export const masterPokemonData = {
  "count": 1154,
  "next": null,
  "previous": null,
  "results": [
    {
      "name": "bulbasaur",
      "url": "https://pokeapi.co/api/v2/pokemon/1/"
    },
    {
      "name": "ivysaur",
      "url": "https://pokeapi.co/api/v2/pokemon/2/"
    },
    {
      "name": "venusaur",
      "url": "https://pokeapi.co/api/v2/pokemon/3/"
    },
    {
      "name": "charmander",
      "url": "https://pokeapi.co/api/v2/pokemon/4/"
    },
    {
      "name": "charmeleon",
      "url": "https://pokeapi.co/api/v2/pokemon/5/"
    },
    {
      "name": "charizard",
      "url": "https://pokeapi.co/api/v2/pokemon/6/"
    },
    {
      "name": "squirtle",
      "url": "https://pokeapi.co/api/v2/pokemon/7/"
    },
    {
      "name": "wartortle",
      "url": "https://pokeapi.co/api/v2/pokemon/8/"
    },
    {
      "name": "blastoise",
      "url": "https://pokeapi.co/api/v2/pokemon/9/"
    },
    {
      "name": "caterpie",
      "url": "https://pokeapi.co/api/v2/pokemon/10/"
    },
    {
      "name": "metapod",
      "url": "https://pokeapi.co/api/v2/pokemon/11/"
    },
    {
      "name": "butterfree",
      "url": "https://pokeapi.co/api/v2/pokemon/12/"
    },
    {
      "name": "weedle",
      "url": "https://pokeapi.co/api/v2/pokemon/13/"
    },
    {
      "name": "kakuna",
      "url": "https://pokeapi.co/api/v2/pokemon/14/"
    },
    {
      "name": "beedrill",
      "url": "https://pokeapi.co/api/v2/pokemon/15/"
    },
    {
      "name": "pidgey",
      "url": "https://pokeapi.co/api/v2/pokemon/16/"
    },
    {
      "name": "pidgeotto",
      "url": "https://pokeapi.co/api/v2/pokemon/17/"
    },
    {
      "name": "pidgeot",
      "url": "https://pokeapi.co/api/v2/pokemon/18/"
    },
    {
      "name": "rattata",
      "url": "https://pokeapi.co/api/v2/pokemon/19/"
    },
    {
      "name": "raticate",
      "url": "https://pokeapi.co/api/v2/pokemon/20/"
    },
    {
      "name": "spearow",
      "url": "https://pokeapi.co/api/v2/pokemon/21/"
    },
    {
      "name": "fearow",
      "url": "https://pokeapi.co/api/v2/pokemon/22/"
    },
    {
      "name": "ekans",
      "url": "https://pokeapi.co/api/v2/pokemon/23/"
    },
    {
      "name": "arbok",
      "url": "https://pokeapi.co/api/v2/pokemon/24/"
    },
    {
      "name": "pikachu",
      "url": "https://pokeapi.co/api/v2/pokemon/25/"
    },
    {
      "name": "raichu",
      "url": "https://pokeapi.co/api/v2/pokemon/26/"
    },
    {
      "name": "sandshrew",
      "url": "https://pokeapi.co/api/v2/pokemon/27/"
    },
    {
      "name": "sandslash",
      "url": "https://pokeapi.co/api/v2/pokemon/28/"
    },
    {
      "name": "nidoran-f",
      "url": "https://pokeapi.co/api/v2/pokemon/29/"
    },
    {
      "name": "nidorina",
      "url": "https://pokeapi.co/api/v2/pokemon/30/"
    },
    {
      "name": "nidoqueen",
      "url": "https://pokeapi.co/api/v2/pokemon/31/"
    },
    {
      "name": "nidoran-m",
      "url": "https://pokeapi.co/api/v2/pokemon/32/"
    },
    {
      "name": "nidorino",
      "url": "https://pokeapi.co/api/v2/pokemon/33/"
    },
    {
      "name": "nidoking",
      "url": "https://pokeapi.co/api/v2/pokemon/34/"
    },
    {
      "name": "clefairy",
      "url": "https://pokeapi.co/api/v2/pokemon/35/"
    },
    {
      "name": "clefable",
      "url": "https://pokeapi.co/api/v2/pokemon/36/"
    },
    {
      "name": "vulpix",
      "url": "https://pokeapi.co/api/v2/pokemon/37/"
    },
    {
      "name": "ninetales",
      "url": "https://pokeapi.co/api/v2/pokemon/38/"
    },
    {
      "name": "jigglypuff",
      "url": "https://pokeapi.co/api/v2/pokemon/39/"
    },
    {
      "name": "wigglytuff",
      "url": "https://pokeapi.co/api/v2/pokemon/40/"
    },
    {
      "name": "zubat",
      "url": "https://pokeapi.co/api/v2/pokemon/41/"
    },
    {
      "name": "golbat",
      "url": "https://pokeapi.co/api/v2/pokemon/42/"
    },
    {
      "name": "oddish",
      "url": "https://pokeapi.co/api/v2/pokemon/43/"
    },
    {
      "name": "gloom",
      "url": "https://pokeapi.co/api/v2/pokemon/44/"
    },
    {
      "name": "vileplume",
      "url": "https://pokeapi.co/api/v2/pokemon/45/"
    },
    {
      "name": "paras",
      "url": "https://pokeapi.co/api/v2/pokemon/46/"
    },
    {
      "name": "parasect",
      "url": "https://pokeapi.co/api/v2/pokemon/47/"
    },
    {
      "name": "venonat",
      "url": "https://pokeapi.co/api/v2/pokemon/48/"
    },
    {
      "name": "venomoth",
      "url": "https://pokeapi.co/api/v2/pokemon/49/"
    },
    {
      "name": "diglett",
      "url": "https://pokeapi.co/api/v2/pokemon/50/"
    },
    {
      "name": "dugtrio",
      "url": "https://pokeapi.co/api/v2/pokemon/51/"
    },
    {
      "name": "meowth",
      "url": "https://pokeapi.co/api/v2/pokemon/52/"
    },
    {
      "name": "persian",
      "url": "https://pokeapi.co/api/v2/pokemon/53/"
    },
    {
      "name": "psyduck",
      "url": "https://pokeapi.co/api/v2/pokemon/54/"
    },
    {
      "name": "golduck",
      "url": "https://pokeapi.co/api/v2/pokemon/55/"
    },
    {
      "name": "mankey",
      "url": "https://pokeapi.co/api/v2/pokemon/56/"
    },
    {
      "name": "primeape",
      "url": "https://pokeapi.co/api/v2/pokemon/57/"
    },
    {
      "name": "growlithe",
      "url": "https://pokeapi.co/api/v2/pokemon/58/"
    },
    {
      "name": "arcanine",
      "url": "https://pokeapi.co/api/v2/pokemon/59/"
    },
    {
      "name": "poliwag",
      "url": "https://pokeapi.co/api/v2/pokemon/60/"
    },
    {
      "name": "poliwhirl",
      "url": "https://pokeapi.co/api/v2/pokemon/61/"
    },
    {
      "name": "poliwrath",
      "url": "https://pokeapi.co/api/v2/pokemon/62/"
    },
    {
      "name": "abra",
      "url": "https://pokeapi.co/api/v2/pokemon/63/"
    },
    {
      "name": "kadabra",
      "url": "https://pokeapi.co/api/v2/pokemon/64/"
    },
    {
      "name": "alakazam",
      "url": "https://pokeapi.co/api/v2/pokemon/65/"
    },
    {
      "name": "machop",
      "url": "https://pokeapi.co/api/v2/pokemon/66/"
    },
    {
      "name": "machoke",
      "url": "https://pokeapi.co/api/v2/pokemon/67/"
    },
    {
      "name": "machamp",
      "url": "https://pokeapi.co/api/v2/pokemon/68/"
    },
    {
      "name": "bellsprout",
      "url": "https://pokeapi.co/api/v2/pokemon/69/"
    },
    {
      "name": "weepinbell",
      "url": "https://pokeapi.co/api/v2/pokemon/70/"
    },
    {
      "name": "victreebel",
      "url": "https://pokeapi.co/api/v2/pokemon/71/"
    },
    {
      "name": "tentacool",
      "url": "https://pokeapi.co/api/v2/pokemon/72/"
    },
    {
      "name": "tentacruel",
      "url": "https://pokeapi.co/api/v2/pokemon/73/"
    },
    {
      "name": "geodude",
      "url": "https://pokeapi.co/api/v2/pokemon/74/"
    },
    {
      "name": "graveler",
      "url": "https://pokeapi.co/api/v2/pokemon/75/"
    },
    {
      "name": "golem",
      "url": "https://pokeapi.co/api/v2/pokemon/76/"
    },
    {
      "name": "ponyta",
      "url": "https://pokeapi.co/api/v2/pokemon/77/"
    },
    {
      "name": "rapidash",
      "url": "https://pokeapi.co/api/v2/pokemon/78/"
    },
    {
      "name": "slowpoke",
      "url": "https://pokeapi.co/api/v2/pokemon/79/"
    },
    {
      "name": "slowbro",
      "url": "https://pokeapi.co/api/v2/pokemon/80/"
    },
    {
      "name": "magnemite",
      "url": "https://pokeapi.co/api/v2/pokemon/81/"
    },
    {
      "name": "magneton",
      "url": "https://pokeapi.co/api/v2/pokemon/82/"
    },
    {
      "name": "farfetchd",
      "url": "https://pokeapi.co/api/v2/pokemon/83/"
    },
    {
      "name": "doduo",
      "url": "https://pokeapi.co/api/v2/pokemon/84/"
    },
    {
      "name": "dodrio",
      "url": "https://pokeapi.co/api/v2/pokemon/85/"
    },
    {
      "name": "seel",
      "url": "https://pokeapi.co/api/v2/pokemon/86/"
    },
    {
      "name": "dewgong",
      "url": "https://pokeapi.co/api/v2/pokemon/87/"
    },
    {
      "name": "grimer",
      "url": "https://pokeapi.co/api/v2/pokemon/88/"
    },
    {
      "name": "muk",
      "url": "https://pokeapi.co/api/v2/pokemon/89/"
    },
    {
      "name": "shellder",
      "url": "https://pokeapi.co/api/v2/pokemon/90/"
    },
    {
      "name": "cloyster",
      "url": "https://pokeapi.co/api/v2/pokemon/91/"
    },
    {
      "name": "gastly",
      "url": "https://pokeapi.co/api/v2/pokemon/92/"
    },
    {
      "name": "haunter",
      "url": "https://pokeapi.co/api/v2/pokemon/93/"
    },
    {
      "name": "gengar",
      "url": "https://pokeapi.co/api/v2/pokemon/94/"
    },
    {
      "name": "onix",
      "url": "https://pokeapi.co/api/v2/pokemon/95/"
    },
    {
      "name": "drowzee",
      "url": "https://pokeapi.co/api/v2/pokemon/96/"
    },
    {
      "name": "hypno",
      "url": "https://pokeapi.co/api/v2/pokemon/97/"
    },
    {
      "name": "krabby",
      "url": "https://pokeapi.co/api/v2/pokemon/98/"
    },
    {
      "name": "kingler",
      "url": "https://pokeapi.co/api/v2/pokemon/99/"
    },
    {
      "name": "voltorb",
      "url": "https://pokeapi.co/api/v2/pokemon/100/"
    },
    {
      "name": "electrode",
      "url": "https://pokeapi.co/api/v2/pokemon/101/"
    },
    {
      "name": "exeggcute",
      "url": "https://pokeapi.co/api/v2/pokemon/102/"
    },
    {
      "name": "exeggutor",
      "url": "https://pokeapi.co/api/v2/pokemon/103/"
    },
    {
      "name": "cubone",
      "url": "https://pokeapi.co/api/v2/pokemon/104/"
    },
    {
      "name": "marowak",
      "url": "https://pokeapi.co/api/v2/pokemon/105/"
    },
    {
      "name": "hitmonlee",
      "url": "https://pokeapi.co/api/v2/pokemon/106/"
    },
    {
      "name": "hitmonchan",
      "url": "https://pokeapi.co/api/v2/pokemon/107/"
    },
    {
      "name": "lickitung",
      "url": "https://pokeapi.co/api/v2/pokemon/108/"
    },
    {
      "name": "koffing",
      "url": "https://pokeapi.co/api/v2/pokemon/109/"
    },
    {
      "name": "weezing",
      "url": "https://pokeapi.co/api/v2/pokemon/110/"
    },
    {
      "name": "rhyhorn",
      "url": "https://pokeapi.co/api/v2/pokemon/111/"
    },
    {
      "name": "rhydon",
      "url": "https://pokeapi.co/api/v2/pokemon/112/"
    },
    {
      "name": "chansey",
      "url": "https://pokeapi.co/api/v2/pokemon/113/"
    },
    {
      "name": "tangela",
      "url": "https://pokeapi.co/api/v2/pokemon/114/"
    },
    {
      "name": "kangaskhan",
      "url": "https://pokeapi.co/api/v2/pokemon/115/"
    },
    {
      "name": "horsea",
      "url": "https://pokeapi.co/api/v2/pokemon/116/"
    },
    {
      "name": "seadra",
      "url": "https://pokeapi.co/api/v2/pokemon/117/"
    },
    {
      "name": "goldeen",
      "url": "https://pokeapi.co/api/v2/pokemon/118/"
    },
    {
      "name": "seaking",
      "url": "https://pokeapi.co/api/v2/pokemon/119/"
    },
    {
      "name": "staryu",
      "url": "https://pokeapi.co/api/v2/pokemon/120/"
    },
    {
      "name": "starmie",
      "url": "https://pokeapi.co/api/v2/pokemon/121/"
    },
    {
      "name": "mr-mime",
      "url": "https://pokeapi.co/api/v2/pokemon/122/"
    },
    {
      "name": "scyther",
      "url": "https://pokeapi.co/api/v2/pokemon/123/"
    },
    {
      "name": "jynx",
      "url": "https://pokeapi.co/api/v2/pokemon/124/"
    },
    {
      "name": "electabuzz",
      "url": "https://pokeapi.co/api/v2/pokemon/125/"
    },
    {
      "name": "magmar",
      "url": "https://pokeapi.co/api/v2/pokemon/126/"
    },
    {
      "name": "pinsir",
      "url": "https://pokeapi.co/api/v2/pokemon/127/"
    },
    {
      "name": "tauros",
      "url": "https://pokeapi.co/api/v2/pokemon/128/"
    },
    {
      "name": "magikarp",
      "url": "https://pokeapi.co/api/v2/pokemon/129/"
    },
    {
      "name": "gyarados",
      "url": "https://pokeapi.co/api/v2/pokemon/130/"
    },
    {
      "name": "lapras",
      "url": "https://pokeapi.co/api/v2/pokemon/131/"
    },
    {
      "name": "ditto",
      "url": "https://pokeapi.co/api/v2/pokemon/132/"
    },
    {
      "name": "eevee",
      "url": "https://pokeapi.co/api/v2/pokemon/133/"
    },
    {
      "name": "vaporeon",
      "url": "https://pokeapi.co/api/v2/pokemon/134/"
    },
    {
      "name": "jolteon",
      "url": "https://pokeapi.co/api/v2/pokemon/135/"
    },
    {
      "name": "flareon",
      "url": "https://pokeapi.co/api/v2/pokemon/136/"
    },
    {
      "name": "porygon",
      "url": "https://pokeapi.co/api/v2/pokemon/137/"
    },
    {
      "name": "omanyte",
      "url": "https://pokeapi.co/api/v2/pokemon/138/"
    },
    {
      "name": "omastar",
      "url": "https://pokeapi.co/api/v2/pokemon/139/"
    },
    {
      "name": "kabuto",
      "url": "https://pokeapi.co/api/v2/pokemon/140/"
    },
    {
      "name": "kabutops",
      "url": "https://pokeapi.co/api/v2/pokemon/141/"
    },
    {
      "name": "aerodactyl",
      "url": "https://pokeapi.co/api/v2/pokemon/142/"
    },
    {
      "name": "snorlax",
      "url": "https://pokeapi.co/api/v2/pokemon/143/"
    },
    {
      "name": "articuno",
      "url": "https://pokeapi.co/api/v2/pokemon/144/"
    },
    {
      "name": "zapdos",
      "url": "https://pokeapi.co/api/v2/pokemon/145/"
    },
    {
      "name": "moltres",
      "url": "https://pokeapi.co/api/v2/pokemon/146/"
    },
    {
      "name": "dratini",
      "url": "https://pokeapi.co/api/v2/pokemon/147/"
    },
    {
      "name": "dragonair",
      "url": "https://pokeapi.co/api/v2/pokemon/148/"
    },
    {
      "name": "dragonite",
      "url": "https://pokeapi.co/api/v2/pokemon/149/"
    },
    {
      "name": "mewtwo",
      "url": "https://pokeapi.co/api/v2/pokemon/150/"
    },
    {
      "name": "mew",
      "url": "https://pokeapi.co/api/v2/pokemon/151/"
    },
    {
      "name": "chikorita",
      "url": "https://pokeapi.co/api/v2/pokemon/152/"
    },
    {
      "name": "bayleef",
      "url": "https://pokeapi.co/api/v2/pokemon/153/"
    },
    {
      "name": "meganium",
      "url": "https://pokeapi.co/api/v2/pokemon/154/"
    },
    {
      "name": "cyndaquil",
      "url": "https://pokeapi.co/api/v2/pokemon/155/"
    },
    {
      "name": "quilava",
      "url": "https://pokeapi.co/api/v2/pokemon/156/"
    },
    {
      "name": "typhlosion",
      "url": "https://pokeapi.co/api/v2/pokemon/157/"
    },
    {
      "name": "totodile",
      "url": "https://pokeapi.co/api/v2/pokemon/158/"
    },
    {
      "name": "croconaw",
      "url": "https://pokeapi.co/api/v2/pokemon/159/"
    },
    {
      "name": "feraligatr",
      "url": "https://pokeapi.co/api/v2/pokemon/160/"
    },
    {
      "name": "sentret",
      "url": "https://pokeapi.co/api/v2/pokemon/161/"
    },
    {
      "name": "furret",
      "url": "https://pokeapi.co/api/v2/pokemon/162/"
    },
    {
      "name": "hoothoot",
      "url": "https://pokeapi.co/api/v2/pokemon/163/"
    },
    {
      "name": "noctowl",
      "url": "https://pokeapi.co/api/v2/pokemon/164/"
    },
    {
      "name": "ledyba",
      "url": "https://pokeapi.co/api/v2/pokemon/165/"
    },
    {
      "name": "ledian",
      "url": "https://pokeapi.co/api/v2/pokemon/166/"
    },
    {
      "name": "spinarak",
      "url": "https://pokeapi.co/api/v2/pokemon/167/"
    },
    {
      "name": "ariados",
      "url": "https://pokeapi.co/api/v2/pokemon/168/"
    },
    {
      "name": "crobat",
      "url": "https://pokeapi.co/api/v2/pokemon/169/"
    },
    {
      "name": "chinchou",
      "url": "https://pokeapi.co/api/v2/pokemon/170/"
    },
    {
      "name": "lanturn",
      "url": "https://pokeapi.co/api/v2/pokemon/171/"
    },
    {
      "name": "pichu",
      "url": "https://pokeapi.co/api/v2/pokemon/172/"
    },
    {
      "name": "cleffa",
      "url": "https://pokeapi.co/api/v2/pokemon/173/"
    },
    {
      "name": "igglybuff",
      "url": "https://pokeapi.co/api/v2/pokemon/174/"
    },
    {
      "name": "togepi",
      "url": "https://pokeapi.co/api/v2/pokemon/175/"
    },
    {
      "name": "togetic",
      "url": "https://pokeapi.co/api/v2/pokemon/176/"
    },
    {
      "name": "natu",
      "url": "https://pokeapi.co/api/v2/pokemon/177/"
    },
    {
      "name": "xatu",
      "url": "https://pokeapi.co/api/v2/pokemon/178/"
    },
    {
      "name": "mareep",
      "url": "https://pokeapi.co/api/v2/pokemon/179/"
    },
    {
      "name": "flaaffy",
      "url": "https://pokeapi.co/api/v2/pokemon/180/"
    },
    {
      "name": "ampharos",
      "url": "https://pokeapi.co/api/v2/pokemon/181/"
    },
    {
      "name": "bellossom",
      "url": "https://pokeapi.co/api/v2/pokemon/182/"
    },
    {
      "name": "marill",
      "url": "https://pokeapi.co/api/v2/pokemon/183/"
    },
    {
      "name": "azumarill",
      "url": "https://pokeapi.co/api/v2/pokemon/184/"
    },
    {
      "name": "sudowoodo",
      "url": "https://pokeapi.co/api/v2/pokemon/185/"
    },
    {
      "name": "politoed",
      "url": "https://pokeapi.co/api/v2/pokemon/186/"
    },
    {
      "name": "hoppip",
      "url": "https://pokeapi.co/api/v2/pokemon/187/"
    },
    {
      "name": "skiploom",
      "url": "https://pokeapi.co/api/v2/pokemon/188/"
    },
    {
      "name": "jumpluff",
      "url": "https://pokeapi.co/api/v2/pokemon/189/"
    },
    {
      "name": "aipom",
      "url": "https://pokeapi.co/api/v2/pokemon/190/"
    },
    {
      "name": "sunkern",
      "url": "https://pokeapi.co/api/v2/pokemon/191/"
    },
    {
      "name": "sunflora",
      "url": "https://pokeapi.co/api/v2/pokemon/192/"
    },
    {
      "name": "yanma",
      "url": "https://pokeapi.co/api/v2/pokemon/193/"
    },
    {
      "name": "wooper",
      "url": "https://pokeapi.co/api/v2/pokemon/194/"
    },
    {
      "name": "quagsire",
      "url": "https://pokeapi.co/api/v2/pokemon/195/"
    },
    {
      "name": "espeon",
      "url": "https://pokeapi.co/api/v2/pokemon/196/"
    },
    {
      "name": "umbreon",
      "url": "https://pokeapi.co/api/v2/pokemon/197/"
    },
    {
      "name": "murkrow",
      "url": "https://pokeapi.co/api/v2/pokemon/198/"
    },
    {
      "name": "slowking",
      "url": "https://pokeapi.co/api/v2/pokemon/199/"
    },
    {
      "name": "misdreavus",
      "url": "https://pokeapi.co/api/v2/pokemon/200/"
    },
    {
      "name": "unown",
      "url": "https://pokeapi.co/api/v2/pokemon/201/"
    },
    {
      "name": "wobbuffet",
      "url": "https://pokeapi.co/api/v2/pokemon/202/"
    },
    {
      "name": "girafarig",
      "url": "https://pokeapi.co/api/v2/pokemon/203/"
    },
    {
      "name": "pineco",
      "url": "https://pokeapi.co/api/v2/pokemon/204/"
    },
    {
      "name": "forretress",
      "url": "https://pokeapi.co/api/v2/pokemon/205/"
    },
    {
      "name": "dunsparce",
      "url": "https://pokeapi.co/api/v2/pokemon/206/"
    },
    {
      "name": "gligar",
      "url": "https://pokeapi.co/api/v2/pokemon/207/"
    },
    {
      "name": "steelix",
      "url": "https://pokeapi.co/api/v2/pokemon/208/"
    },
    {
      "name": "snubbull",
      "url": "https://pokeapi.co/api/v2/pokemon/209/"
    },
    {
      "name": "granbull",
      "url": "https://pokeapi.co/api/v2/pokemon/210/"
    },
    {
      "name": "qwilfish",
      "url": "https://pokeapi.co/api/v2/pokemon/211/"
    },
    {
      "name": "scizor",
      "url": "https://pokeapi.co/api/v2/pokemon/212/"
    },
    {
      "name": "shuckle",
      "url": "https://pokeapi.co/api/v2/pokemon/213/"
    },
    {
      "name": "heracross",
      "url": "https://pokeapi.co/api/v2/pokemon/214/"
    },
    {
      "name": "sneasel",
      "url": "https://pokeapi.co/api/v2/pokemon/215/"
    },
    {
      "name": "teddiursa",
      "url": "https://pokeapi.co/api/v2/pokemon/216/"
    },
    {
      "name": "ursaring",
      "url": "https://pokeapi.co/api/v2/pokemon/217/"
    },
    {
      "name": "slugma",
      "url": "https://pokeapi.co/api/v2/pokemon/218/"
    },
    {
      "name": "magcargo",
      "url": "https://pokeapi.co/api/v2/pokemon/219/"
    },
    {
      "name": "swinub",
      "url": "https://pokeapi.co/api/v2/pokemon/220/"
    },
    {
      "name": "piloswine",
      "url": "https://pokeapi.co/api/v2/pokemon/221/"
    },
    {
      "name": "corsola",
      "url": "https://pokeapi.co/api/v2/pokemon/222/"
    },
    {
      "name": "remoraid",
      "url": "https://pokeapi.co/api/v2/pokemon/223/"
    },
    {
      "name": "octillery",
      "url": "https://pokeapi.co/api/v2/pokemon/224/"
    },
    {
      "name": "delibird",
      "url": "https://pokeapi.co/api/v2/pokemon/225/"
    },
    {
      "name": "mantine",
      "url": "https://pokeapi.co/api/v2/pokemon/226/"
    },
    {
      "name": "skarmory",
      "url": "https://pokeapi.co/api/v2/pokemon/227/"
    },
    {
      "name": "houndour",
      "url": "https://pokeapi.co/api/v2/pokemon/228/"
    },
    {
      "name": "houndoom",
      "url": "https://pokeapi.co/api/v2/pokemon/229/"
    },
    {
      "name": "kingdra",
      "url": "https://pokeapi.co/api/v2/pokemon/230/"
    },
    {
      "name": "phanpy",
      "url": "https://pokeapi.co/api/v2/pokemon/231/"
    },
    {
      "name": "donphan",
      "url": "https://pokeapi.co/api/v2/pokemon/232/"
    },
    {
      "name": "porygon2",
      "url": "https://pokeapi.co/api/v2/pokemon/233/"
    },
    {
      "name": "stantler",
      "url": "https://pokeapi.co/api/v2/pokemon/234/"
    },
    {
      "name": "smeargle",
      "url": "https://pokeapi.co/api/v2/pokemon/235/"
    },
    {
      "name": "tyrogue",
      "url": "https://pokeapi.co/api/v2/pokemon/236/"
    },
    {
      "name": "hitmontop",
      "url": "https://pokeapi.co/api/v2/pokemon/237/"
    },
    {
      "name": "smoochum",
      "url": "https://pokeapi.co/api/v2/pokemon/238/"
    },
    {
      "name": "elekid",
      "url": "https://pokeapi.co/api/v2/pokemon/239/"
    },
    {
      "name": "magby",
      "url": "https://pokeapi.co/api/v2/pokemon/240/"
    },
    {
      "name": "miltank",
      "url": "https://pokeapi.co/api/v2/pokemon/241/"
    },
    {
      "name": "blissey",
      "url": "https://pokeapi.co/api/v2/pokemon/242/"
    },
    {
      "name": "raikou",
      "url": "https://pokeapi.co/api/v2/pokemon/243/"
    },
    {
      "name": "entei",
      "url": "https://pokeapi.co/api/v2/pokemon/244/"
    },
    {
      "name": "suicune",
      "url": "https://pokeapi.co/api/v2/pokemon/245/"
    },
    {
      "name": "larvitar",
      "url": "https://pokeapi.co/api/v2/pokemon/246/"
    },
    {
      "name": "pupitar",
      "url": "https://pokeapi.co/api/v2/pokemon/247/"
    },
    {
      "name": "tyranitar",
      "url": "https://pokeapi.co/api/v2/pokemon/248/"
    },
    {
      "name": "lugia",
      "url": "https://pokeapi.co/api/v2/pokemon/249/"
    },
    {
      "name": "ho-oh",
      "url": "https://pokeapi.co/api/v2/pokemon/250/"
    },
    {
      "name": "celebi",
      "url": "https://pokeapi.co/api/v2/pokemon/251/"
    },
    {
      "name": "treecko",
      "url": "https://pokeapi.co/api/v2/pokemon/252/"
    },
    {
      "name": "grovyle",
      "url": "https://pokeapi.co/api/v2/pokemon/253/"
    },
    {
      "name": "sceptile",
      "url": "https://pokeapi.co/api/v2/pokemon/254/"
    },
    {
      "name": "torchic",
      "url": "https://pokeapi.co/api/v2/pokemon/255/"
    },
    {
      "name": "combusken",
      "url": "https://pokeapi.co/api/v2/pokemon/256/"
    },
    {
      "name": "blaziken",
      "url": "https://pokeapi.co/api/v2/pokemon/257/"
    },
    {
      "name": "mudkip",
      "url": "https://pokeapi.co/api/v2/pokemon/258/"
    },
    {
      "name": "marshtomp",
      "url": "https://pokeapi.co/api/v2/pokemon/259/"
    },
    {
      "name": "swampert",
      "url": "https://pokeapi.co/api/v2/pokemon/260/"
    },
    {
      "name": "poochyena",
      "url": "https://pokeapi.co/api/v2/pokemon/261/"
    },
    {
      "name": "mightyena",
      "url": "https://pokeapi.co/api/v2/pokemon/262/"
    },
    {
      "name": "zigzagoon",
      "url": "https://pokeapi.co/api/v2/pokemon/263/"
    },
    {
      "name": "linoone",
      "url": "https://pokeapi.co/api/v2/pokemon/264/"
    },
    {
      "name": "wurmple",
      "url": "https://pokeapi.co/api/v2/pokemon/265/"
    },
    {
      "name": "silcoon",
      "url": "https://pokeapi.co/api/v2/pokemon/266/"
    },
    {
      "name": "beautifly",
      "url": "https://pokeapi.co/api/v2/pokemon/267/"
    },
    {
      "name": "cascoon",
      "url": "https://pokeapi.co/api/v2/pokemon/268/"
    },
    {
      "name": "dustox",
      "url": "https://pokeapi.co/api/v2/pokemon/269/"
    },
    {
      "name": "lotad",
      "url": "https://pokeapi.co/api/v2/pokemon/270/"
    },
    {
      "name": "lombre",
      "url": "https://pokeapi.co/api/v2/pokemon/271/"
    },
    {
      "name": "ludicolo",
      "url": "https://pokeapi.co/api/v2/pokemon/272/"
    },
    {
      "name": "seedot",
      "url": "https://pokeapi.co/api/v2/pokemon/273/"
    },
    {
      "name": "nuzleaf",
      "url": "https://pokeapi.co/api/v2/pokemon/274/"
    },
    {
      "name": "shiftry",
      "url": "https://pokeapi.co/api/v2/pokemon/275/"
    },
    {
      "name": "taillow",
      "url": "https://pokeapi.co/api/v2/pokemon/276/"
    },
    {
      "name": "swellow",
      "url": "https://pokeapi.co/api/v2/pokemon/277/"
    },
    {
      "name": "wingull",
      "url": "https://pokeapi.co/api/v2/pokemon/278/"
    },
    {
      "name": "pelipper",
      "url": "https://pokeapi.co/api/v2/pokemon/279/"
    },
    {
      "name": "ralts",
      "url": "https://pokeapi.co/api/v2/pokemon/280/"
    },
    {
      "name": "kirlia",
      "url": "https://pokeapi.co/api/v2/pokemon/281/"
    },
    {
      "name": "gardevoir",
      "url": "https://pokeapi.co/api/v2/pokemon/282/"
    },
    {
      "name": "surskit",
      "url": "https://pokeapi.co/api/v2/pokemon/283/"
    },
    {
      "name": "masquerain",
      "url": "https://pokeapi.co/api/v2/pokemon/284/"
    },
    {
      "name": "shroomish",
      "url": "https://pokeapi.co/api/v2/pokemon/285/"
    },
    {
      "name": "breloom",
      "url": "https://pokeapi.co/api/v2/pokemon/286/"
    },
    {
      "name": "slakoth",
      "url": "https://pokeapi.co/api/v2/pokemon/287/"
    },
    {
      "name": "vigoroth",
      "url": "https://pokeapi.co/api/v2/pokemon/288/"
    },
    {
      "name": "slaking",
      "url": "https://pokeapi.co/api/v2/pokemon/289/"
    },
    {
      "name": "nincada",
      "url": "https://pokeapi.co/api/v2/pokemon/290/"
    },
    {
      "name": "ninjask",
      "url": "https://pokeapi.co/api/v2/pokemon/291/"
    },
    {
      "name": "shedinja",
      "url": "https://pokeapi.co/api/v2/pokemon/292/"
    },
    {
      "name": "whismur",
      "url": "https://pokeapi.co/api/v2/pokemon/293/"
    },
    {
      "name": "loudred",
      "url": "https://pokeapi.co/api/v2/pokemon/294/"
    },
    {
      "name": "exploud",
      "url": "https://pokeapi.co/api/v2/pokemon/295/"
    },
    {
      "name": "makuhita",
      "url": "https://pokeapi.co/api/v2/pokemon/296/"
    },
    {
      "name": "hariyama",
      "url": "https://pokeapi.co/api/v2/pokemon/297/"
    },
    {
      "name": "azurill",
      "url": "https://pokeapi.co/api/v2/pokemon/298/"
    },
    {
      "name": "nosepass",
      "url": "https://pokeapi.co/api/v2/pokemon/299/"
    },
    {
      "name": "skitty",
      "url": "https://pokeapi.co/api/v2/pokemon/300/"
    },
    {
      "name": "delcatty",
      "url": "https://pokeapi.co/api/v2/pokemon/301/"
    },
    {
      "name": "sableye",
      "url": "https://pokeapi.co/api/v2/pokemon/302/"
    },
    {
      "name": "mawile",
      "url": "https://pokeapi.co/api/v2/pokemon/303/"
    },
    {
      "name": "aron",
      "url": "https://pokeapi.co/api/v2/pokemon/304/"
    },
    {
      "name": "lairon",
      "url": "https://pokeapi.co/api/v2/pokemon/305/"
    },
    {
      "name": "aggron",
      "url": "https://pokeapi.co/api/v2/pokemon/306/"
    },
    {
      "name": "meditite",
      "url": "https://pokeapi.co/api/v2/pokemon/307/"
    },
    {
      "name": "medicham",
      "url": "https://pokeapi.co/api/v2/pokemon/308/"
    },
    {
      "name": "electrike",
      "url": "https://pokeapi.co/api/v2/pokemon/309/"
    },
    {
      "name": "manectric",
      "url": "https://pokeapi.co/api/v2/pokemon/310/"
    },
    {
      "name": "plusle",
      "url": "https://pokeapi.co/api/v2/pokemon/311/"
    },
    {
      "name": "minun",
      "url": "https://pokeapi.co/api/v2/pokemon/312/"
    },
    {
      "name": "volbeat",
      "url": "https://pokeapi.co/api/v2/pokemon/313/"
    },
    {
      "name": "illumise",
      "url": "https://pokeapi.co/api/v2/pokemon/314/"
    },
    {
      "name": "roselia",
      "url": "https://pokeapi.co/api/v2/pokemon/315/"
    },
    {
      "name": "gulpin",
      "url": "https://pokeapi.co/api/v2/pokemon/316/"
    },
    {
      "name": "swalot",
      "url": "https://pokeapi.co/api/v2/pokemon/317/"
    },
    {
      "name": "carvanha",
      "url": "https://pokeapi.co/api/v2/pokemon/318/"
    },
    {
      "name": "sharpedo",
      "url": "https://pokeapi.co/api/v2/pokemon/319/"
    },
    {
      "name": "wailmer",
      "url": "https://pokeapi.co/api/v2/pokemon/320/"
    },
    {
      "name": "wailord",
      "url": "https://pokeapi.co/api/v2/pokemon/321/"
    },
    {
      "name": "numel",
      "url": "https://pokeapi.co/api/v2/pokemon/322/"
    },
    {
      "name": "camerupt",
      "url": "https://pokeapi.co/api/v2/pokemon/323/"
    },
    {
      "name": "torkoal",
      "url": "https://pokeapi.co/api/v2/pokemon/324/"
    },
    {
      "name": "spoink",
      "url": "https://pokeapi.co/api/v2/pokemon/325/"
    },
    {
      "name": "grumpig",
      "url": "https://pokeapi.co/api/v2/pokemon/326/"
    },
    {
      "name": "spinda",
      "url": "https://pokeapi.co/api/v2/pokemon/327/"
    },
    {
      "name": "trapinch",
      "url": "https://pokeapi.co/api/v2/pokemon/328/"
    },
    {
      "name": "vibrava",
      "url": "https://pokeapi.co/api/v2/pokemon/329/"
    },
    {
      "name": "flygon",
      "url": "https://pokeapi.co/api/v2/pokemon/330/"
    },
    {
      "name": "cacnea",
      "url": "https://pokeapi.co/api/v2/pokemon/331/"
    },
    {
      "name": "cacturne",
      "url": "https://pokeapi.co/api/v2/pokemon/332/"
    },
    {
      "name": "swablu",
      "url": "https://pokeapi.co/api/v2/pokemon/333/"
    },
    {
      "name": "altaria",
      "url": "https://pokeapi.co/api/v2/pokemon/334/"
    },
    {
      "name": "zangoose",
      "url": "https://pokeapi.co/api/v2/pokemon/335/"
    },
    {
      "name": "seviper",
      "url": "https://pokeapi.co/api/v2/pokemon/336/"
    },
    {
      "name": "lunatone",
      "url": "https://pokeapi.co/api/v2/pokemon/337/"
    },
    {
      "name": "solrock",
      "url": "https://pokeapi.co/api/v2/pokemon/338/"
    },
    {
      "name": "barboach",
      "url": "https://pokeapi.co/api/v2/pokemon/339/"
    },
    {
      "name": "whiscash",
      "url": "https://pokeapi.co/api/v2/pokemon/340/"
    },
    {
      "name": "corphish",
      "url": "https://pokeapi.co/api/v2/pokemon/341/"
    },
    {
      "name": "crawdaunt",
      "url": "https://pokeapi.co/api/v2/pokemon/342/"
    },
    {
      "name": "baltoy",
      "url": "https://pokeapi.co/api/v2/pokemon/343/"
    },
    {
      "name": "claydol",
      "url": "https://pokeapi.co/api/v2/pokemon/344/"
    },
    {
      "name": "lileep",
      "url": "https://pokeapi.co/api/v2/pokemon/345/"
    },
    {
      "name": "cradily",
      "url": "https://pokeapi.co/api/v2/pokemon/346/"
    },
    {
      "name": "anorith",
      "url": "https://pokeapi.co/api/v2/pokemon/347/"
    },
    {
      "name": "armaldo",
      "url": "https://pokeapi.co/api/v2/pokemon/348/"
    },
    {
      "name": "feebas",
      "url": "https://pokeapi.co/api/v2/pokemon/349/"
    },
    {
      "name": "milotic",
      "url": "https://pokeapi.co/api/v2/pokemon/350/"
    },
    {
      "name": "castform",
      "url": "https://pokeapi.co/api/v2/pokemon/351/"
    },
    {
      "name": "kecleon",
      "url": "https://pokeapi.co/api/v2/pokemon/352/"
    },
    {
      "name": "shuppet",
      "url": "https://pokeapi.co/api/v2/pokemon/353/"
    },
    {
      "name": "banette",
      "url": "https://pokeapi.co/api/v2/pokemon/354/"
    },
    {
      "name": "duskull",
      "url": "https://pokeapi.co/api/v2/pokemon/355/"
    },
    {
      "name": "dusclops",
      "url": "https://pokeapi.co/api/v2/pokemon/356/"
    },
    {
      "name": "tropius",
      "url": "https://pokeapi.co/api/v2/pokemon/357/"
    },
    {
      "name": "chimecho",
      "url": "https://pokeapi.co/api/v2/pokemon/358/"
    },
    {
      "name": "absol",
      "url": "https://pokeapi.co/api/v2/pokemon/359/"
    },
    {
      "name": "wynaut",
      "url": "https://pokeapi.co/api/v2/pokemon/360/"
    },
    {
      "name": "snorunt",
      "url": "https://pokeapi.co/api/v2/pokemon/361/"
    },
    {
      "name": "glalie",
      "url": "https://pokeapi.co/api/v2/pokemon/362/"
    },
    {
      "name": "spheal",
      "url": "https://pokeapi.co/api/v2/pokemon/363/"
    },
    {
      "name": "sealeo",
      "url": "https://pokeapi.co/api/v2/pokemon/364/"
    },
    {
      "name": "walrein",
      "url": "https://pokeapi.co/api/v2/pokemon/365/"
    },
    {
      "name": "clamperl",
      "url": "https://pokeapi.co/api/v2/pokemon/366/"
    },
    {
      "name": "huntail",
      "url": "https://pokeapi.co/api/v2/pokemon/367/"
    },
    {
      "name": "gorebyss",
      "url": "https://pokeapi.co/api/v2/pokemon/368/"
    },
    {
      "name": "relicanth",
      "url": "https://pokeapi.co/api/v2/pokemon/369/"
    },
    {
      "name": "luvdisc",
      "url": "https://pokeapi.co/api/v2/pokemon/370/"
    },
    {
      "name": "bagon",
      "url": "https://pokeapi.co/api/v2/pokemon/371/"
    },
    {
      "name": "shelgon",
      "url": "https://pokeapi.co/api/v2/pokemon/372/"
    },
    {
      "name": "salamence",
      "url": "https://pokeapi.co/api/v2/pokemon/373/"
    },
    {
      "name": "beldum",
      "url": "https://pokeapi.co/api/v2/pokemon/374/"
    },
    {
      "name": "metang",
      "url": "https://pokeapi.co/api/v2/pokemon/375/"
    },
    {
      "name": "metagross",
      "url": "https://pokeapi.co/api/v2/pokemon/376/"
    },
    {
      "name": "regirock",
      "url": "https://pokeapi.co/api/v2/pokemon/377/"
    },
    {
      "name": "regice",
      "url": "https://pokeapi.co/api/v2/pokemon/378/"
    },
    {
      "name": "registeel",
      "url": "https://pokeapi.co/api/v2/pokemon/379/"
    },
    {
      "name": "latias",
      "url": "https://pokeapi.co/api/v2/pokemon/380/"
    },
    {
      "name": "latios",
      "url": "https://pokeapi.co/api/v2/pokemon/381/"
    },
    {
      "name": "kyogre",
      "url": "https://pokeapi.co/api/v2/pokemon/382/"
    },
    {
      "name": "groudon",
      "url": "https://pokeapi.co/api/v2/pokemon/383/"
    },
    {
      "name": "rayquaza",
      "url": "https://pokeapi.co/api/v2/pokemon/384/"
    },
    {
      "name": "jirachi",
      "url": "https://pokeapi.co/api/v2/pokemon/385/"
    },
    {
      "name": "deoxys-normal",
      "url": "https://pokeapi.co/api/v2/pokemon/386/"
    },
    {
      "name": "turtwig",
      "url": "https://pokeapi.co/api/v2/pokemon/387/"
    },
    {
      "name": "grotle",
      "url": "https://pokeapi.co/api/v2/pokemon/388/"
    },
    {
      "name": "torterra",
      "url": "https://pokeapi.co/api/v2/pokemon/389/"
    },
    {
      "name": "chimchar",
      "url": "https://pokeapi.co/api/v2/pokemon/390/"
    },
    {
      "name": "monferno",
      "url": "https://pokeapi.co/api/v2/pokemon/391/"
    },
    {
      "name": "infernape",
      "url": "https://pokeapi.co/api/v2/pokemon/392/"
    },
    {
      "name": "piplup",
      "url": "https://pokeapi.co/api/v2/pokemon/393/"
    },
    {
      "name": "prinplup",
      "url": "https://pokeapi.co/api/v2/pokemon/394/"
    },
    {
      "name": "empoleon",
      "url": "https://pokeapi.co/api/v2/pokemon/395/"
    },
    {
      "name": "starly",
      "url": "https://pokeapi.co/api/v2/pokemon/396/"
    },
    {
      "name": "staravia",
      "url": "https://pokeapi.co/api/v2/pokemon/397/"
    },
    {
      "name": "staraptor",
      "url": "https://pokeapi.co/api/v2/pokemon/398/"
    },
    {
      "name": "bidoof",
      "url": "https://pokeapi.co/api/v2/pokemon/399/"
    },
    {
      "name": "bibarel",
      "url": "https://pokeapi.co/api/v2/pokemon/400/"
    },
    {
      "name": "kricketot",
      "url": "https://pokeapi.co/api/v2/pokemon/401/"
    },
    {
      "name": "kricketune",
      "url": "https://pokeapi.co/api/v2/pokemon/402/"
    },
    {
      "name": "shinx",
      "url": "https://pokeapi.co/api/v2/pokemon/403/"
    },
    {
      "name": "luxio",
      "url": "https://pokeapi.co/api/v2/pokemon/404/"
    },
    {
      "name": "luxray",
      "url": "https://pokeapi.co/api/v2/pokemon/405/"
    },
    {
      "name": "budew",
      "url": "https://pokeapi.co/api/v2/pokemon/406/"
    },
    {
      "name": "roserade",
      "url": "https://pokeapi.co/api/v2/pokemon/407/"
    },
    {
      "name": "cranidos",
      "url": "https://pokeapi.co/api/v2/pokemon/408/"
    },
    {
      "name": "rampardos",
      "url": "https://pokeapi.co/api/v2/pokemon/409/"
    },
    {
      "name": "shieldon",
      "url": "https://pokeapi.co/api/v2/pokemon/410/"
    },
    {
      "name": "bastiodon",
      "url": "https://pokeapi.co/api/v2/pokemon/411/"
    },
    {
      "name": "burmy",
      "url": "https://pokeapi.co/api/v2/pokemon/412/"
    },
    {
      "name": "wormadam-plant",
      "url": "https://pokeapi.co/api/v2/pokemon/413/"
    },
    {
      "name": "mothim",
      "url": "https://pokeapi.co/api/v2/pokemon/414/"
    },
    {
      "name": "combee",
      "url": "https://pokeapi.co/api/v2/pokemon/415/"
    },
    {
      "name": "vespiquen",
      "url": "https://pokeapi.co/api/v2/pokemon/416/"
    },
    {
      "name": "pachirisu",
      "url": "https://pokeapi.co/api/v2/pokemon/417/"
    },
    {
      "name": "buizel",
      "url": "https://pokeapi.co/api/v2/pokemon/418/"
    },
    {
      "name": "floatzel",
      "url": "https://pokeapi.co/api/v2/pokemon/419/"
    },
    {
      "name": "cherubi",
      "url": "https://pokeapi.co/api/v2/pokemon/420/"
    },
    {
      "name": "cherrim",
      "url": "https://pokeapi.co/api/v2/pokemon/421/"
    },
    {
      "name": "shellos",
      "url": "https://pokeapi.co/api/v2/pokemon/422/"
    },
    {
      "name": "gastrodon",
      "url": "https://pokeapi.co/api/v2/pokemon/423/"
    },
    {
      "name": "ambipom",
      "url": "https://pokeapi.co/api/v2/pokemon/424/"
    },
    {
      "name": "drifloon",
      "url": "https://pokeapi.co/api/v2/pokemon/425/"
    },
    {
      "name": "drifblim",
      "url": "https://pokeapi.co/api/v2/pokemon/426/"
    },
    {
      "name": "buneary",
      "url": "https://pokeapi.co/api/v2/pokemon/427/"
    },
    {
      "name": "lopunny",
      "url": "https://pokeapi.co/api/v2/pokemon/428/"
    },
    {
      "name": "mismagius",
      "url": "https://pokeapi.co/api/v2/pokemon/429/"
    },
    {
      "name": "honchkrow",
      "url": "https://pokeapi.co/api/v2/pokemon/430/"
    },
    {
      "name": "glameow",
      "url": "https://pokeapi.co/api/v2/pokemon/431/"
    },
    {
      "name": "purugly",
      "url": "https://pokeapi.co/api/v2/pokemon/432/"
    },
    {
      "name": "chingling",
      "url": "https://pokeapi.co/api/v2/pokemon/433/"
    },
    {
      "name": "stunky",
      "url": "https://pokeapi.co/api/v2/pokemon/434/"
    },
    {
      "name": "skuntank",
      "url": "https://pokeapi.co/api/v2/pokemon/435/"
    },
    {
      "name": "bronzor",
      "url": "https://pokeapi.co/api/v2/pokemon/436/"
    },
    {
      "name": "bronzong",
      "url": "https://pokeapi.co/api/v2/pokemon/437/"
    },
    {
      "name": "bonsly",
      "url": "https://pokeapi.co/api/v2/pokemon/438/"
    },
    {
      "name": "mime-jr",
      "url": "https://pokeapi.co/api/v2/pokemon/439/"
    },
    {
      "name": "happiny",
      "url": "https://pokeapi.co/api/v2/pokemon/440/"
    },
    {
      "name": "chatot",
      "url": "https://pokeapi.co/api/v2/pokemon/441/"
    },
    {
      "name": "spiritomb",
      "url": "https://pokeapi.co/api/v2/pokemon/442/"
    },
    {
      "name": "gible",
      "url": "https://pokeapi.co/api/v2/pokemon/443/"
    },
    {
      "name": "gabite",
      "url": "https://pokeapi.co/api/v2/pokemon/444/"
    },
    {
      "name": "garchomp",
      "url": "https://pokeapi.co/api/v2/pokemon/445/"
    },
    {
      "name": "munchlax",
      "url": "https://pokeapi.co/api/v2/pokemon/446/"
    },
    {
      "name": "riolu",
      "url": "https://pokeapi.co/api/v2/pokemon/447/"
    },
    {
      "name": "lucario",
      "url": "https://pokeapi.co/api/v2/pokemon/448/"
    },
    {
      "name": "hippopotas",
      "url": "https://pokeapi.co/api/v2/pokemon/449/"
    },
    {
      "name": "hippowdon",
      "url": "https://pokeapi.co/api/v2/pokemon/450/"
    },
    {
      "name": "skorupi",
      "url": "https://pokeapi.co/api/v2/pokemon/451/"
    },
    {
      "name": "drapion",
      "url": "https://pokeapi.co/api/v2/pokemon/452/"
    },
    {
      "name": "croagunk",
      "url": "https://pokeapi.co/api/v2/pokemon/453/"
    },
    {
      "name": "toxicroak",
      "url": "https://pokeapi.co/api/v2/pokemon/454/"
    },
    {
      "name": "carnivine",
      "url": "https://pokeapi.co/api/v2/pokemon/455/"
    },
    {
      "name": "finneon",
      "url": "https://pokeapi.co/api/v2/pokemon/456/"
    },
    {
      "name": "lumineon",
      "url": "https://pokeapi.co/api/v2/pokemon/457/"
    },
    {
      "name": "mantyke",
      "url": "https://pokeapi.co/api/v2/pokemon/458/"
    },
    {
      "name": "snover",
      "url": "https://pokeapi.co/api/v2/pokemon/459/"
    },
    {
      "name": "abomasnow",
      "url": "https://pokeapi.co/api/v2/pokemon/460/"
    },
    {
      "name": "weavile",
      "url": "https://pokeapi.co/api/v2/pokemon/461/"
    },
    {
      "name": "magnezone",
      "url": "https://pokeapi.co/api/v2/pokemon/462/"
    },
    {
      "name": "lickilicky",
      "url": "https://pokeapi.co/api/v2/pokemon/463/"
    },
    {
      "name": "rhyperior",
      "url": "https://pokeapi.co/api/v2/pokemon/464/"
    },
    {
      "name": "tangrowth",
      "url": "https://pokeapi.co/api/v2/pokemon/465/"
    },
    {
      "name": "electivire",
      "url": "https://pokeapi.co/api/v2/pokemon/466/"
    },
    {
      "name": "magmortar",
      "url": "https://pokeapi.co/api/v2/pokemon/467/"
    },
    {
      "name": "togekiss",
      "url": "https://pokeapi.co/api/v2/pokemon/468/"
    },
    {
      "name": "yanmega",
      "url": "https://pokeapi.co/api/v2/pokemon/469/"
    },
    {
      "name": "leafeon",
      "url": "https://pokeapi.co/api/v2/pokemon/470/"
    },
    {
      "name": "glaceon",
      "url": "https://pokeapi.co/api/v2/pokemon/471/"
    },
    {
      "name": "gliscor",
      "url": "https://pokeapi.co/api/v2/pokemon/472/"
    },
    {
      "name": "mamoswine",
      "url": "https://pokeapi.co/api/v2/pokemon/473/"
    },
    {
      "name": "porygon-z",
      "url": "https://pokeapi.co/api/v2/pokemon/474/"
    },
    {
      "name": "gallade",
      "url": "https://pokeapi.co/api/v2/pokemon/475/"
    },
    {
      "name": "probopass",
      "url": "https://pokeapi.co/api/v2/pokemon/476/"
    },
    {
      "name": "dusknoir",
      "url": "https://pokeapi.co/api/v2/pokemon/477/"
    },
    {
      "name": "froslass",
      "url": "https://pokeapi.co/api/v2/pokemon/478/"
    },
    {
      "name": "rotom",
      "url": "https://pokeapi.co/api/v2/pokemon/479/"
    },
    {
      "name": "uxie",
      "url": "https://pokeapi.co/api/v2/pokemon/480/"
    },
    {
      "name": "mesprit",
      "url": "https://pokeapi.co/api/v2/pokemon/481/"
    },
    {
      "name": "azelf",
      "url": "https://pokeapi.co/api/v2/pokemon/482/"
    },
    {
      "name": "dialga",
      "url": "https://pokeapi.co/api/v2/pokemon/483/"
    },
    {
      "name": "palkia",
      "url": "https://pokeapi.co/api/v2/pokemon/484/"
    },
    {
      "name": "heatran",
      "url": "https://pokeapi.co/api/v2/pokemon/485/"
    },
    {
      "name": "regigigas",
      "url": "https://pokeapi.co/api/v2/pokemon/486/"
    },
    {
      "name": "giratina-altered",
      "url": "https://pokeapi.co/api/v2/pokemon/487/"
    },
    {
      "name": "cresselia",
      "url": "https://pokeapi.co/api/v2/pokemon/488/"
    },
    {
      "name": "phione",
      "url": "https://pokeapi.co/api/v2/pokemon/489/"
    },
    {
      "name": "manaphy",
      "url": "https://pokeapi.co/api/v2/pokemon/490/"
    },
    {
      "name": "darkrai",
      "url": "https://pokeapi.co/api/v2/pokemon/491/"
    },
    {
      "name": "shaymin-land",
      "url": "https://pokeapi.co/api/v2/pokemon/492/"
    },
    {
      "name": "arceus",
      "url": "https://pokeapi.co/api/v2/pokemon/493/"
    },
    {
      "name": "victini",
      "url": "https://pokeapi.co/api/v2/pokemon/494/"
    },
    {
      "name": "snivy",
      "url": "https://pokeapi.co/api/v2/pokemon/495/"
    },
    {
      "name": "servine",
      "url": "https://pokeapi.co/api/v2/pokemon/496/"
    },
    {
      "name": "serperior",
      "url": "https://pokeapi.co/api/v2/pokemon/497/"
    },
    {
      "name": "tepig",
      "url": "https://pokeapi.co/api/v2/pokemon/498/"
    },
    {
      "name": "pignite",
      "url": "https://pokeapi.co/api/v2/pokemon/499/"
    },
    {
      "name": "emboar",
      "url": "https://pokeapi.co/api/v2/pokemon/500/"
    },
    {
      "name": "oshawott",
      "url": "https://pokeapi.co/api/v2/pokemon/501/"
    },
    {
      "name": "dewott",
      "url": "https://pokeapi.co/api/v2/pokemon/502/"
    },
    {
      "name": "samurott",
      "url": "https://pokeapi.co/api/v2/pokemon/503/"
    },
    {
      "name": "patrat",
      "url": "https://pokeapi.co/api/v2/pokemon/504/"
    },
    {
      "name": "watchog",
      "url": "https://pokeapi.co/api/v2/pokemon/505/"
    },
    {
      "name": "lillipup",
      "url": "https://pokeapi.co/api/v2/pokemon/506/"
    },
    {
      "name": "herdier",
      "url": "https://pokeapi.co/api/v2/pokemon/507/"
    },
    {
      "name": "stoutland",
      "url": "https://pokeapi.co/api/v2/pokemon/508/"
    },
    {
      "name": "purrloin",
      "url": "https://pokeapi.co/api/v2/pokemon/509/"
    },
    {
      "name": "liepard",
      "url": "https://pokeapi.co/api/v2/pokemon/510/"
    },
    {
      "name": "pansage",
      "url": "https://pokeapi.co/api/v2/pokemon/511/"
    },
    {
      "name": "simisage",
      "url": "https://pokeapi.co/api/v2/pokemon/512/"
    },
    {
      "name": "pansear",
      "url": "https://pokeapi.co/api/v2/pokemon/513/"
    },
    {
      "name": "simisear",
      "url": "https://pokeapi.co/api/v2/pokemon/514/"
    },
    {
      "name": "panpour",
      "url": "https://pokeapi.co/api/v2/pokemon/515/"
    },
    {
      "name": "simipour",
      "url": "https://pokeapi.co/api/v2/pokemon/516/"
    },
    {
      "name": "munna",
      "url": "https://pokeapi.co/api/v2/pokemon/517/"
    },
    {
      "name": "musharna",
      "url": "https://pokeapi.co/api/v2/pokemon/518/"
    },
    {
      "name": "pidove",
      "url": "https://pokeapi.co/api/v2/pokemon/519/"
    },
    {
      "name": "tranquill",
      "url": "https://pokeapi.co/api/v2/pokemon/520/"
    },
    {
      "name": "unfezant",
      "url": "https://pokeapi.co/api/v2/pokemon/521/"
    },
    {
      "name": "blitzle",
      "url": "https://pokeapi.co/api/v2/pokemon/522/"
    },
    {
      "name": "zebstrika",
      "url": "https://pokeapi.co/api/v2/pokemon/523/"
    },
    {
      "name": "roggenrola",
      "url": "https://pokeapi.co/api/v2/pokemon/524/"
    },
    {
      "name": "boldore",
      "url": "https://pokeapi.co/api/v2/pokemon/525/"
    },
    {
      "name": "gigalith",
      "url": "https://pokeapi.co/api/v2/pokemon/526/"
    },
    {
      "name": "woobat",
      "url": "https://pokeapi.co/api/v2/pokemon/527/"
    },
    {
      "name": "swoobat",
      "url": "https://pokeapi.co/api/v2/pokemon/528/"
    },
    {
      "name": "drilbur",
      "url": "https://pokeapi.co/api/v2/pokemon/529/"
    },
    {
      "name": "excadrill",
      "url": "https://pokeapi.co/api/v2/pokemon/530/"
    },
    {
      "name": "audino",
      "url": "https://pokeapi.co/api/v2/pokemon/531/"
    },
    {
      "name": "timburr",
      "url": "https://pokeapi.co/api/v2/pokemon/532/"
    },
    {
      "name": "gurdurr",
      "url": "https://pokeapi.co/api/v2/pokemon/533/"
    },
    {
      "name": "conkeldurr",
      "url": "https://pokeapi.co/api/v2/pokemon/534/"
    },
    {
      "name": "tympole",
      "url": "https://pokeapi.co/api/v2/pokemon/535/"
    },
    {
      "name": "palpitoad",
      "url": "https://pokeapi.co/api/v2/pokemon/536/"
    },
    {
      "name": "seismitoad",
      "url": "https://pokeapi.co/api/v2/pokemon/537/"
    },
    {
      "name": "throh",
      "url": "https://pokeapi.co/api/v2/pokemon/538/"
    },
    {
      "name": "sawk",
      "url": "https://pokeapi.co/api/v2/pokemon/539/"
    },
    {
      "name": "sewaddle",
      "url": "https://pokeapi.co/api/v2/pokemon/540/"
    },
    {
      "name": "swadloon",
      "url": "https://pokeapi.co/api/v2/pokemon/541/"
    },
    {
      "name": "leavanny",
      "url": "https://pokeapi.co/api/v2/pokemon/542/"
    },
    {
      "name": "venipede",
      "url": "https://pokeapi.co/api/v2/pokemon/543/"
    },
    {
      "name": "whirlipede",
      "url": "https://pokeapi.co/api/v2/pokemon/544/"
    },
    {
      "name": "scolipede",
      "url": "https://pokeapi.co/api/v2/pokemon/545/"
    },
    {
      "name": "cottonee",
      "url": "https://pokeapi.co/api/v2/pokemon/546/"
    },
    {
      "name": "whimsicott",
      "url": "https://pokeapi.co/api/v2/pokemon/547/"
    },
    {
      "name": "petilil",
      "url": "https://pokeapi.co/api/v2/pokemon/548/"
    },
    {
      "name": "lilligant",
      "url": "https://pokeapi.co/api/v2/pokemon/549/"
    },
    {
      "name": "basculin-red-striped",
      "url": "https://pokeapi.co/api/v2/pokemon/550/"
    },
    {
      "name": "sandile",
      "url": "https://pokeapi.co/api/v2/pokemon/551/"
    },
    {
      "name": "krokorok",
      "url": "https://pokeapi.co/api/v2/pokemon/552/"
    },
    {
      "name": "krookodile",
      "url": "https://pokeapi.co/api/v2/pokemon/553/"
    },
    {
      "name": "darumaka",
      "url": "https://pokeapi.co/api/v2/pokemon/554/"
    },
    {
      "name": "darmanitan-standard",
      "url": "https://pokeapi.co/api/v2/pokemon/555/"
    },
    {
      "name": "maractus",
      "url": "https://pokeapi.co/api/v2/pokemon/556/"
    },
    {
      "name": "dwebble",
      "url": "https://pokeapi.co/api/v2/pokemon/557/"
    },
    {
      "name": "crustle",
      "url": "https://pokeapi.co/api/v2/pokemon/558/"
    },
    {
      "name": "scraggy",
      "url": "https://pokeapi.co/api/v2/pokemon/559/"
    },
    {
      "name": "scrafty",
      "url": "https://pokeapi.co/api/v2/pokemon/560/"
    },
    {
      "name": "sigilyph",
      "url": "https://pokeapi.co/api/v2/pokemon/561/"
    },
    {
      "name": "yamask",
      "url": "https://pokeapi.co/api/v2/pokemon/562/"
    },
    {
      "name": "cofagrigus",
      "url": "https://pokeapi.co/api/v2/pokemon/563/"
    },
    {
      "name": "tirtouga",
      "url": "https://pokeapi.co/api/v2/pokemon/564/"
    },
    {
      "name": "carracosta",
      "url": "https://pokeapi.co/api/v2/pokemon/565/"
    },
    {
      "name": "archen",
      "url": "https://pokeapi.co/api/v2/pokemon/566/"
    },
    {
      "name": "archeops",
      "url": "https://pokeapi.co/api/v2/pokemon/567/"
    },
    {
      "name": "trubbish",
      "url": "https://pokeapi.co/api/v2/pokemon/568/"
    },
    {
      "name": "garbodor",
      "url": "https://pokeapi.co/api/v2/pokemon/569/"
    },
    {
      "name": "zorua",
      "url": "https://pokeapi.co/api/v2/pokemon/570/"
    },
    {
      "name": "zoroark",
      "url": "https://pokeapi.co/api/v2/pokemon/571/"
    },
    {
      "name": "minccino",
      "url": "https://pokeapi.co/api/v2/pokemon/572/"
    },
    {
      "name": "cinccino",
      "url": "https://pokeapi.co/api/v2/pokemon/573/"
    },
    {
      "name": "gothita",
      "url": "https://pokeapi.co/api/v2/pokemon/574/"
    },
    {
      "name": "gothorita",
      "url": "https://pokeapi.co/api/v2/pokemon/575/"
    },
    {
      "name": "gothitelle",
      "url": "https://pokeapi.co/api/v2/pokemon/576/"
    },
    {
      "name": "solosis",
      "url": "https://pokeapi.co/api/v2/pokemon/577/"
    },
    {
      "name": "duosion",
      "url": "https://pokeapi.co/api/v2/pokemon/578/"
    },
    {
      "name": "reuniclus",
      "url": "https://pokeapi.co/api/v2/pokemon/579/"
    },
    {
      "name": "ducklett",
      "url": "https://pokeapi.co/api/v2/pokemon/580/"
    },
    {
      "name": "swanna",
      "url": "https://pokeapi.co/api/v2/pokemon/581/"
    },
    {
      "name": "vanillite",
      "url": "https://pokeapi.co/api/v2/pokemon/582/"
    },
    {
      "name": "vanillish",
      "url": "https://pokeapi.co/api/v2/pokemon/583/"
    },
    {
      "name": "vanilluxe",
      "url": "https://pokeapi.co/api/v2/pokemon/584/"
    },
    {
      "name": "deerling",
      "url": "https://pokeapi.co/api/v2/pokemon/585/"
    },
    {
      "name": "sawsbuck",
      "url": "https://pokeapi.co/api/v2/pokemon/586/"
    },
    {
      "name": "emolga",
      "url": "https://pokeapi.co/api/v2/pokemon/587/"
    },
    {
      "name": "karrablast",
      "url": "https://pokeapi.co/api/v2/pokemon/588/"
    },
    {
      "name": "escavalier",
      "url": "https://pokeapi.co/api/v2/pokemon/589/"
    },
    {
      "name": "foongus",
      "url": "https://pokeapi.co/api/v2/pokemon/590/"
    },
    {
      "name": "amoonguss",
      "url": "https://pokeapi.co/api/v2/pokemon/591/"
    },
    {
      "name": "frillish",
      "url": "https://pokeapi.co/api/v2/pokemon/592/"
    },
    {
      "name": "jellicent",
      "url": "https://pokeapi.co/api/v2/pokemon/593/"
    },
    {
      "name": "alomomola",
      "url": "https://pokeapi.co/api/v2/pokemon/594/"
    },
    {
      "name": "joltik",
      "url": "https://pokeapi.co/api/v2/pokemon/595/"
    },
    {
      "name": "galvantula",
      "url": "https://pokeapi.co/api/v2/pokemon/596/"
    },
    {
      "name": "ferroseed",
      "url": "https://pokeapi.co/api/v2/pokemon/597/"
    },
    {
      "name": "ferrothorn",
      "url": "https://pokeapi.co/api/v2/pokemon/598/"
    },
    {
      "name": "klink",
      "url": "https://pokeapi.co/api/v2/pokemon/599/"
    },
    {
      "name": "klang",
      "url": "https://pokeapi.co/api/v2/pokemon/600/"
    },
    {
      "name": "klinklang",
      "url": "https://pokeapi.co/api/v2/pokemon/601/"
    },
    {
      "name": "tynamo",
      "url": "https://pokeapi.co/api/v2/pokemon/602/"
    },
    {
      "name": "eelektrik",
      "url": "https://pokeapi.co/api/v2/pokemon/603/"
    },
    {
      "name": "eelektross",
      "url": "https://pokeapi.co/api/v2/pokemon/604/"
    },
    {
      "name": "elgyem",
      "url": "https://pokeapi.co/api/v2/pokemon/605/"
    },
    {
      "name": "beheeyem",
      "url": "https://pokeapi.co/api/v2/pokemon/606/"
    },
    {
      "name": "litwick",
      "url": "https://pokeapi.co/api/v2/pokemon/607/"
    },
    {
      "name": "lampent",
      "url": "https://pokeapi.co/api/v2/pokemon/608/"
    },
    {
      "name": "chandelure",
      "url": "https://pokeapi.co/api/v2/pokemon/609/"
    },
    {
      "name": "axew",
      "url": "https://pokeapi.co/api/v2/pokemon/610/"
    },
    {
      "name": "fraxure",
      "url": "https://pokeapi.co/api/v2/pokemon/611/"
    },
    {
      "name": "haxorus",
      "url": "https://pokeapi.co/api/v2/pokemon/612/"
    },
    {
      "name": "cubchoo",
      "url": "https://pokeapi.co/api/v2/pokemon/613/"
    },
    {
      "name": "beartic",
      "url": "https://pokeapi.co/api/v2/pokemon/614/"
    },
    {
      "name": "cryogonal",
      "url": "https://pokeapi.co/api/v2/pokemon/615/"
    },
    {
      "name": "shelmet",
      "url": "https://pokeapi.co/api/v2/pokemon/616/"
    },
    {
      "name": "accelgor",
      "url": "https://pokeapi.co/api/v2/pokemon/617/"
    },
    {
      "name": "stunfisk",
      "url": "https://pokeapi.co/api/v2/pokemon/618/"
    },
    {
      "name": "mienfoo",
      "url": "https://pokeapi.co/api/v2/pokemon/619/"
    },
    {
      "name": "mienshao",
      "url": "https://pokeapi.co/api/v2/pokemon/620/"
    },
    {
      "name": "druddigon",
      "url": "https://pokeapi.co/api/v2/pokemon/621/"
    },
    {
      "name": "golett",
      "url": "https://pokeapi.co/api/v2/pokemon/622/"
    },
    {
      "name": "golurk",
      "url": "https://pokeapi.co/api/v2/pokemon/623/"
    },
    {
      "name": "pawniard",
      "url": "https://pokeapi.co/api/v2/pokemon/624/"
    },
    {
      "name": "bisharp",
      "url": "https://pokeapi.co/api/v2/pokemon/625/"
    },
    {
      "name": "bouffalant",
      "url": "https://pokeapi.co/api/v2/pokemon/626/"
    },
    {
      "name": "rufflet",
      "url": "https://pokeapi.co/api/v2/pokemon/627/"
    },
    {
      "name": "braviary",
      "url": "https://pokeapi.co/api/v2/pokemon/628/"
    },
    {
      "name": "vullaby",
      "url": "https://pokeapi.co/api/v2/pokemon/629/"
    },
    {
      "name": "mandibuzz",
      "url": "https://pokeapi.co/api/v2/pokemon/630/"
    },
    {
      "name": "heatmor",
      "url": "https://pokeapi.co/api/v2/pokemon/631/"
    },
    {
      "name": "durant",
      "url": "https://pokeapi.co/api/v2/pokemon/632/"
    },
    {
      "name": "deino",
      "url": "https://pokeapi.co/api/v2/pokemon/633/"
    },
    {
      "name": "zweilous",
      "url": "https://pokeapi.co/api/v2/pokemon/634/"
    },
    {
      "name": "hydreigon",
      "url": "https://pokeapi.co/api/v2/pokemon/635/"
    },
    {
      "name": "larvesta",
      "url": "https://pokeapi.co/api/v2/pokemon/636/"
    },
    {
      "name": "volcarona",
      "url": "https://pokeapi.co/api/v2/pokemon/637/"
    },
    {
      "name": "cobalion",
      "url": "https://pokeapi.co/api/v2/pokemon/638/"
    },
    {
      "name": "terrakion",
      "url": "https://pokeapi.co/api/v2/pokemon/639/"
    },
    {
      "name": "virizion",
      "url": "https://pokeapi.co/api/v2/pokemon/640/"
    },
    {
      "name": "tornadus-incarnate",
      "url": "https://pokeapi.co/api/v2/pokemon/641/"
    },
    {
      "name": "thundurus-incarnate",
      "url": "https://pokeapi.co/api/v2/pokemon/642/"
    },
    {
      "name": "reshiram",
      "url": "https://pokeapi.co/api/v2/pokemon/643/"
    },
    {
      "name": "zekrom",
      "url": "https://pokeapi.co/api/v2/pokemon/644/"
    },
    {
      "name": "landorus-incarnate",
      "url": "https://pokeapi.co/api/v2/pokemon/645/"
    },
    {
      "name": "kyurem",
      "url": "https://pokeapi.co/api/v2/pokemon/646/"
    },
    {
      "name": "keldeo-ordinary",
      "url": "https://pokeapi.co/api/v2/pokemon/647/"
    },
    {
      "name": "meloetta-aria",
      "url": "https://pokeapi.co/api/v2/pokemon/648/"
    },
    {
      "name": "genesect",
      "url": "https://pokeapi.co/api/v2/pokemon/649/"
    },
    {
      "name": "chespin",
      "url": "https://pokeapi.co/api/v2/pokemon/650/"
    },
    {
      "name": "quilladin",
      "url": "https://pokeapi.co/api/v2/pokemon/651/"
    },
    {
      "name": "chesnaught",
      "url": "https://pokeapi.co/api/v2/pokemon/652/"
    },
    {
      "name": "fennekin",
      "url": "https://pokeapi.co/api/v2/pokemon/653/"
    },
    {
      "name": "braixen",
      "url": "https://pokeapi.co/api/v2/pokemon/654/"
    },
    {
      "name": "delphox",
      "url": "https://pokeapi.co/api/v2/pokemon/655/"
    },
    {
      "name": "froakie",
      "url": "https://pokeapi.co/api/v2/pokemon/656/"
    },
    {
      "name": "frogadier",
      "url": "https://pokeapi.co/api/v2/pokemon/657/"
    },
    {
      "name": "greninja",
      "url": "https://pokeapi.co/api/v2/pokemon/658/"
    },
    {
      "name": "bunnelby",
      "url": "https://pokeapi.co/api/v2/pokemon/659/"
    },
    {
      "name": "diggersby",
      "url": "https://pokeapi.co/api/v2/pokemon/660/"
    },
    {
      "name": "fletchling",
      "url": "https://pokeapi.co/api/v2/pokemon/661/"
    },
    {
      "name": "fletchinder",
      "url": "https://pokeapi.co/api/v2/pokemon/662/"
    },
    {
      "name": "talonflame",
      "url": "https://pokeapi.co/api/v2/pokemon/663/"
    },
    {
      "name": "scatterbug",
      "url": "https://pokeapi.co/api/v2/pokemon/664/"
    },
    {
      "name": "spewpa",
      "url": "https://pokeapi.co/api/v2/pokemon/665/"
    },
    {
      "name": "vivillon",
      "url": "https://pokeapi.co/api/v2/pokemon/666/"
    },
    {
      "name": "litleo",
      "url": "https://pokeapi.co/api/v2/pokemon/667/"
    },
    {
      "name": "pyroar",
      "url": "https://pokeapi.co/api/v2/pokemon/668/"
    },
    {
      "name": "flabebe",
      "url": "https://pokeapi.co/api/v2/pokemon/669/"
    },
    {
      "name": "floette",
      "url": "https://pokeapi.co/api/v2/pokemon/670/"
    },
    {
      "name": "florges",
      "url": "https://pokeapi.co/api/v2/pokemon/671/"
    },
    {
      "name": "skiddo",
      "url": "https://pokeapi.co/api/v2/pokemon/672/"
    },
    {
      "name": "gogoat",
      "url": "https://pokeapi.co/api/v2/pokemon/673/"
    },
    {
      "name": "pancham",
      "url": "https://pokeapi.co/api/v2/pokemon/674/"
    },
    {
      "name": "pangoro",
      "url": "https://pokeapi.co/api/v2/pokemon/675/"
    },
    {
      "name": "furfrou",
      "url": "https://pokeapi.co/api/v2/pokemon/676/"
    },
    {
      "name": "espurr",
      "url": "https://pokeapi.co/api/v2/pokemon/677/"
    },
    {
      "name": "meowstic-male",
      "url": "https://pokeapi.co/api/v2/pokemon/678/"
    },
    {
      "name": "honedge",
      "url": "https://pokeapi.co/api/v2/pokemon/679/"
    },
    {
      "name": "doublade",
      "url": "https://pokeapi.co/api/v2/pokemon/680/"
    },
    {
      "name": "aegislash-shield",
      "url": "https://pokeapi.co/api/v2/pokemon/681/"
    },
    {
      "name": "spritzee",
      "url": "https://pokeapi.co/api/v2/pokemon/682/"
    },
    {
      "name": "aromatisse",
      "url": "https://pokeapi.co/api/v2/pokemon/683/"
    },
    {
      "name": "swirlix",
      "url": "https://pokeapi.co/api/v2/pokemon/684/"
    },
    {
      "name": "slurpuff",
      "url": "https://pokeapi.co/api/v2/pokemon/685/"
    },
    {
      "name": "inkay",
      "url": "https://pokeapi.co/api/v2/pokemon/686/"
    },
    {
      "name": "malamar",
      "url": "https://pokeapi.co/api/v2/pokemon/687/"
    },
    {
      "name": "binacle",
      "url": "https://pokeapi.co/api/v2/pokemon/688/"
    },
    {
      "name": "barbaracle",
      "url": "https://pokeapi.co/api/v2/pokemon/689/"
    },
    {
      "name": "skrelp",
      "url": "https://pokeapi.co/api/v2/pokemon/690/"
    },
    {
      "name": "dragalge",
      "url": "https://pokeapi.co/api/v2/pokemon/691/"
    },
    {
      "name": "clauncher",
      "url": "https://pokeapi.co/api/v2/pokemon/692/"
    },
    {
      "name": "clawitzer",
      "url": "https://pokeapi.co/api/v2/pokemon/693/"
    },
    {
      "name": "helioptile",
      "url": "https://pokeapi.co/api/v2/pokemon/694/"
    },
    {
      "name": "heliolisk",
      "url": "https://pokeapi.co/api/v2/pokemon/695/"
    },
    {
      "name": "tyrunt",
      "url": "https://pokeapi.co/api/v2/pokemon/696/"
    },
    {
      "name": "tyrantrum",
      "url": "https://pokeapi.co/api/v2/pokemon/697/"
    },
    {
      "name": "amaura",
      "url": "https://pokeapi.co/api/v2/pokemon/698/"
    },
    {
      "name": "aurorus",
      "url": "https://pokeapi.co/api/v2/pokemon/699/"
    },
    {
      "name": "sylveon",
      "url": "https://pokeapi.co/api/v2/pokemon/700/"
    },
    {
      "name": "hawlucha",
      "url": "https://pokeapi.co/api/v2/pokemon/701/"
    },
    {
      "name": "dedenne",
      "url": "https://pokeapi.co/api/v2/pokemon/702/"
    },
    {
      "name": "carbink",
      "url": "https://pokeapi.co/api/v2/pokemon/703/"
    },
    {
      "name": "goomy",
      "url": "https://pokeapi.co/api/v2/pokemon/704/"
    },
    {
      "name": "sliggoo",
      "url": "https://pokeapi.co/api/v2/pokemon/705/"
    },
    {
      "name": "goodra",
      "url": "https://pokeapi.co/api/v2/pokemon/706/"
    },
    {
      "name": "klefki",
      "url": "https://pokeapi.co/api/v2/pokemon/707/"
    },
    {
      "name": "phantump",
      "url": "https://pokeapi.co/api/v2/pokemon/708/"
    },
    {
      "name": "trevenant",
      "url": "https://pokeapi.co/api/v2/pokemon/709/"
    },
    {
      "name": "pumpkaboo-average",
      "url": "https://pokeapi.co/api/v2/pokemon/710/"
    },
    {
      "name": "gourgeist-average",
      "url": "https://pokeapi.co/api/v2/pokemon/711/"
    },
    {
      "name": "bergmite",
      "url": "https://pokeapi.co/api/v2/pokemon/712/"
    },
    {
      "name": "avalugg",
      "url": "https://pokeapi.co/api/v2/pokemon/713/"
    },
    {
      "name": "noibat",
      "url": "https://pokeapi.co/api/v2/pokemon/714/"
    },
    {
      "name": "noivern",
      "url": "https://pokeapi.co/api/v2/pokemon/715/"
    },
    {
      "name": "xerneas",
      "url": "https://pokeapi.co/api/v2/pokemon/716/"
    },
    {
      "name": "yveltal",
      "url": "https://pokeapi.co/api/v2/pokemon/717/"
    },
    {
      "name": "zygarde-50",
      "url": "https://pokeapi.co/api/v2/pokemon/718/"
    },
    {
      "name": "diancie",
      "url": "https://pokeapi.co/api/v2/pokemon/719/"
    },
    {
      "name": "hoopa",
      "url": "https://pokeapi.co/api/v2/pokemon/720/"
    },
    {
      "name": "volcanion",
      "url": "https://pokeapi.co/api/v2/pokemon/721/"
    },
    {
      "name": "rowlet",
      "url": "https://pokeapi.co/api/v2/pokemon/722/"
    },
    {
      "name": "dartrix",
      "url": "https://pokeapi.co/api/v2/pokemon/723/"
    },
    {
      "name": "decidueye",
      "url": "https://pokeapi.co/api/v2/pokemon/724/"
    },
    {
      "name": "litten",
      "url": "https://pokeapi.co/api/v2/pokemon/725/"
    },
    {
      "name": "torracat",
      "url": "https://pokeapi.co/api/v2/pokemon/726/"
    },
    {
      "name": "incineroar",
      "url": "https://pokeapi.co/api/v2/pokemon/727/"
    },
    {
      "name": "popplio",
      "url": "https://pokeapi.co/api/v2/pokemon/728/"
    },
    {
      "name": "brionne",
      "url": "https://pokeapi.co/api/v2/pokemon/729/"
    },
    {
      "name": "primarina",
      "url": "https://pokeapi.co/api/v2/pokemon/730/"
    },
    {
      "name": "pikipek",
      "url": "https://pokeapi.co/api/v2/pokemon/731/"
    },
    {
      "name": "trumbeak",
      "url": "https://pokeapi.co/api/v2/pokemon/732/"
    },
    {
      "name": "toucannon",
      "url": "https://pokeapi.co/api/v2/pokemon/733/"
    },
    {
      "name": "yungoos",
      "url": "https://pokeapi.co/api/v2/pokemon/734/"
    },
    {
      "name": "gumshoos",
      "url": "https://pokeapi.co/api/v2/pokemon/735/"
    },
    {
      "name": "grubbin",
      "url": "https://pokeapi.co/api/v2/pokemon/736/"
    },
    {
      "name": "charjabug",
      "url": "https://pokeapi.co/api/v2/pokemon/737/"
    },
    {
      "name": "vikavolt",
      "url": "https://pokeapi.co/api/v2/pokemon/738/"
    },
    {
      "name": "crabrawler",
      "url": "https://pokeapi.co/api/v2/pokemon/739/"
    },
    {
      "name": "crabominable",
      "url": "https://pokeapi.co/api/v2/pokemon/740/"
    },
    {
      "name": "oricorio-baile",
      "url": "https://pokeapi.co/api/v2/pokemon/741/"
    },
    {
      "name": "cutiefly",
      "url": "https://pokeapi.co/api/v2/pokemon/742/"
    },
    {
      "name": "ribombee",
      "url": "https://pokeapi.co/api/v2/pokemon/743/"
    },
    {
      "name": "rockruff",
      "url": "https://pokeapi.co/api/v2/pokemon/744/"
    },
    {
      "name": "lycanroc-midday",
      "url": "https://pokeapi.co/api/v2/pokemon/745/"
    },
    {
      "name": "wishiwashi-solo",
      "url": "https://pokeapi.co/api/v2/pokemon/746/"
    },
    {
      "name": "mareanie",
      "url": "https://pokeapi.co/api/v2/pokemon/747/"
    },
    {
      "name": "toxapex",
      "url": "https://pokeapi.co/api/v2/pokemon/748/"
    },
    {
      "name": "mudbray",
      "url": "https://pokeapi.co/api/v2/pokemon/749/"
    },
    {
      "name": "mudsdale",
      "url": "https://pokeapi.co/api/v2/pokemon/750/"
    },
    {
      "name": "dewpider",
      "url": "https://pokeapi.co/api/v2/pokemon/751/"
    },
    {
      "name": "araquanid",
      "url": "https://pokeapi.co/api/v2/pokemon/752/"
    },
    {
      "name": "fomantis",
      "url": "https://pokeapi.co/api/v2/pokemon/753/"
    },
    {
      "name": "lurantis",
      "url": "https://pokeapi.co/api/v2/pokemon/754/"
    },
    {
      "name": "morelull",
      "url": "https://pokeapi.co/api/v2/pokemon/755/"
    },
    {
      "name": "shiinotic",
      "url": "https://pokeapi.co/api/v2/pokemon/756/"
    },
    {
      "name": "salandit",
      "url": "https://pokeapi.co/api/v2/pokemon/757/"
    },
    {
      "name": "salazzle",
      "url": "https://pokeapi.co/api/v2/pokemon/758/"
    },
    {
      "name": "stufful",
      "url": "https://pokeapi.co/api/v2/pokemon/759/"
    },
    {
      "name": "bewear",
      "url": "https://pokeapi.co/api/v2/pokemon/760/"
    },
    {
      "name": "bounsweet",
      "url": "https://pokeapi.co/api/v2/pokemon/761/"
    },
    {
      "name": "steenee",
      "url": "https://pokeapi.co/api/v2/pokemon/762/"
    },
    {
      "name": "tsareena",
      "url": "https://pokeapi.co/api/v2/pokemon/763/"
    },
    {
      "name": "comfey",
      "url": "https://pokeapi.co/api/v2/pokemon/764/"
    },
    {
      "name": "oranguru",
      "url": "https://pokeapi.co/api/v2/pokemon/765/"
    },
    {
      "name": "passimian",
      "url": "https://pokeapi.co/api/v2/pokemon/766/"
    },
    {
      "name": "wimpod",
      "url": "https://pokeapi.co/api/v2/pokemon/767/"
    },
    {
      "name": "golisopod",
      "url": "https://pokeapi.co/api/v2/pokemon/768/"
    },
    {
      "name": "sandygast",
      "url": "https://pokeapi.co/api/v2/pokemon/769/"
    },
    {
      "name": "palossand",
      "url": "https://pokeapi.co/api/v2/pokemon/770/"
    },
    {
      "name": "pyukumuku",
      "url": "https://pokeapi.co/api/v2/pokemon/771/"
    },
    {
      "name": "type-null",
      "url": "https://pokeapi.co/api/v2/pokemon/772/"
    },
    {
      "name": "silvally",
      "url": "https://pokeapi.co/api/v2/pokemon/773/"
    },
    {
      "name": "minior-red-meteor",
      "url": "https://pokeapi.co/api/v2/pokemon/774/"
    },
    {
      "name": "komala",
      "url": "https://pokeapi.co/api/v2/pokemon/775/"
    },
    {
      "name": "turtonator",
      "url": "https://pokeapi.co/api/v2/pokemon/776/"
    },
    {
      "name": "togedemaru",
      "url": "https://pokeapi.co/api/v2/pokemon/777/"
    },
    {
      "name": "mimikyu-disguised",
      "url": "https://pokeapi.co/api/v2/pokemon/778/"
    },
    {
      "name": "bruxish",
      "url": "https://pokeapi.co/api/v2/pokemon/779/"
    },
    {
      "name": "drampa",
      "url": "https://pokeapi.co/api/v2/pokemon/780/"
    },
    {
      "name": "dhelmise",
      "url": "https://pokeapi.co/api/v2/pokemon/781/"
    },
    {
      "name": "jangmo-o",
      "url": "https://pokeapi.co/api/v2/pokemon/782/"
    },
    {
      "name": "hakamo-o",
      "url": "https://pokeapi.co/api/v2/pokemon/783/"
    },
    {
      "name": "kommo-o",
      "url": "https://pokeapi.co/api/v2/pokemon/784/"
    },
    {
      "name": "tapu-koko",
      "url": "https://pokeapi.co/api/v2/pokemon/785/"
    },
    {
      "name": "tapu-lele",
      "url": "https://pokeapi.co/api/v2/pokemon/786/"
    },
    {
      "name": "tapu-bulu",
      "url": "https://pokeapi.co/api/v2/pokemon/787/"
    },
    {
      "name": "tapu-fini",
      "url": "https://pokeapi.co/api/v2/pokemon/788/"
    },
    {
      "name": "cosmog",
      "url": "https://pokeapi.co/api/v2/pokemon/789/"
    },
    {
      "name": "cosmoem",
      "url": "https://pokeapi.co/api/v2/pokemon/790/"
    },
    {
      "name": "solgaleo",
      "url": "https://pokeapi.co/api/v2/pokemon/791/"
    },
    {
      "name": "lunala",
      "url": "https://pokeapi.co/api/v2/pokemon/792/"
    },
    {
      "name": "nihilego",
      "url": "https://pokeapi.co/api/v2/pokemon/793/"
    },
    {
      "name": "buzzwole",
      "url": "https://pokeapi.co/api/v2/pokemon/794/"
    },
    {
      "name": "pheromosa",
      "url": "https://pokeapi.co/api/v2/pokemon/795/"
    },
    {
      "name": "xurkitree",
      "url": "https://pokeapi.co/api/v2/pokemon/796/"
    },
    {
      "name": "celesteela",
      "url": "https://pokeapi.co/api/v2/pokemon/797/"
    },
    {
      "name": "kartana",
      "url": "https://pokeapi.co/api/v2/pokemon/798/"
    },
    {
      "name": "guzzlord",
      "url": "https://pokeapi.co/api/v2/pokemon/799/"
    },
    {
      "name": "necrozma",
      "url": "https://pokeapi.co/api/v2/pokemon/800/"
    },
    {
      "name": "magearna",
      "url": "https://pokeapi.co/api/v2/pokemon/801/"
    },
    {
      "name": "marshadow",
      "url": "https://pokeapi.co/api/v2/pokemon/802/"
    },
    {
      "name": "poipole",
      "url": "https://pokeapi.co/api/v2/pokemon/803/"
    },
    {
      "name": "naganadel",
      "url": "https://pokeapi.co/api/v2/pokemon/804/"
    },
    {
      "name": "stakataka",
      "url": "https://pokeapi.co/api/v2/pokemon/805/"
    },
    {
      "name": "blacephalon",
      "url": "https://pokeapi.co/api/v2/pokemon/806/"
    },
    {
      "name": "zeraora",
      "url": "https://pokeapi.co/api/v2/pokemon/807/"
    },
    {
      "name": "meltan",
      "url": "https://pokeapi.co/api/v2/pokemon/808/"
    },
    {
      "name": "melmetal",
      "url": "https://pokeapi.co/api/v2/pokemon/809/"
    },
    {
      "name": "grookey",
      "url": "https://pokeapi.co/api/v2/pokemon/810/"
    },
    {
      "name": "thwackey",
      "url": "https://pokeapi.co/api/v2/pokemon/811/"
    },
    {
      "name": "rillaboom",
      "url": "https://pokeapi.co/api/v2/pokemon/812/"
    },
    {
      "name": "scorbunny",
      "url": "https://pokeapi.co/api/v2/pokemon/813/"
    },
    {
      "name": "raboot",
      "url": "https://pokeapi.co/api/v2/pokemon/814/"
    },
    {
      "name": "cinderace",
      "url": "https://pokeapi.co/api/v2/pokemon/815/"
    },
    {
      "name": "sobble",
      "url": "https://pokeapi.co/api/v2/pokemon/816/"
    },
    {
      "name": "drizzile",
      "url": "https://pokeapi.co/api/v2/pokemon/817/"
    },
    {
      "name": "inteleon",
      "url": "https://pokeapi.co/api/v2/pokemon/818/"
    },
    {
      "name": "skwovet",
      "url": "https://pokeapi.co/api/v2/pokemon/819/"
    },
    {
      "name": "greedent",
      "url": "https://pokeapi.co/api/v2/pokemon/820/"
    },
    {
      "name": "rookidee",
      "url": "https://pokeapi.co/api/v2/pokemon/821/"
    },
    {
      "name": "corvisquire",
      "url": "https://pokeapi.co/api/v2/pokemon/822/"
    },
    {
      "name": "corviknight",
      "url": "https://pokeapi.co/api/v2/pokemon/823/"
    },
    {
      "name": "blipbug",
      "url": "https://pokeapi.co/api/v2/pokemon/824/"
    },
    {
      "name": "dottler",
      "url": "https://pokeapi.co/api/v2/pokemon/825/"
    },
    {
      "name": "orbeetle",
      "url": "https://pokeapi.co/api/v2/pokemon/826/"
    },
    {
      "name": "nickit",
      "url": "https://pokeapi.co/api/v2/pokemon/827/"
    },
    {
      "name": "thievul",
      "url": "https://pokeapi.co/api/v2/pokemon/828/"
    },
    {
      "name": "gossifleur",
      "url": "https://pokeapi.co/api/v2/pokemon/829/"
    },
    {
      "name": "eldegoss",
      "url": "https://pokeapi.co/api/v2/pokemon/830/"
    },
    {
      "name": "wooloo",
      "url": "https://pokeapi.co/api/v2/pokemon/831/"
    },
    {
      "name": "dubwool",
      "url": "https://pokeapi.co/api/v2/pokemon/832/"
    },
    {
      "name": "chewtle",
      "url": "https://pokeapi.co/api/v2/pokemon/833/"
    },
    {
      "name": "drednaw",
      "url": "https://pokeapi.co/api/v2/pokemon/834/"
    },
    {
      "name": "yamper",
      "url": "https://pokeapi.co/api/v2/pokemon/835/"
    },
    {
      "name": "boltund",
      "url": "https://pokeapi.co/api/v2/pokemon/836/"
    },
    {
      "name": "rolycoly",
      "url": "https://pokeapi.co/api/v2/pokemon/837/"
    },
    {
      "name": "carkol",
      "url": "https://pokeapi.co/api/v2/pokemon/838/"
    },
    {
      "name": "coalossal",
      "url": "https://pokeapi.co/api/v2/pokemon/839/"
    },
    {
      "name": "applin",
      "url": "https://pokeapi.co/api/v2/pokemon/840/"
    },
    {
      "name": "flapple",
      "url": "https://pokeapi.co/api/v2/pokemon/841/"
    },
    {
      "name": "appletun",
      "url": "https://pokeapi.co/api/v2/pokemon/842/"
    },
    {
      "name": "silicobra",
      "url": "https://pokeapi.co/api/v2/pokemon/843/"
    },
    {
      "name": "sandaconda",
      "url": "https://pokeapi.co/api/v2/pokemon/844/"
    },
    {
      "name": "cramorant",
      "url": "https://pokeapi.co/api/v2/pokemon/845/"
    },
    {
      "name": "arrokuda",
      "url": "https://pokeapi.co/api/v2/pokemon/846/"
    },
    {
      "name": "barraskewda",
      "url": "https://pokeapi.co/api/v2/pokemon/847/"
    },
    {
      "name": "toxel",
      "url": "https://pokeapi.co/api/v2/pokemon/848/"
    },
    {
      "name": "toxtricity-amped",
      "url": "https://pokeapi.co/api/v2/pokemon/849/"
    },
    {
      "name": "sizzlipede",
      "url": "https://pokeapi.co/api/v2/pokemon/850/"
    },
    {
      "name": "centiskorch",
      "url": "https://pokeapi.co/api/v2/pokemon/851/"
    },
    {
      "name": "clobbopus",
      "url": "https://pokeapi.co/api/v2/pokemon/852/"
    },
    {
      "name": "grapploct",
      "url": "https://pokeapi.co/api/v2/pokemon/853/"
    },
    {
      "name": "sinistea",
      "url": "https://pokeapi.co/api/v2/pokemon/854/"
    },
    {
      "name": "polteageist",
      "url": "https://pokeapi.co/api/v2/pokemon/855/"
    },
    {
      "name": "hatenna",
      "url": "https://pokeapi.co/api/v2/pokemon/856/"
    },
    {
      "name": "hattrem",
      "url": "https://pokeapi.co/api/v2/pokemon/857/"
    },
    {
      "name": "hatterene",
      "url": "https://pokeapi.co/api/v2/pokemon/858/"
    },
    {
      "name": "impidimp",
      "url": "https://pokeapi.co/api/v2/pokemon/859/"
    },
    {
      "name": "morgrem",
      "url": "https://pokeapi.co/api/v2/pokemon/860/"
    },
    {
      "name": "grimmsnarl",
      "url": "https://pokeapi.co/api/v2/pokemon/861/"
    },
    {
      "name": "obstagoon",
      "url": "https://pokeapi.co/api/v2/pokemon/862/"
    },
    {
      "name": "perrserker",
      "url": "https://pokeapi.co/api/v2/pokemon/863/"
    },
    {
      "name": "cursola",
      "url": "https://pokeapi.co/api/v2/pokemon/864/"
    },
    {
      "name": "sirfetchd",
      "url": "https://pokeapi.co/api/v2/pokemon/865/"
    },
    {
      "name": "mr-rime",
      "url": "https://pokeapi.co/api/v2/pokemon/866/"
    },
    {
      "name": "runerigus",
      "url": "https://pokeapi.co/api/v2/pokemon/867/"
    },
    {
      "name": "milcery",
      "url": "https://pokeapi.co/api/v2/pokemon/868/"
    },
    {
      "name": "alcremie",
      "url": "https://pokeapi.co/api/v2/pokemon/869/"
    },
    {
      "name": "falinks",
      "url": "https://pokeapi.co/api/v2/pokemon/870/"
    },
    {
      "name": "pincurchin",
      "url": "https://pokeapi.co/api/v2/pokemon/871/"
    },
    {
      "name": "snom",
      "url": "https://pokeapi.co/api/v2/pokemon/872/"
    },
    {
      "name": "frosmoth",
      "url": "https://pokeapi.co/api/v2/pokemon/873/"
    },
    {
      "name": "stonjourner",
      "url": "https://pokeapi.co/api/v2/pokemon/874/"
    },
    {
      "name": "eiscue-ice",
      "url": "https://pokeapi.co/api/v2/pokemon/875/"
    },
    {
      "name": "indeedee-male",
      "url": "https://pokeapi.co/api/v2/pokemon/876/"
    },
    {
      "name": "morpeko-full-belly",
      "url": "https://pokeapi.co/api/v2/pokemon/877/"
    },
    {
      "name": "cufant",
      "url": "https://pokeapi.co/api/v2/pokemon/878/"
    },
    {
      "name": "copperajah",
      "url": "https://pokeapi.co/api/v2/pokemon/879/"
    },
    {
      "name": "dracozolt",
      "url": "https://pokeapi.co/api/v2/pokemon/880/"
    },
    {
      "name": "arctozolt",
      "url": "https://pokeapi.co/api/v2/pokemon/881/"
    },
    {
      "name": "dracovish",
      "url": "https://pokeapi.co/api/v2/pokemon/882/"
    },
    {
      "name": "arctovish",
      "url": "https://pokeapi.co/api/v2/pokemon/883/"
    },
    {
      "name": "duraludon",
      "url": "https://pokeapi.co/api/v2/pokemon/884/"
    },
    {
      "name": "dreepy",
      "url": "https://pokeapi.co/api/v2/pokemon/885/"
    },
    {
      "name": "drakloak",
      "url": "https://pokeapi.co/api/v2/pokemon/886/"
    },
    {
      "name": "dragapult",
      "url": "https://pokeapi.co/api/v2/pokemon/887/"
    },
    {
      "name": "zacian",
      "url": "https://pokeapi.co/api/v2/pokemon/888/"
    },
    {
      "name": "zamazenta",
      "url": "https://pokeapi.co/api/v2/pokemon/889/"
    },
    {
      "name": "eternatus",
      "url": "https://pokeapi.co/api/v2/pokemon/890/"
    },
    {
      "name": "kubfu",
      "url": "https://pokeapi.co/api/v2/pokemon/891/"
    },
    {
      "name": "urshifu-single-strike",
      "url": "https://pokeapi.co/api/v2/pokemon/892/"
    },
    {
      "name": "zarude",
      "url": "https://pokeapi.co/api/v2/pokemon/893/"
    },
    {
      "name": "regieleki",
      "url": "https://pokeapi.co/api/v2/pokemon/894/"
    },
    {
      "name": "regidrago",
      "url": "https://pokeapi.co/api/v2/pokemon/895/"
    },
    {
      "name": "glastrier",
      "url": "https://pokeapi.co/api/v2/pokemon/896/"
    },
    {
      "name": "spectrier",
      "url": "https://pokeapi.co/api/v2/pokemon/897/"
    },
    {
      "name": "calyrex",
      "url": "https://pokeapi.co/api/v2/pokemon/898/"
    },
    {
      "name": "wyrdeer",
      "url": "https://pokeapi.co/api/v2/pokemon/899/"
    },
    {
      "name": "kleavor",
      "url": "https://pokeapi.co/api/v2/pokemon/900/"
    },
    {
      "name": "ursaluna",
      "url": "https://pokeapi.co/api/v2/pokemon/901/"
    },
    {
      "name": "basculegion-male",
      "url": "https://pokeapi.co/api/v2/pokemon/902/"
    },
    {
      "name": "sneasler",
      "url": "https://pokeapi.co/api/v2/pokemon/903/"
    },
    {
      "name": "overqwil",
      "url": "https://pokeapi.co/api/v2/pokemon/904/"
    },
    {
      "name": "enamorus-incarnate",
      "url": "https://pokeapi.co/api/v2/pokemon/905/"
    },
    {
      "name": "deoxys-attack",
      "url": "https://pokeapi.co/api/v2/pokemon/10001/"
    },
    {
      "name": "deoxys-defense",
      "url": "https://pokeapi.co/api/v2/pokemon/10002/"
    },
    {
      "name": "deoxys-speed",
      "url": "https://pokeapi.co/api/v2/pokemon/10003/"
    },
    {
      "name": "wormadam-sandy",
      "url": "https://pokeapi.co/api/v2/pokemon/10004/"
    },
    {
      "name": "wormadam-trash",
      "url": "https://pokeapi.co/api/v2/pokemon/10005/"
    },
    {
      "name": "shaymin-sky",
      "url": "https://pokeapi.co/api/v2/pokemon/10006/"
    },
    {
      "name": "giratina-origin",
      "url": "https://pokeapi.co/api/v2/pokemon/10007/"
    },
    {
      "name": "rotom-heat",
      "url": "https://pokeapi.co/api/v2/pokemon/10008/"
    },
    {
      "name": "rotom-wash",
      "url": "https://pokeapi.co/api/v2/pokemon/10009/"
    },
    {
      "name": "rotom-frost",
      "url": "https://pokeapi.co/api/v2/pokemon/10010/"
    },
    {
      "name": "rotom-fan",
      "url": "https://pokeapi.co/api/v2/pokemon/10011/"
    },
    {
      "name": "rotom-mow",
      "url": "https://pokeapi.co/api/v2/pokemon/10012/"
    },
    {
      "name": "castform-sunny",
      "url": "https://pokeapi.co/api/v2/pokemon/10013/"
    },
    {
      "name": "castform-rainy",
      "url": "https://pokeapi.co/api/v2/pokemon/10014/"
    },
    {
      "name": "castform-snowy",
      "url": "https://pokeapi.co/api/v2/pokemon/10015/"
    },
    {
      "name": "basculin-blue-striped",
      "url": "https://pokeapi.co/api/v2/pokemon/10016/"
    },
    {
      "name": "darmanitan-zen",
      "url": "https://pokeapi.co/api/v2/pokemon/10017/"
    },
    {
      "name": "meloetta-pirouette",
      "url": "https://pokeapi.co/api/v2/pokemon/10018/"
    },
    {
      "name": "tornadus-therian",
      "url": "https://pokeapi.co/api/v2/pokemon/10019/"
    },
    {
      "name": "thundurus-therian",
      "url": "https://pokeapi.co/api/v2/pokemon/10020/"
    },
    {
      "name": "landorus-therian",
      "url": "https://pokeapi.co/api/v2/pokemon/10021/"
    },
    {
      "name": "kyurem-black",
      "url": "https://pokeapi.co/api/v2/pokemon/10022/"
    },
    {
      "name": "kyurem-white",
      "url": "https://pokeapi.co/api/v2/pokemon/10023/"
    },
    {
      "name": "keldeo-resolute",
      "url": "https://pokeapi.co/api/v2/pokemon/10024/"
    },
    {
      "name": "meowstic-female",
      "url": "https://pokeapi.co/api/v2/pokemon/10025/"
    },
    {
      "name": "aegislash-blade",
      "url": "https://pokeapi.co/api/v2/pokemon/10026/"
    },
    {
      "name": "pumpkaboo-small",
      "url": "https://pokeapi.co/api/v2/pokemon/10027/"
    },
    {
      "name": "pumpkaboo-large",
      "url": "https://pokeapi.co/api/v2/pokemon/10028/"
    },
    {
      "name": "pumpkaboo-super",
      "url": "https://pokeapi.co/api/v2/pokemon/10029/"
    },
    {
      "name": "gourgeist-small",
      "url": "https://pokeapi.co/api/v2/pokemon/10030/"
    },
    {
      "name": "gourgeist-large",
      "url": "https://pokeapi.co/api/v2/pokemon/10031/"
    },
    {
      "name": "gourgeist-super",
      "url": "https://pokeapi.co/api/v2/pokemon/10032/"
    },
    {
      "name": "venusaur-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10033/"
    },
    {
      "name": "charizard-mega-x",
      "url": "https://pokeapi.co/api/v2/pokemon/10034/"
    },
    {
      "name": "charizard-mega-y",
      "url": "https://pokeapi.co/api/v2/pokemon/10035/"
    },
    {
      "name": "blastoise-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10036/"
    },
    {
      "name": "alakazam-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10037/"
    },
    {
      "name": "gengar-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10038/"
    },
    {
      "name": "kangaskhan-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10039/"
    },
    {
      "name": "pinsir-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10040/"
    },
    {
      "name": "gyarados-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10041/"
    },
    {
      "name": "aerodactyl-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10042/"
    },
    {
      "name": "mewtwo-mega-x",
      "url": "https://pokeapi.co/api/v2/pokemon/10043/"
    },
    {
      "name": "mewtwo-mega-y",
      "url": "https://pokeapi.co/api/v2/pokemon/10044/"
    },
    {
      "name": "ampharos-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10045/"
    },
    {
      "name": "scizor-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10046/"
    },
    {
      "name": "heracross-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10047/"
    },
    {
      "name": "houndoom-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10048/"
    },
    {
      "name": "tyranitar-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10049/"
    },
    {
      "name": "blaziken-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10050/"
    },
    {
      "name": "gardevoir-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10051/"
    },
    {
      "name": "mawile-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10052/"
    },
    {
      "name": "aggron-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10053/"
    },
    {
      "name": "medicham-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10054/"
    },
    {
      "name": "manectric-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10055/"
    },
    {
      "name": "banette-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10056/"
    },
    {
      "name": "absol-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10057/"
    },
    {
      "name": "garchomp-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10058/"
    },
    {
      "name": "lucario-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10059/"
    },
    {
      "name": "abomasnow-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10060/"
    },
    {
      "name": "floette-eternal",
      "url": "https://pokeapi.co/api/v2/pokemon/10061/"
    },
    {
      "name": "latias-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10062/"
    },
    {
      "name": "latios-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10063/"
    },
    {
      "name": "swampert-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10064/"
    },
    {
      "name": "sceptile-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10065/"
    },
    {
      "name": "sableye-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10066/"
    },
    {
      "name": "altaria-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10067/"
    },
    {
      "name": "gallade-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10068/"
    },
    {
      "name": "audino-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10069/"
    },
    {
      "name": "sharpedo-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10070/"
    },
    {
      "name": "slowbro-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10071/"
    },
    {
      "name": "steelix-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10072/"
    },
    {
      "name": "pidgeot-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10073/"
    },
    {
      "name": "glalie-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10074/"
    },
    {
      "name": "diancie-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10075/"
    },
    {
      "name": "metagross-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10076/"
    },
    {
      "name": "kyogre-primal",
      "url": "https://pokeapi.co/api/v2/pokemon/10077/"
    },
    {
      "name": "groudon-primal",
      "url": "https://pokeapi.co/api/v2/pokemon/10078/"
    },
    {
      "name": "rayquaza-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10079/"
    },
    {
      "name": "pikachu-rock-star",
      "url": "https://pokeapi.co/api/v2/pokemon/10080/"
    },
    {
      "name": "pikachu-belle",
      "url": "https://pokeapi.co/api/v2/pokemon/10081/"
    },
    {
      "name": "pikachu-pop-star",
      "url": "https://pokeapi.co/api/v2/pokemon/10082/"
    },
    {
      "name": "pikachu-phd",
      "url": "https://pokeapi.co/api/v2/pokemon/10083/"
    },
    {
      "name": "pikachu-libre",
      "url": "https://pokeapi.co/api/v2/pokemon/10084/"
    },
    {
      "name": "pikachu-cosplay",
      "url": "https://pokeapi.co/api/v2/pokemon/10085/"
    },
    {
      "name": "hoopa-unbound",
      "url": "https://pokeapi.co/api/v2/pokemon/10086/"
    },
    {
      "name": "camerupt-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10087/"
    },
    {
      "name": "lopunny-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10088/"
    },
    {
      "name": "salamence-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10089/"
    },
    {
      "name": "beedrill-mega",
      "url": "https://pokeapi.co/api/v2/pokemon/10090/"
    },
    {
      "name": "rattata-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10091/"
    },
    {
      "name": "raticate-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10092/"
    },
    {
      "name": "raticate-totem-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10093/"
    },
    {
      "name": "pikachu-original-cap",
      "url": "https://pokeapi.co/api/v2/pokemon/10094/"
    },
    {
      "name": "pikachu-hoenn-cap",
      "url": "https://pokeapi.co/api/v2/pokemon/10095/"
    },
    {
      "name": "pikachu-sinnoh-cap",
      "url": "https://pokeapi.co/api/v2/pokemon/10096/"
    },
    {
      "name": "pikachu-unova-cap",
      "url": "https://pokeapi.co/api/v2/pokemon/10097/"
    },
    {
      "name": "pikachu-kalos-cap",
      "url": "https://pokeapi.co/api/v2/pokemon/10098/"
    },
    {
      "name": "pikachu-alola-cap",
      "url": "https://pokeapi.co/api/v2/pokemon/10099/"
    },
    {
      "name": "raichu-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10100/"
    },
    {
      "name": "sandshrew-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10101/"
    },
    {
      "name": "sandslash-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10102/"
    },
    {
      "name": "vulpix-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10103/"
    },
    {
      "name": "ninetales-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10104/"
    },
    {
      "name": "diglett-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10105/"
    },
    {
      "name": "dugtrio-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10106/"
    },
    {
      "name": "meowth-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10107/"
    },
    {
      "name": "persian-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10108/"
    },
    {
      "name": "geodude-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10109/"
    },
    {
      "name": "graveler-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10110/"
    },
    {
      "name": "golem-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10111/"
    },
    {
      "name": "grimer-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10112/"
    },
    {
      "name": "muk-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10113/"
    },
    {
      "name": "exeggutor-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10114/"
    },
    {
      "name": "marowak-alola",
      "url": "https://pokeapi.co/api/v2/pokemon/10115/"
    },
    {
      "name": "greninja-battle-bond",
      "url": "https://pokeapi.co/api/v2/pokemon/10116/"
    },
    {
      "name": "greninja-ash",
      "url": "https://pokeapi.co/api/v2/pokemon/10117/"
    },
    {
      "name": "zygarde-10-power-construct",
      "url": "https://pokeapi.co/api/v2/pokemon/10118/"
    },
    {
      "name": "zygarde-50-power-construct",
      "url": "https://pokeapi.co/api/v2/pokemon/10119/"
    },
    {
      "name": "zygarde-complete",
      "url": "https://pokeapi.co/api/v2/pokemon/10120/"
    },
    {
      "name": "gumshoos-totem",
      "url": "https://pokeapi.co/api/v2/pokemon/10121/"
    },
    {
      "name": "vikavolt-totem",
      "url": "https://pokeapi.co/api/v2/pokemon/10122/"
    },
    {
      "name": "oricorio-pom-pom",
      "url": "https://pokeapi.co/api/v2/pokemon/10123/"
    },
    {
      "name": "oricorio-pau",
      "url": "https://pokeapi.co/api/v2/pokemon/10124/"
    },
    {
      "name": "oricorio-sensu",
      "url": "https://pokeapi.co/api/v2/pokemon/10125/"
    },
    {
      "name": "lycanroc-midnight",
      "url": "https://pokeapi.co/api/v2/pokemon/10126/"
    },
    {
      "name": "wishiwashi-school",
      "url": "https://pokeapi.co/api/v2/pokemon/10127/"
    },
    {
      "name": "lurantis-totem",
      "url": "https://pokeapi.co/api/v2/pokemon/10128/"
    },
    {
      "name": "salazzle-totem",
      "url": "https://pokeapi.co/api/v2/pokemon/10129/"
    },
    {
      "name": "minior-orange-meteor",
      "url": "https://pokeapi.co/api/v2/pokemon/10130/"
    },
    {
      "name": "minior-yellow-meteor",
      "url": "https://pokeapi.co/api/v2/pokemon/10131/"
    },
    {
      "name": "minior-green-meteor",
      "url": "https://pokeapi.co/api/v2/pokemon/10132/"
    },
    {
      "name": "minior-blue-meteor",
      "url": "https://pokeapi.co/api/v2/pokemon/10133/"
    },
    {
      "name": "minior-indigo-meteor",
      "url": "https://pokeapi.co/api/v2/pokemon/10134/"
    },
    {
      "name": "minior-violet-meteor",
      "url": "https://pokeapi.co/api/v2/pokemon/10135/"
    },
    {
      "name": "minior-red",
      "url": "https://pokeapi.co/api/v2/pokemon/10136/"
    },
    {
      "name": "minior-orange",
      "url": "https://pokeapi.co/api/v2/pokemon/10137/"
    },
    {
      "name": "minior-yellow",
      "url": "https://pokeapi.co/api/v2/pokemon/10138/"
    },
    {
      "name": "minior-green",
      "url": "https://pokeapi.co/api/v2/pokemon/10139/"
    },
    {
      "name": "minior-blue",
      "url": "https://pokeapi.co/api/v2/pokemon/10140/"
    },
    {
      "name": "minior-indigo",
      "url": "https://pokeapi.co/api/v2/pokemon/10141/"
    },
    {
      "name": "minior-violet",
      "url": "https://pokeapi.co/api/v2/pokemon/10142/"
    },
    {
      "name": "mimikyu-busted",
      "url": "https://pokeapi.co/api/v2/pokemon/10143/"
    },
    {
      "name": "mimikyu-totem-disguised",
      "url": "https://pokeapi.co/api/v2/pokemon/10144/"
    },
    {
      "name": "mimikyu-totem-busted",
      "url": "https://pokeapi.co/api/v2/pokemon/10145/"
    },
    {
      "name": "kommo-o-totem",
      "url": "https://pokeapi.co/api/v2/pokemon/10146/"
    },
    {
      "name": "magearna-original",
      "url": "https://pokeapi.co/api/v2/pokemon/10147/"
    },
    {
      "name": "pikachu-partner-cap",
      "url": "https://pokeapi.co/api/v2/pokemon/10148/"
    },
    {
      "name": "marowak-totem",
      "url": "https://pokeapi.co/api/v2/pokemon/10149/"
    },
    {
      "name": "ribombee-totem",
      "url": "https://pokeapi.co/api/v2/pokemon/10150/"
    },
    {
      "name": "rockruff-own-tempo",
      "url": "https://pokeapi.co/api/v2/pokemon/10151/"
    },
    {
      "name": "lycanroc-dusk",
      "url": "https://pokeapi.co/api/v2/pokemon/10152/"
    },
    {
      "name": "araquanid-totem",
      "url": "https://pokeapi.co/api/v2/pokemon/10153/"
    },
    {
      "name": "togedemaru-totem",
      "url": "https://pokeapi.co/api/v2/pokemon/10154/"
    },
    {
      "name": "necrozma-dusk",
      "url": "https://pokeapi.co/api/v2/pokemon/10155/"
    },
    {
      "name": "necrozma-dawn",
      "url": "https://pokeapi.co/api/v2/pokemon/10156/"
    },
    {
      "name": "necrozma-ultra",
      "url": "https://pokeapi.co/api/v2/pokemon/10157/"
    },
    {
      "name": "pikachu-starter",
      "url": "https://pokeapi.co/api/v2/pokemon/10158/"
    },
    {
      "name": "eevee-starter",
      "url": "https://pokeapi.co/api/v2/pokemon/10159/"
    },
    {
      "name": "pikachu-world-cap",
      "url": "https://pokeapi.co/api/v2/pokemon/10160/"
    },
    {
      "name": "meowth-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10161/"
    },
    {
      "name": "ponyta-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10162/"
    },
    {
      "name": "rapidash-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10163/"
    },
    {
      "name": "slowpoke-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10164/"
    },
    {
      "name": "slowbro-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10165/"
    },
    {
      "name": "farfetchd-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10166/"
    },
    {
      "name": "weezing-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10167/"
    },
    {
      "name": "mr-mime-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10168/"
    },
    {
      "name": "articuno-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10169/"
    },
    {
      "name": "zapdos-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10170/"
    },
    {
      "name": "moltres-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10171/"
    },
    {
      "name": "slowking-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10172/"
    },
    {
      "name": "corsola-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10173/"
    },
    {
      "name": "zigzagoon-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10174/"
    },
    {
      "name": "linoone-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10175/"
    },
    {
      "name": "darumaka-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10176/"
    },
    {
      "name": "darmanitan-galar-standard",
      "url": "https://pokeapi.co/api/v2/pokemon/10177/"
    },
    {
      "name": "darmanitan-galar-zen",
      "url": "https://pokeapi.co/api/v2/pokemon/10178/"
    },
    {
      "name": "yamask-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10179/"
    },
    {
      "name": "stunfisk-galar",
      "url": "https://pokeapi.co/api/v2/pokemon/10180/"
    },
    {
      "name": "zygarde-10",
      "url": "https://pokeapi.co/api/v2/pokemon/10181/"
    },
    {
      "name": "cramorant-gulping",
      "url": "https://pokeapi.co/api/v2/pokemon/10182/"
    },
    {
      "name": "cramorant-gorging",
      "url": "https://pokeapi.co/api/v2/pokemon/10183/"
    },
    {
      "name": "toxtricity-low-key",
      "url": "https://pokeapi.co/api/v2/pokemon/10184/"
    },
    {
      "name": "eiscue-noice",
      "url": "https://pokeapi.co/api/v2/pokemon/10185/"
    },
    {
      "name": "indeedee-female",
      "url": "https://pokeapi.co/api/v2/pokemon/10186/"
    },
    {
      "name": "morpeko-hangry",
      "url": "https://pokeapi.co/api/v2/pokemon/10187/"
    },
    {
      "name": "zacian-crowned",
      "url": "https://pokeapi.co/api/v2/pokemon/10188/"
    },
    {
      "name": "zamazenta-crowned",
      "url": "https://pokeapi.co/api/v2/pokemon/10189/"
    },
    {
      "name": "eternatus-eternamax",
      "url": "https://pokeapi.co/api/v2/pokemon/10190/"
    },
    {
      "name": "urshifu-rapid-strike",
      "url": "https://pokeapi.co/api/v2/pokemon/10191/"
    },
    {
      "name": "zarude-dada",
      "url": "https://pokeapi.co/api/v2/pokemon/10192/"
    },
    {
      "name": "calyrex-ice",
      "url": "https://pokeapi.co/api/v2/pokemon/10193/"
    },
    {
      "name": "calyrex-shadow",
      "url": "https://pokeapi.co/api/v2/pokemon/10194/"
    },
    {
      "name": "venusaur-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10195/"
    },
    {
      "name": "charizard-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10196/"
    },
    {
      "name": "blastoise-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10197/"
    },
    {
      "name": "butterfree-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10198/"
    },
    {
      "name": "pikachu-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10199/"
    },
    {
      "name": "meowth-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10200/"
    },
    {
      "name": "machamp-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10201/"
    },
    {
      "name": "gengar-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10202/"
    },
    {
      "name": "kingler-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10203/"
    },
    {
      "name": "lapras-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10204/"
    },
    {
      "name": "eevee-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10205/"
    },
    {
      "name": "snorlax-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10206/"
    },
    {
      "name": "garbodor-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10207/"
    },
    {
      "name": "melmetal-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10208/"
    },
    {
      "name": "rillaboom-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10209/"
    },
    {
      "name": "cinderace-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10210/"
    },
    {
      "name": "inteleon-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10211/"
    },
    {
      "name": "corviknight-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10212/"
    },
    {
      "name": "orbeetle-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10213/"
    },
    {
      "name": "drednaw-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10214/"
    },
    {
      "name": "coalossal-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10215/"
    },
    {
      "name": "flapple-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10216/"
    },
    {
      "name": "appletun-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10217/"
    },
    {
      "name": "sandaconda-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10218/"
    },
    {
      "name": "toxtricity-amped-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10219/"
    },
    {
      "name": "centiskorch-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10220/"
    },
    {
      "name": "hatterene-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10221/"
    },
    {
      "name": "grimmsnarl-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10222/"
    },
    {
      "name": "alcremie-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10223/"
    },
    {
      "name": "copperajah-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10224/"
    },
    {
      "name": "duraludon-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10225/"
    },
    {
      "name": "urshifu-single-strike-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10226/"
    },
    {
      "name": "urshifu-rapid-strike-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10227/"
    },
    {
      "name": "toxtricity-low-key-gmax",
      "url": "https://pokeapi.co/api/v2/pokemon/10228/"
    },
    {
      "name": "growlithe-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10229/"
    },
    {
      "name": "arcanine-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10230/"
    },
    {
      "name": "voltorb-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10231/"
    },
    {
      "name": "electrode-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10232/"
    },
    {
      "name": "typhlosion-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10233/"
    },
    {
      "name": "qwilfish-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10234/"
    },
    {
      "name": "sneasel-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10235/"
    },
    {
      "name": "samurott-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10236/"
    },
    {
      "name": "lilligant-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10237/"
    },
    {
      "name": "zorua-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10238/"
    },
    {
      "name": "zoroark-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10239/"
    },
    {
      "name": "braviary-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10240/"
    },
    {
      "name": "sliggoo-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10241/"
    },
    {
      "name": "goodra-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10242/"
    },
    {
      "name": "avalugg-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10243/"
    },
    {
      "name": "decidueye-hisui",
      "url": "https://pokeapi.co/api/v2/pokemon/10244/"
    },
    {
      "name": "dialga-origin",
      "url": "https://pokeapi.co/api/v2/pokemon/10245/"
    },
    {
      "name": "palkia-origin",
      "url": "https://pokeapi.co/api/v2/pokemon/10246/"
    },
    {
      "name": "basculin-white-striped",
      "url": "https://pokeapi.co/api/v2/pokemon/10247/"
    },
    {
      "name": "basculegion-female",
      "url": "https://pokeapi.co/api/v2/pokemon/10248/"
    },
    {
      "name": "enamorus-therian",
      "url": "https://pokeapi.co/api/v2/pokemon/10249/"
    }
  ]
};

export const pokeType = {
  "count": 20,
  "next": null,
  "previous": null,
  "results": [
    {
      "name": "normal",
      "url": "https://pokeapi.co/api/v2/type/1/"
    },
    {
      "name": "fighting",
      "url": "https://pokeapi.co/api/v2/type/2/"
    },
    {
      "name": "flying",
      "url": "https://pokeapi.co/api/v2/type/3/"
    },
    {
      "name": "poison",
      "url": "https://pokeapi.co/api/v2/type/4/"
    },
    {
      "name": "ground",
      "url": "https://pokeapi.co/api/v2/type/5/"
    },
    {
      "name": "rock",
      "url": "https://pokeapi.co/api/v2/type/6/"
    },
    {
      "name": "bug",
      "url": "https://pokeapi.co/api/v2/type/7/"
    },
    {
      "name": "ghost",
      "url": "https://pokeapi.co/api/v2/type/8/"
    },
    {
      "name": "steel",
      "url": "https://pokeapi.co/api/v2/type/9/"
    },
    {
      "name": "fire",
      "url": "https://pokeapi.co/api/v2/type/10/"
    },
    {
      "name": "water",
      "url": "https://pokeapi.co/api/v2/type/11/"
    },
    {
      "name": "grass",
      "url": "https://pokeapi.co/api/v2/type/12/"
    },
    {
      "name": "electric",
      "url": "https://pokeapi.co/api/v2/type/13/"
    },
    {
      "name": "psychic",
      "url": "https://pokeapi.co/api/v2/type/14/"
    },
    {
      "name": "ice",
      "url": "https://pokeapi.co/api/v2/type/15/"
    },
    {
      "name": "dragon",
      "url": "https://pokeapi.co/api/v2/type/16/"
    },
    {
      "name": "dark",
      "url": "https://pokeapi.co/api/v2/type/17/"
    },
    {
      "name": "fairy",
      "url": "https://pokeapi.co/api/v2/type/18/"
    },
    {
      "name": "unknown",
      "url": "https://pokeapi.co/api/v2/type/10001/"
    },
    {
      "name": "shadow",
      "url": "https://pokeapi.co/api/v2/type/10002/"
    }
  ]
}
export const pokeDex = {
  "count": 29,
  "next": "https://pokeapi.co/api/v2/pokedex/?offset=20&limit=9",
  "previous": null,
  "results": [
    {
      "name": "national",
      "url": "https://pokeapi.co/api/v2/pokedex/1/"
    },
    {
      "name": "kanto",
      "url": "https://pokeapi.co/api/v2/pokedex/2/"
    },
    {
      "name": "original-johto",
      "url": "https://pokeapi.co/api/v2/pokedex/3/"
    },
    {
      "name": "hoenn",
      "url": "https://pokeapi.co/api/v2/pokedex/4/"
    },
    {
      "name": "original-sinnoh",
      "url": "https://pokeapi.co/api/v2/pokedex/5/"
    },
    {
      "name": "extended-sinnoh",
      "url": "https://pokeapi.co/api/v2/pokedex/6/"
    },
    {
      "name": "updated-johto",
      "url": "https://pokeapi.co/api/v2/pokedex/7/"
    },
    {
      "name": "original-unova",
      "url": "https://pokeapi.co/api/v2/pokedex/8/"
    },
    {
      "name": "updated-unova",
      "url": "https://pokeapi.co/api/v2/pokedex/9/"
    },
    {
      "name": "conquest-gallery",
      "url": "https://pokeapi.co/api/v2/pokedex/11/"
    },
    {
      "name": "kalos-central",
      "url": "https://pokeapi.co/api/v2/pokedex/12/"
    },
    {
      "name": "kalos-coastal",
      "url": "https://pokeapi.co/api/v2/pokedex/13/"
    },
    {
      "name": "kalos-mountain",
      "url": "https://pokeapi.co/api/v2/pokedex/14/"
    },
    {
      "name": "updated-hoenn",
      "url": "https://pokeapi.co/api/v2/pokedex/15/"
    },
    {
      "name": "original-alola",
      "url": "https://pokeapi.co/api/v2/pokedex/16/"
    },
    {
      "name": "original-melemele",
      "url": "https://pokeapi.co/api/v2/pokedex/17/"
    },
    {
      "name": "original-akala",
      "url": "https://pokeapi.co/api/v2/pokedex/18/"
    },
    {
      "name": "original-ulaula",
      "url": "https://pokeapi.co/api/v2/pokedex/19/"
    },
    {
      "name": "original-poni",
      "url": "https://pokeapi.co/api/v2/pokedex/20/"
    },
    {
      "name": "updated-alola",
      "url": "https://pokeapi.co/api/v2/pokedex/21/"
    },
    {
      "name": "updated-melemele",
      "url": "https://pokeapi.co/api/v2/pokedex/22/"
    },
    {
      "name": "updated-akala",
      "url": "https://pokeapi.co/api/v2/pokedex/23/"
    },
    {
      "name": "updated-ulaula",
      "url": "https://pokeapi.co/api/v2/pokedex/24/"
    },
    {
      "name": "updated-poni",
      "url": "https://pokeapi.co/api/v2/pokedex/25/"
    },
    {
      "name": "letsgo-kanto",
      "url": "https://pokeapi.co/api/v2/pokedex/26/"
    },
    {
      "name": "galar",
      "url": "https://pokeapi.co/api/v2/pokedex/27/"
    },
    {
      "name": "isle-of-armor",
      "url": "https://pokeapi.co/api/v2/pokedex/28/"
    },
    {
      "name": "crown-tundra",
      "url": "https://pokeapi.co/api/v2/pokedex/29/"
    },
    {
      "name": "hisui",
      "url": "https://pokeapi.co/api/v2/pokedex/30/"
    }
  ]
}

export const pokeItemData = {
  "count": 2050,
  "next": null,
  "previous": null,
  "results": [
    {
      "name": "master-ball",
      "url": "https://pokeapi.co/api/v2/item/1/"
    },
    {
      "name": "ultra-ball",
      "url": "https://pokeapi.co/api/v2/item/2/"
    },
    {
      "name": "great-ball",
      "url": "https://pokeapi.co/api/v2/item/3/"
    },
    {
      "name": "poke-ball",
      "url": "https://pokeapi.co/api/v2/item/4/"
    },
    {
      "name": "safari-ball",
      "url": "https://pokeapi.co/api/v2/item/5/"
    },
    {
      "name": "net-ball",
      "url": "https://pokeapi.co/api/v2/item/6/"
    },
    {
      "name": "dive-ball",
      "url": "https://pokeapi.co/api/v2/item/7/"
    },
    {
      "name": "nest-ball",
      "url": "https://pokeapi.co/api/v2/item/8/"
    },
    {
      "name": "repeat-ball",
      "url": "https://pokeapi.co/api/v2/item/9/"
    },
    {
      "name": "timer-ball",
      "url": "https://pokeapi.co/api/v2/item/10/"
    },
    {
      "name": "luxury-ball",
      "url": "https://pokeapi.co/api/v2/item/11/"
    },
    {
      "name": "premier-ball",
      "url": "https://pokeapi.co/api/v2/item/12/"
    },
    {
      "name": "dusk-ball",
      "url": "https://pokeapi.co/api/v2/item/13/"
    },
    {
      "name": "heal-ball",
      "url": "https://pokeapi.co/api/v2/item/14/"
    },
    {
      "name": "quick-ball",
      "url": "https://pokeapi.co/api/v2/item/15/"
    },
    {
      "name": "cherish-ball",
      "url": "https://pokeapi.co/api/v2/item/16/"
    },
    {
      "name": "potion",
      "url": "https://pokeapi.co/api/v2/item/17/"
    },
    {
      "name": "antidote",
      "url": "https://pokeapi.co/api/v2/item/18/"
    },
    {
      "name": "burn-heal",
      "url": "https://pokeapi.co/api/v2/item/19/"
    },
    {
      "name": "ice-heal",
      "url": "https://pokeapi.co/api/v2/item/20/"
    },
    {
      "name": "awakening",
      "url": "https://pokeapi.co/api/v2/item/21/"
    },
    {
      "name": "paralyze-heal",
      "url": "https://pokeapi.co/api/v2/item/22/"
    },
    {
      "name": "full-restore",
      "url": "https://pokeapi.co/api/v2/item/23/"
    },
    {
      "name": "max-potion",
      "url": "https://pokeapi.co/api/v2/item/24/"
    },
    {
      "name": "hyper-potion",
      "url": "https://pokeapi.co/api/v2/item/25/"
    },
    {
      "name": "super-potion",
      "url": "https://pokeapi.co/api/v2/item/26/"
    },
    {
      "name": "full-heal",
      "url": "https://pokeapi.co/api/v2/item/27/"
    },
    {
      "name": "revive",
      "url": "https://pokeapi.co/api/v2/item/28/"
    },
    {
      "name": "max-revive",
      "url": "https://pokeapi.co/api/v2/item/29/"
    },
    {
      "name": "fresh-water",
      "url": "https://pokeapi.co/api/v2/item/30/"
    },
    {
      "name": "soda-pop",
      "url": "https://pokeapi.co/api/v2/item/31/"
    },
    {
      "name": "lemonade",
      "url": "https://pokeapi.co/api/v2/item/32/"
    },
    {
      "name": "moomoo-milk",
      "url": "https://pokeapi.co/api/v2/item/33/"
    },
    {
      "name": "energy-powder",
      "url": "https://pokeapi.co/api/v2/item/34/"
    },
    {
      "name": "energy-root",
      "url": "https://pokeapi.co/api/v2/item/35/"
    },
    {
      "name": "heal-powder",
      "url": "https://pokeapi.co/api/v2/item/36/"
    },
    {
      "name": "revival-herb",
      "url": "https://pokeapi.co/api/v2/item/37/"
    },
    {
      "name": "ether",
      "url": "https://pokeapi.co/api/v2/item/38/"
    },
    {
      "name": "max-ether",
      "url": "https://pokeapi.co/api/v2/item/39/"
    },
    {
      "name": "elixir",
      "url": "https://pokeapi.co/api/v2/item/40/"
    },
    {
      "name": "max-elixir",
      "url": "https://pokeapi.co/api/v2/item/41/"
    },
    {
      "name": "lava-cookie",
      "url": "https://pokeapi.co/api/v2/item/42/"
    },
    {
      "name": "berry-juice",
      "url": "https://pokeapi.co/api/v2/item/43/"
    },
    {
      "name": "sacred-ash",
      "url": "https://pokeapi.co/api/v2/item/44/"
    },
    {
      "name": "hp-up",
      "url": "https://pokeapi.co/api/v2/item/45/"
    },
    {
      "name": "protein",
      "url": "https://pokeapi.co/api/v2/item/46/"
    },
    {
      "name": "iron",
      "url": "https://pokeapi.co/api/v2/item/47/"
    },
    {
      "name": "carbos",
      "url": "https://pokeapi.co/api/v2/item/48/"
    },
    {
      "name": "calcium",
      "url": "https://pokeapi.co/api/v2/item/49/"
    },
    {
      "name": "rare-candy",
      "url": "https://pokeapi.co/api/v2/item/50/"
    },
    {
      "name": "pp-up",
      "url": "https://pokeapi.co/api/v2/item/51/"
    },
    {
      "name": "zinc",
      "url": "https://pokeapi.co/api/v2/item/52/"
    },
    {
      "name": "pp-max",
      "url": "https://pokeapi.co/api/v2/item/53/"
    },
    {
      "name": "old-gateau",
      "url": "https://pokeapi.co/api/v2/item/54/"
    },
    {
      "name": "guard-spec",
      "url": "https://pokeapi.co/api/v2/item/55/"
    },
    {
      "name": "dire-hit",
      "url": "https://pokeapi.co/api/v2/item/56/"
    },
    {
      "name": "x-attack",
      "url": "https://pokeapi.co/api/v2/item/57/"
    },
    {
      "name": "x-defense",
      "url": "https://pokeapi.co/api/v2/item/58/"
    },
    {
      "name": "x-speed",
      "url": "https://pokeapi.co/api/v2/item/59/"
    },
    {
      "name": "x-accuracy",
      "url": "https://pokeapi.co/api/v2/item/60/"
    },
    {
      "name": "x-sp-atk",
      "url": "https://pokeapi.co/api/v2/item/61/"
    },
    {
      "name": "x-sp-def",
      "url": "https://pokeapi.co/api/v2/item/62/"
    },
    {
      "name": "poke-doll",
      "url": "https://pokeapi.co/api/v2/item/63/"
    },
    {
      "name": "fluffy-tail",
      "url": "https://pokeapi.co/api/v2/item/64/"
    },
    {
      "name": "blue-flute",
      "url": "https://pokeapi.co/api/v2/item/65/"
    },
    {
      "name": "yellow-flute",
      "url": "https://pokeapi.co/api/v2/item/66/"
    },
    {
      "name": "red-flute",
      "url": "https://pokeapi.co/api/v2/item/67/"
    },
    {
      "name": "black-flute",
      "url": "https://pokeapi.co/api/v2/item/68/"
    },
    {
      "name": "white-flute",
      "url": "https://pokeapi.co/api/v2/item/69/"
    },
    {
      "name": "shoal-salt",
      "url": "https://pokeapi.co/api/v2/item/70/"
    },
    {
      "name": "shoal-shell",
      "url": "https://pokeapi.co/api/v2/item/71/"
    },
    {
      "name": "red-shard",
      "url": "https://pokeapi.co/api/v2/item/72/"
    },
    {
      "name": "blue-shard",
      "url": "https://pokeapi.co/api/v2/item/73/"
    },
    {
      "name": "yellow-shard",
      "url": "https://pokeapi.co/api/v2/item/74/"
    },
    {
      "name": "green-shard",
      "url": "https://pokeapi.co/api/v2/item/75/"
    },
    {
      "name": "super-repel",
      "url": "https://pokeapi.co/api/v2/item/76/"
    },
    {
      "name": "max-repel",
      "url": "https://pokeapi.co/api/v2/item/77/"
    },
    {
      "name": "escape-rope",
      "url": "https://pokeapi.co/api/v2/item/78/"
    },
    {
      "name": "repel",
      "url": "https://pokeapi.co/api/v2/item/79/"
    },
    {
      "name": "sun-stone",
      "url": "https://pokeapi.co/api/v2/item/80/"
    },
    {
      "name": "moon-stone",
      "url": "https://pokeapi.co/api/v2/item/81/"
    },
    {
      "name": "fire-stone",
      "url": "https://pokeapi.co/api/v2/item/82/"
    },
    {
      "name": "thunder-stone",
      "url": "https://pokeapi.co/api/v2/item/83/"
    },
    {
      "name": "water-stone",
      "url": "https://pokeapi.co/api/v2/item/84/"
    },
    {
      "name": "leaf-stone",
      "url": "https://pokeapi.co/api/v2/item/85/"
    },
    {
      "name": "tiny-mushroom",
      "url": "https://pokeapi.co/api/v2/item/86/"
    },
    {
      "name": "big-mushroom",
      "url": "https://pokeapi.co/api/v2/item/87/"
    },
    {
      "name": "pearl",
      "url": "https://pokeapi.co/api/v2/item/88/"
    },
    {
      "name": "big-pearl",
      "url": "https://pokeapi.co/api/v2/item/89/"
    },
    {
      "name": "stardust",
      "url": "https://pokeapi.co/api/v2/item/90/"
    },
    {
      "name": "star-piece",
      "url": "https://pokeapi.co/api/v2/item/91/"
    },
    {
      "name": "nugget",
      "url": "https://pokeapi.co/api/v2/item/92/"
    },
    {
      "name": "heart-scale",
      "url": "https://pokeapi.co/api/v2/item/93/"
    },
    {
      "name": "honey",
      "url": "https://pokeapi.co/api/v2/item/94/"
    },
    {
      "name": "growth-mulch",
      "url": "https://pokeapi.co/api/v2/item/95/"
    },
    {
      "name": "damp-mulch",
      "url": "https://pokeapi.co/api/v2/item/96/"
    },
    {
      "name": "stable-mulch",
      "url": "https://pokeapi.co/api/v2/item/97/"
    },
    {
      "name": "gooey-mulch",
      "url": "https://pokeapi.co/api/v2/item/98/"
    },
    {
      "name": "root-fossil",
      "url": "https://pokeapi.co/api/v2/item/99/"
    },
    {
      "name": "claw-fossil",
      "url": "https://pokeapi.co/api/v2/item/100/"
    },
    {
      "name": "helix-fossil",
      "url": "https://pokeapi.co/api/v2/item/101/"
    },
    {
      "name": "dome-fossil",
      "url": "https://pokeapi.co/api/v2/item/102/"
    },
    {
      "name": "old-amber",
      "url": "https://pokeapi.co/api/v2/item/103/"
    },
    {
      "name": "armor-fossil",
      "url": "https://pokeapi.co/api/v2/item/104/"
    },
    {
      "name": "skull-fossil",
      "url": "https://pokeapi.co/api/v2/item/105/"
    },
    {
      "name": "rare-bone",
      "url": "https://pokeapi.co/api/v2/item/106/"
    },
    {
      "name": "shiny-stone",
      "url": "https://pokeapi.co/api/v2/item/107/"
    },
    {
      "name": "dusk-stone",
      "url": "https://pokeapi.co/api/v2/item/108/"
    },
    {
      "name": "dawn-stone",
      "url": "https://pokeapi.co/api/v2/item/109/"
    },
    {
      "name": "oval-stone",
      "url": "https://pokeapi.co/api/v2/item/110/"
    },
    {
      "name": "odd-keystone",
      "url": "https://pokeapi.co/api/v2/item/111/"
    },
    {
      "name": "adamant-orb",
      "url": "https://pokeapi.co/api/v2/item/112/"
    },
    {
      "name": "lustrous-orb",
      "url": "https://pokeapi.co/api/v2/item/113/"
    },
    {
      "name": "grass-mail",
      "url": "https://pokeapi.co/api/v2/item/114/"
    },
    {
      "name": "flame-mail",
      "url": "https://pokeapi.co/api/v2/item/115/"
    },
    {
      "name": "bubble-mail",
      "url": "https://pokeapi.co/api/v2/item/116/"
    },
    {
      "name": "bloom-mail",
      "url": "https://pokeapi.co/api/v2/item/117/"
    },
    {
      "name": "tunnel-mail",
      "url": "https://pokeapi.co/api/v2/item/118/"
    },
    {
      "name": "steel-mail",
      "url": "https://pokeapi.co/api/v2/item/119/"
    },
    {
      "name": "heart-mail",
      "url": "https://pokeapi.co/api/v2/item/120/"
    },
    {
      "name": "snow-mail",
      "url": "https://pokeapi.co/api/v2/item/121/"
    },
    {
      "name": "space-mail",
      "url": "https://pokeapi.co/api/v2/item/122/"
    },
    {
      "name": "air-mail",
      "url": "https://pokeapi.co/api/v2/item/123/"
    },
    {
      "name": "mosaic-mail",
      "url": "https://pokeapi.co/api/v2/item/124/"
    },
    {
      "name": "brick-mail",
      "url": "https://pokeapi.co/api/v2/item/125/"
    },
    {
      "name": "cheri-berry",
      "url": "https://pokeapi.co/api/v2/item/126/"
    },
    {
      "name": "chesto-berry",
      "url": "https://pokeapi.co/api/v2/item/127/"
    },
    {
      "name": "pecha-berry",
      "url": "https://pokeapi.co/api/v2/item/128/"
    },
    {
      "name": "rawst-berry",
      "url": "https://pokeapi.co/api/v2/item/129/"
    },
    {
      "name": "aspear-berry",
      "url": "https://pokeapi.co/api/v2/item/130/"
    },
    {
      "name": "leppa-berry",
      "url": "https://pokeapi.co/api/v2/item/131/"
    },
    {
      "name": "oran-berry",
      "url": "https://pokeapi.co/api/v2/item/132/"
    },
    {
      "name": "persim-berry",
      "url": "https://pokeapi.co/api/v2/item/133/"
    },
    {
      "name": "lum-berry",
      "url": "https://pokeapi.co/api/v2/item/134/"
    },
    {
      "name": "sitrus-berry",
      "url": "https://pokeapi.co/api/v2/item/135/"
    },
    {
      "name": "figy-berry",
      "url": "https://pokeapi.co/api/v2/item/136/"
    },
    {
      "name": "wiki-berry",
      "url": "https://pokeapi.co/api/v2/item/137/"
    },
    {
      "name": "mago-berry",
      "url": "https://pokeapi.co/api/v2/item/138/"
    },
    {
      "name": "aguav-berry",
      "url": "https://pokeapi.co/api/v2/item/139/"
    },
    {
      "name": "iapapa-berry",
      "url": "https://pokeapi.co/api/v2/item/140/"
    },
    {
      "name": "razz-berry",
      "url": "https://pokeapi.co/api/v2/item/141/"
    },
    {
      "name": "bluk-berry",
      "url": "https://pokeapi.co/api/v2/item/142/"
    },
    {
      "name": "nanab-berry",
      "url": "https://pokeapi.co/api/v2/item/143/"
    },
    {
      "name": "wepear-berry",
      "url": "https://pokeapi.co/api/v2/item/144/"
    },
    {
      "name": "pinap-berry",
      "url": "https://pokeapi.co/api/v2/item/145/"
    },
    {
      "name": "pomeg-berry",
      "url": "https://pokeapi.co/api/v2/item/146/"
    },
    {
      "name": "kelpsy-berry",
      "url": "https://pokeapi.co/api/v2/item/147/"
    },
    {
      "name": "qualot-berry",
      "url": "https://pokeapi.co/api/v2/item/148/"
    },
    {
      "name": "hondew-berry",
      "url": "https://pokeapi.co/api/v2/item/149/"
    },
    {
      "name": "grepa-berry",
      "url": "https://pokeapi.co/api/v2/item/150/"
    },
    {
      "name": "tamato-berry",
      "url": "https://pokeapi.co/api/v2/item/151/"
    },
    {
      "name": "cornn-berry",
      "url": "https://pokeapi.co/api/v2/item/152/"
    },
    {
      "name": "magost-berry",
      "url": "https://pokeapi.co/api/v2/item/153/"
    },
    {
      "name": "rabuta-berry",
      "url": "https://pokeapi.co/api/v2/item/154/"
    },
    {
      "name": "nomel-berry",
      "url": "https://pokeapi.co/api/v2/item/155/"
    },
    {
      "name": "spelon-berry",
      "url": "https://pokeapi.co/api/v2/item/156/"
    },
    {
      "name": "pamtre-berry",
      "url": "https://pokeapi.co/api/v2/item/157/"
    },
    {
      "name": "watmel-berry",
      "url": "https://pokeapi.co/api/v2/item/158/"
    },
    {
      "name": "durin-berry",
      "url": "https://pokeapi.co/api/v2/item/159/"
    },
    {
      "name": "belue-berry",
      "url": "https://pokeapi.co/api/v2/item/160/"
    },
    {
      "name": "occa-berry",
      "url": "https://pokeapi.co/api/v2/item/161/"
    },
    {
      "name": "passho-berry",
      "url": "https://pokeapi.co/api/v2/item/162/"
    },
    {
      "name": "wacan-berry",
      "url": "https://pokeapi.co/api/v2/item/163/"
    },
    {
      "name": "rindo-berry",
      "url": "https://pokeapi.co/api/v2/item/164/"
    },
    {
      "name": "yache-berry",
      "url": "https://pokeapi.co/api/v2/item/165/"
    },
    {
      "name": "chople-berry",
      "url": "https://pokeapi.co/api/v2/item/166/"
    },
    {
      "name": "kebia-berry",
      "url": "https://pokeapi.co/api/v2/item/167/"
    },
    {
      "name": "shuca-berry",
      "url": "https://pokeapi.co/api/v2/item/168/"
    },
    {
      "name": "coba-berry",
      "url": "https://pokeapi.co/api/v2/item/169/"
    },
    {
      "name": "payapa-berry",
      "url": "https://pokeapi.co/api/v2/item/170/"
    },
    {
      "name": "tanga-berry",
      "url": "https://pokeapi.co/api/v2/item/171/"
    },
    {
      "name": "charti-berry",
      "url": "https://pokeapi.co/api/v2/item/172/"
    },
    {
      "name": "kasib-berry",
      "url": "https://pokeapi.co/api/v2/item/173/"
    },
    {
      "name": "haban-berry",
      "url": "https://pokeapi.co/api/v2/item/174/"
    },
    {
      "name": "colbur-berry",
      "url": "https://pokeapi.co/api/v2/item/175/"
    },
    {
      "name": "babiri-berry",
      "url": "https://pokeapi.co/api/v2/item/176/"
    },
    {
      "name": "chilan-berry",
      "url": "https://pokeapi.co/api/v2/item/177/"
    },
    {
      "name": "liechi-berry",
      "url": "https://pokeapi.co/api/v2/item/178/"
    },
    {
      "name": "ganlon-berry",
      "url": "https://pokeapi.co/api/v2/item/179/"
    },
    {
      "name": "salac-berry",
      "url": "https://pokeapi.co/api/v2/item/180/"
    },
    {
      "name": "petaya-berry",
      "url": "https://pokeapi.co/api/v2/item/181/"
    },
    {
      "name": "apicot-berry",
      "url": "https://pokeapi.co/api/v2/item/182/"
    },
    {
      "name": "lansat-berry",
      "url": "https://pokeapi.co/api/v2/item/183/"
    },
    {
      "name": "starf-berry",
      "url": "https://pokeapi.co/api/v2/item/184/"
    },
    {
      "name": "enigma-berry",
      "url": "https://pokeapi.co/api/v2/item/185/"
    },
    {
      "name": "micle-berry",
      "url": "https://pokeapi.co/api/v2/item/186/"
    },
    {
      "name": "custap-berry",
      "url": "https://pokeapi.co/api/v2/item/187/"
    },
    {
      "name": "jaboca-berry",
      "url": "https://pokeapi.co/api/v2/item/188/"
    },
    {
      "name": "rowap-berry",
      "url": "https://pokeapi.co/api/v2/item/189/"
    },
    {
      "name": "bright-powder",
      "url": "https://pokeapi.co/api/v2/item/190/"
    },
    {
      "name": "white-herb",
      "url": "https://pokeapi.co/api/v2/item/191/"
    },
    {
      "name": "macho-brace",
      "url": "https://pokeapi.co/api/v2/item/192/"
    },
    {
      "name": "exp-share",
      "url": "https://pokeapi.co/api/v2/item/193/"
    },
    {
      "name": "quick-claw",
      "url": "https://pokeapi.co/api/v2/item/194/"
    },
    {
      "name": "soothe-bell",
      "url": "https://pokeapi.co/api/v2/item/195/"
    },
    {
      "name": "mental-herb",
      "url": "https://pokeapi.co/api/v2/item/196/"
    },
    {
      "name": "choice-band",
      "url": "https://pokeapi.co/api/v2/item/197/"
    },
    {
      "name": "kings-rock",
      "url": "https://pokeapi.co/api/v2/item/198/"
    },
    {
      "name": "silver-powder",
      "url": "https://pokeapi.co/api/v2/item/199/"
    },
    {
      "name": "amulet-coin",
      "url": "https://pokeapi.co/api/v2/item/200/"
    },
    {
      "name": "cleanse-tag",
      "url": "https://pokeapi.co/api/v2/item/201/"
    },
    {
      "name": "soul-dew",
      "url": "https://pokeapi.co/api/v2/item/202/"
    },
    {
      "name": "deep-sea-tooth",
      "url": "https://pokeapi.co/api/v2/item/203/"
    },
    {
      "name": "deep-sea-scale",
      "url": "https://pokeapi.co/api/v2/item/204/"
    },
    {
      "name": "smoke-ball",
      "url": "https://pokeapi.co/api/v2/item/205/"
    },
    {
      "name": "everstone",
      "url": "https://pokeapi.co/api/v2/item/206/"
    },
    {
      "name": "focus-band",
      "url": "https://pokeapi.co/api/v2/item/207/"
    },
    {
      "name": "lucky-egg",
      "url": "https://pokeapi.co/api/v2/item/208/"
    },
    {
      "name": "scope-lens",
      "url": "https://pokeapi.co/api/v2/item/209/"
    },
    {
      "name": "metal-coat",
      "url": "https://pokeapi.co/api/v2/item/210/"
    },
    {
      "name": "leftovers",
      "url": "https://pokeapi.co/api/v2/item/211/"
    },
    {
      "name": "dragon-scale",
      "url": "https://pokeapi.co/api/v2/item/212/"
    },
    {
      "name": "light-ball",
      "url": "https://pokeapi.co/api/v2/item/213/"
    },
    {
      "name": "soft-sand",
      "url": "https://pokeapi.co/api/v2/item/214/"
    },
    {
      "name": "hard-stone",
      "url": "https://pokeapi.co/api/v2/item/215/"
    },
    {
      "name": "miracle-seed",
      "url": "https://pokeapi.co/api/v2/item/216/"
    },
    {
      "name": "black-glasses",
      "url": "https://pokeapi.co/api/v2/item/217/"
    },
    {
      "name": "black-belt",
      "url": "https://pokeapi.co/api/v2/item/218/"
    },
    {
      "name": "magnet",
      "url": "https://pokeapi.co/api/v2/item/219/"
    },
    {
      "name": "mystic-water",
      "url": "https://pokeapi.co/api/v2/item/220/"
    },
    {
      "name": "sharp-beak",
      "url": "https://pokeapi.co/api/v2/item/221/"
    },
    {
      "name": "poison-barb",
      "url": "https://pokeapi.co/api/v2/item/222/"
    },
    {
      "name": "never-melt-ice",
      "url": "https://pokeapi.co/api/v2/item/223/"
    },
    {
      "name": "spell-tag",
      "url": "https://pokeapi.co/api/v2/item/224/"
    },
    {
      "name": "twisted-spoon",
      "url": "https://pokeapi.co/api/v2/item/225/"
    },
    {
      "name": "charcoal",
      "url": "https://pokeapi.co/api/v2/item/226/"
    },
    {
      "name": "dragon-fang",
      "url": "https://pokeapi.co/api/v2/item/227/"
    },
    {
      "name": "silk-scarf",
      "url": "https://pokeapi.co/api/v2/item/228/"
    },
    {
      "name": "up-grade",
      "url": "https://pokeapi.co/api/v2/item/229/"
    },
    {
      "name": "shell-bell",
      "url": "https://pokeapi.co/api/v2/item/230/"
    },
    {
      "name": "sea-incense",
      "url": "https://pokeapi.co/api/v2/item/231/"
    },
    {
      "name": "lax-incense",
      "url": "https://pokeapi.co/api/v2/item/232/"
    },
    {
      "name": "lucky-punch",
      "url": "https://pokeapi.co/api/v2/item/233/"
    },
    {
      "name": "metal-powder",
      "url": "https://pokeapi.co/api/v2/item/234/"
    },
    {
      "name": "thick-club",
      "url": "https://pokeapi.co/api/v2/item/235/"
    },
    {
      "name": "stick",
      "url": "https://pokeapi.co/api/v2/item/236/"
    },
    {
      "name": "red-scarf",
      "url": "https://pokeapi.co/api/v2/item/237/"
    },
    {
      "name": "blue-scarf",
      "url": "https://pokeapi.co/api/v2/item/238/"
    },
    {
      "name": "pink-scarf",
      "url": "https://pokeapi.co/api/v2/item/239/"
    },
    {
      "name": "green-scarf",
      "url": "https://pokeapi.co/api/v2/item/240/"
    },
    {
      "name": "yellow-scarf",
      "url": "https://pokeapi.co/api/v2/item/241/"
    },
    {
      "name": "wide-lens",
      "url": "https://pokeapi.co/api/v2/item/242/"
    },
    {
      "name": "muscle-band",
      "url": "https://pokeapi.co/api/v2/item/243/"
    },
    {
      "name": "wise-glasses",
      "url": "https://pokeapi.co/api/v2/item/244/"
    },
    {
      "name": "expert-belt",
      "url": "https://pokeapi.co/api/v2/item/245/"
    },
    {
      "name": "light-clay",
      "url": "https://pokeapi.co/api/v2/item/246/"
    },
    {
      "name": "life-orb",
      "url": "https://pokeapi.co/api/v2/item/247/"
    },
    {
      "name": "power-herb",
      "url": "https://pokeapi.co/api/v2/item/248/"
    },
    {
      "name": "toxic-orb",
      "url": "https://pokeapi.co/api/v2/item/249/"
    },
    {
      "name": "flame-orb",
      "url": "https://pokeapi.co/api/v2/item/250/"
    },
    {
      "name": "quick-powder",
      "url": "https://pokeapi.co/api/v2/item/251/"
    },
    {
      "name": "focus-sash",
      "url": "https://pokeapi.co/api/v2/item/252/"
    },
    {
      "name": "zoom-lens",
      "url": "https://pokeapi.co/api/v2/item/253/"
    },
    {
      "name": "metronome",
      "url": "https://pokeapi.co/api/v2/item/254/"
    },
    {
      "name": "iron-ball",
      "url": "https://pokeapi.co/api/v2/item/255/"
    },
    {
      "name": "lagging-tail",
      "url": "https://pokeapi.co/api/v2/item/256/"
    },
    {
      "name": "destiny-knot",
      "url": "https://pokeapi.co/api/v2/item/257/"
    },
    {
      "name": "black-sludge",
      "url": "https://pokeapi.co/api/v2/item/258/"
    },
    {
      "name": "icy-rock",
      "url": "https://pokeapi.co/api/v2/item/259/"
    },
    {
      "name": "smooth-rock",
      "url": "https://pokeapi.co/api/v2/item/260/"
    },
    {
      "name": "heat-rock",
      "url": "https://pokeapi.co/api/v2/item/261/"
    },
    {
      "name": "damp-rock",
      "url": "https://pokeapi.co/api/v2/item/262/"
    },
    {
      "name": "grip-claw",
      "url": "https://pokeapi.co/api/v2/item/263/"
    },
    {
      "name": "choice-scarf",
      "url": "https://pokeapi.co/api/v2/item/264/"
    },
    {
      "name": "sticky-barb",
      "url": "https://pokeapi.co/api/v2/item/265/"
    },
    {
      "name": "power-bracer",
      "url": "https://pokeapi.co/api/v2/item/266/"
    },
    {
      "name": "power-belt",
      "url": "https://pokeapi.co/api/v2/item/267/"
    },
    {
      "name": "power-lens",
      "url": "https://pokeapi.co/api/v2/item/268/"
    },
    {
      "name": "power-band",
      "url": "https://pokeapi.co/api/v2/item/269/"
    },
    {
      "name": "power-anklet",
      "url": "https://pokeapi.co/api/v2/item/270/"
    },
    {
      "name": "power-weight",
      "url": "https://pokeapi.co/api/v2/item/271/"
    },
    {
      "name": "shed-shell",
      "url": "https://pokeapi.co/api/v2/item/272/"
    },
    {
      "name": "big-root",
      "url": "https://pokeapi.co/api/v2/item/273/"
    },
    {
      "name": "choice-specs",
      "url": "https://pokeapi.co/api/v2/item/274/"
    },
    {
      "name": "flame-plate",
      "url": "https://pokeapi.co/api/v2/item/275/"
    },
    {
      "name": "splash-plate",
      "url": "https://pokeapi.co/api/v2/item/276/"
    },
    {
      "name": "zap-plate",
      "url": "https://pokeapi.co/api/v2/item/277/"
    },
    {
      "name": "meadow-plate",
      "url": "https://pokeapi.co/api/v2/item/278/"
    },
    {
      "name": "icicle-plate",
      "url": "https://pokeapi.co/api/v2/item/279/"
    },
    {
      "name": "fist-plate",
      "url": "https://pokeapi.co/api/v2/item/280/"
    },
    {
      "name": "toxic-plate",
      "url": "https://pokeapi.co/api/v2/item/281/"
    },
    {
      "name": "earth-plate",
      "url": "https://pokeapi.co/api/v2/item/282/"
    },
    {
      "name": "sky-plate",
      "url": "https://pokeapi.co/api/v2/item/283/"
    },
    {
      "name": "mind-plate",
      "url": "https://pokeapi.co/api/v2/item/284/"
    },
    {
      "name": "insect-plate",
      "url": "https://pokeapi.co/api/v2/item/285/"
    },
    {
      "name": "stone-plate",
      "url": "https://pokeapi.co/api/v2/item/286/"
    },
    {
      "name": "spooky-plate",
      "url": "https://pokeapi.co/api/v2/item/287/"
    },
    {
      "name": "draco-plate",
      "url": "https://pokeapi.co/api/v2/item/288/"
    },
    {
      "name": "dread-plate",
      "url": "https://pokeapi.co/api/v2/item/289/"
    },
    {
      "name": "iron-plate",
      "url": "https://pokeapi.co/api/v2/item/290/"
    },
    {
      "name": "odd-incense",
      "url": "https://pokeapi.co/api/v2/item/291/"
    },
    {
      "name": "rock-incense",
      "url": "https://pokeapi.co/api/v2/item/292/"
    },
    {
      "name": "full-incense",
      "url": "https://pokeapi.co/api/v2/item/293/"
    },
    {
      "name": "wave-incense",
      "url": "https://pokeapi.co/api/v2/item/294/"
    },
    {
      "name": "rose-incense",
      "url": "https://pokeapi.co/api/v2/item/295/"
    },
    {
      "name": "luck-incense",
      "url": "https://pokeapi.co/api/v2/item/296/"
    },
    {
      "name": "pure-incense",
      "url": "https://pokeapi.co/api/v2/item/297/"
    },
    {
      "name": "protector",
      "url": "https://pokeapi.co/api/v2/item/298/"
    },
    {
      "name": "electirizer",
      "url": "https://pokeapi.co/api/v2/item/299/"
    },
    {
      "name": "magmarizer",
      "url": "https://pokeapi.co/api/v2/item/300/"
    },
    {
      "name": "dubious-disc",
      "url": "https://pokeapi.co/api/v2/item/301/"
    },
    {
      "name": "reaper-cloth",
      "url": "https://pokeapi.co/api/v2/item/302/"
    },
    {
      "name": "razor-claw",
      "url": "https://pokeapi.co/api/v2/item/303/"
    },
    {
      "name": "razor-fang",
      "url": "https://pokeapi.co/api/v2/item/304/"
    },
    {
      "name": "tm01",
      "url": "https://pokeapi.co/api/v2/item/305/"
    },
    {
      "name": "tm02",
      "url": "https://pokeapi.co/api/v2/item/306/"
    },
    {
      "name": "tm03",
      "url": "https://pokeapi.co/api/v2/item/307/"
    },
    {
      "name": "tm04",
      "url": "https://pokeapi.co/api/v2/item/308/"
    },
    {
      "name": "tm05",
      "url": "https://pokeapi.co/api/v2/item/309/"
    },
    {
      "name": "tm06",
      "url": "https://pokeapi.co/api/v2/item/310/"
    },
    {
      "name": "tm07",
      "url": "https://pokeapi.co/api/v2/item/311/"
    },
    {
      "name": "tm08",
      "url": "https://pokeapi.co/api/v2/item/312/"
    },
    {
      "name": "tm09",
      "url": "https://pokeapi.co/api/v2/item/313/"
    },
    {
      "name": "tm10",
      "url": "https://pokeapi.co/api/v2/item/314/"
    },
    {
      "name": "tm11",
      "url": "https://pokeapi.co/api/v2/item/315/"
    },
    {
      "name": "tm12",
      "url": "https://pokeapi.co/api/v2/item/316/"
    },
    {
      "name": "tm13",
      "url": "https://pokeapi.co/api/v2/item/317/"
    },
    {
      "name": "tm14",
      "url": "https://pokeapi.co/api/v2/item/318/"
    },
    {
      "name": "tm15",
      "url": "https://pokeapi.co/api/v2/item/319/"
    },
    {
      "name": "tm16",
      "url": "https://pokeapi.co/api/v2/item/320/"
    },
    {
      "name": "tm17",
      "url": "https://pokeapi.co/api/v2/item/321/"
    },
    {
      "name": "tm18",
      "url": "https://pokeapi.co/api/v2/item/322/"
    },
    {
      "name": "tm19",
      "url": "https://pokeapi.co/api/v2/item/323/"
    },
    {
      "name": "tm20",
      "url": "https://pokeapi.co/api/v2/item/324/"
    },
    {
      "name": "tm21",
      "url": "https://pokeapi.co/api/v2/item/325/"
    },
    {
      "name": "tm22",
      "url": "https://pokeapi.co/api/v2/item/326/"
    },
    {
      "name": "tm23",
      "url": "https://pokeapi.co/api/v2/item/327/"
    },
    {
      "name": "tm24",
      "url": "https://pokeapi.co/api/v2/item/328/"
    },
    {
      "name": "tm25",
      "url": "https://pokeapi.co/api/v2/item/329/"
    },
    {
      "name": "tm26",
      "url": "https://pokeapi.co/api/v2/item/330/"
    },
    {
      "name": "tm27",
      "url": "https://pokeapi.co/api/v2/item/331/"
    },
    {
      "name": "tm28",
      "url": "https://pokeapi.co/api/v2/item/332/"
    },
    {
      "name": "tm29",
      "url": "https://pokeapi.co/api/v2/item/333/"
    },
    {
      "name": "tm30",
      "url": "https://pokeapi.co/api/v2/item/334/"
    },
    {
      "name": "tm31",
      "url": "https://pokeapi.co/api/v2/item/335/"
    },
    {
      "name": "tm32",
      "url": "https://pokeapi.co/api/v2/item/336/"
    },
    {
      "name": "tm33",
      "url": "https://pokeapi.co/api/v2/item/337/"
    },
    {
      "name": "tm34",
      "url": "https://pokeapi.co/api/v2/item/338/"
    },
    {
      "name": "tm35",
      "url": "https://pokeapi.co/api/v2/item/339/"
    },
    {
      "name": "tm36",
      "url": "https://pokeapi.co/api/v2/item/340/"
    },
    {
      "name": "tm37",
      "url": "https://pokeapi.co/api/v2/item/341/"
    },
    {
      "name": "tm38",
      "url": "https://pokeapi.co/api/v2/item/342/"
    },
    {
      "name": "tm39",
      "url": "https://pokeapi.co/api/v2/item/343/"
    },
    {
      "name": "tm40",
      "url": "https://pokeapi.co/api/v2/item/344/"
    },
    {
      "name": "tm41",
      "url": "https://pokeapi.co/api/v2/item/345/"
    },
    {
      "name": "tm42",
      "url": "https://pokeapi.co/api/v2/item/346/"
    },
    {
      "name": "tm43",
      "url": "https://pokeapi.co/api/v2/item/347/"
    },
    {
      "name": "tm44",
      "url": "https://pokeapi.co/api/v2/item/348/"
    },
    {
      "name": "tm45",
      "url": "https://pokeapi.co/api/v2/item/349/"
    },
    {
      "name": "tm46",
      "url": "https://pokeapi.co/api/v2/item/350/"
    },
    {
      "name": "tm47",
      "url": "https://pokeapi.co/api/v2/item/351/"
    },
    {
      "name": "tm48",
      "url": "https://pokeapi.co/api/v2/item/352/"
    },
    {
      "name": "tm49",
      "url": "https://pokeapi.co/api/v2/item/353/"
    },
    {
      "name": "tm50",
      "url": "https://pokeapi.co/api/v2/item/354/"
    },
    {
      "name": "tm51",
      "url": "https://pokeapi.co/api/v2/item/355/"
    },
    {
      "name": "tm52",
      "url": "https://pokeapi.co/api/v2/item/356/"
    },
    {
      "name": "tm53",
      "url": "https://pokeapi.co/api/v2/item/357/"
    },
    {
      "name": "tm54",
      "url": "https://pokeapi.co/api/v2/item/358/"
    },
    {
      "name": "tm55",
      "url": "https://pokeapi.co/api/v2/item/359/"
    },
    {
      "name": "tm56",
      "url": "https://pokeapi.co/api/v2/item/360/"
    },
    {
      "name": "tm57",
      "url": "https://pokeapi.co/api/v2/item/361/"
    },
    {
      "name": "tm58",
      "url": "https://pokeapi.co/api/v2/item/362/"
    },
    {
      "name": "tm59",
      "url": "https://pokeapi.co/api/v2/item/363/"
    },
    {
      "name": "tm60",
      "url": "https://pokeapi.co/api/v2/item/364/"
    },
    {
      "name": "tm61",
      "url": "https://pokeapi.co/api/v2/item/365/"
    },
    {
      "name": "tm62",
      "url": "https://pokeapi.co/api/v2/item/366/"
    },
    {
      "name": "tm63",
      "url": "https://pokeapi.co/api/v2/item/367/"
    },
    {
      "name": "tm64",
      "url": "https://pokeapi.co/api/v2/item/368/"
    },
    {
      "name": "tm65",
      "url": "https://pokeapi.co/api/v2/item/369/"
    },
    {
      "name": "tm66",
      "url": "https://pokeapi.co/api/v2/item/370/"
    },
    {
      "name": "tm67",
      "url": "https://pokeapi.co/api/v2/item/371/"
    },
    {
      "name": "tm68",
      "url": "https://pokeapi.co/api/v2/item/372/"
    },
    {
      "name": "tm69",
      "url": "https://pokeapi.co/api/v2/item/373/"
    },
    {
      "name": "tm70",
      "url": "https://pokeapi.co/api/v2/item/374/"
    },
    {
      "name": "tm71",
      "url": "https://pokeapi.co/api/v2/item/375/"
    },
    {
      "name": "tm72",
      "url": "https://pokeapi.co/api/v2/item/376/"
    },
    {
      "name": "tm73",
      "url": "https://pokeapi.co/api/v2/item/377/"
    },
    {
      "name": "tm74",
      "url": "https://pokeapi.co/api/v2/item/378/"
    },
    {
      "name": "tm75",
      "url": "https://pokeapi.co/api/v2/item/379/"
    },
    {
      "name": "tm76",
      "url": "https://pokeapi.co/api/v2/item/380/"
    },
    {
      "name": "tm77",
      "url": "https://pokeapi.co/api/v2/item/381/"
    },
    {
      "name": "tm78",
      "url": "https://pokeapi.co/api/v2/item/382/"
    },
    {
      "name": "tm79",
      "url": "https://pokeapi.co/api/v2/item/383/"
    },
    {
      "name": "tm80",
      "url": "https://pokeapi.co/api/v2/item/384/"
    },
    {
      "name": "tm81",
      "url": "https://pokeapi.co/api/v2/item/385/"
    },
    {
      "name": "tm82",
      "url": "https://pokeapi.co/api/v2/item/386/"
    },
    {
      "name": "tm83",
      "url": "https://pokeapi.co/api/v2/item/387/"
    },
    {
      "name": "tm84",
      "url": "https://pokeapi.co/api/v2/item/388/"
    },
    {
      "name": "tm85",
      "url": "https://pokeapi.co/api/v2/item/389/"
    },
    {
      "name": "tm86",
      "url": "https://pokeapi.co/api/v2/item/390/"
    },
    {
      "name": "tm87",
      "url": "https://pokeapi.co/api/v2/item/391/"
    },
    {
      "name": "tm88",
      "url": "https://pokeapi.co/api/v2/item/392/"
    },
    {
      "name": "tm89",
      "url": "https://pokeapi.co/api/v2/item/393/"
    },
    {
      "name": "tm90",
      "url": "https://pokeapi.co/api/v2/item/394/"
    },
    {
      "name": "tm91",
      "url": "https://pokeapi.co/api/v2/item/395/"
    },
    {
      "name": "tm92",
      "url": "https://pokeapi.co/api/v2/item/396/"
    },
    {
      "name": "hm01",
      "url": "https://pokeapi.co/api/v2/item/397/"
    },
    {
      "name": "hm02",
      "url": "https://pokeapi.co/api/v2/item/398/"
    },
    {
      "name": "hm03",
      "url": "https://pokeapi.co/api/v2/item/399/"
    },
    {
      "name": "hm04",
      "url": "https://pokeapi.co/api/v2/item/400/"
    },
    {
      "name": "hm05",
      "url": "https://pokeapi.co/api/v2/item/401/"
    },
    {
      "name": "hm06",
      "url": "https://pokeapi.co/api/v2/item/402/"
    },
    {
      "name": "hm07",
      "url": "https://pokeapi.co/api/v2/item/403/"
    },
    {
      "name": "hm08",
      "url": "https://pokeapi.co/api/v2/item/404/"
    },
    {
      "name": "explorer-kit",
      "url": "https://pokeapi.co/api/v2/item/405/"
    },
    {
      "name": "loot-sack",
      "url": "https://pokeapi.co/api/v2/item/406/"
    },
    {
      "name": "rule-book",
      "url": "https://pokeapi.co/api/v2/item/407/"
    },
    {
      "name": "poke-radar",
      "url": "https://pokeapi.co/api/v2/item/408/"
    },
    {
      "name": "point-card",
      "url": "https://pokeapi.co/api/v2/item/409/"
    },
    {
      "name": "journal",
      "url": "https://pokeapi.co/api/v2/item/410/"
    },
    {
      "name": "seal-case",
      "url": "https://pokeapi.co/api/v2/item/411/"
    },
    {
      "name": "fashion-case",
      "url": "https://pokeapi.co/api/v2/item/412/"
    },
    {
      "name": "seal-bag",
      "url": "https://pokeapi.co/api/v2/item/413/"
    },
    {
      "name": "pal-pad",
      "url": "https://pokeapi.co/api/v2/item/414/"
    },
    {
      "name": "works-key",
      "url": "https://pokeapi.co/api/v2/item/415/"
    },
    {
      "name": "old-charm",
      "url": "https://pokeapi.co/api/v2/item/416/"
    },
    {
      "name": "galactic-key",
      "url": "https://pokeapi.co/api/v2/item/417/"
    },
    {
      "name": "red-chain",
      "url": "https://pokeapi.co/api/v2/item/418/"
    },
    {
      "name": "town-map",
      "url": "https://pokeapi.co/api/v2/item/419/"
    },
    {
      "name": "vs-seeker",
      "url": "https://pokeapi.co/api/v2/item/420/"
    },
    {
      "name": "coin-case",
      "url": "https://pokeapi.co/api/v2/item/421/"
    },
    {
      "name": "old-rod",
      "url": "https://pokeapi.co/api/v2/item/422/"
    },
    {
      "name": "good-rod",
      "url": "https://pokeapi.co/api/v2/item/423/"
    },
    {
      "name": "super-rod",
      "url": "https://pokeapi.co/api/v2/item/424/"
    },
    {
      "name": "sprayduck",
      "url": "https://pokeapi.co/api/v2/item/425/"
    },
    {
      "name": "poffin-case",
      "url": "https://pokeapi.co/api/v2/item/426/"
    },
    {
      "name": "bicycle",
      "url": "https://pokeapi.co/api/v2/item/427/"
    },
    {
      "name": "suite-key",
      "url": "https://pokeapi.co/api/v2/item/428/"
    },
    {
      "name": "oaks-letter",
      "url": "https://pokeapi.co/api/v2/item/429/"
    },
    {
      "name": "lunar-wing",
      "url": "https://pokeapi.co/api/v2/item/430/"
    },
    {
      "name": "member-card",
      "url": "https://pokeapi.co/api/v2/item/431/"
    },
    {
      "name": "azure-flute",
      "url": "https://pokeapi.co/api/v2/item/432/"
    },
    {
      "name": "ss-ticket",
      "url": "https://pokeapi.co/api/v2/item/433/"
    },
    {
      "name": "contest-pass",
      "url": "https://pokeapi.co/api/v2/item/434/"
    },
    {
      "name": "magma-stone",
      "url": "https://pokeapi.co/api/v2/item/435/"
    },
    {
      "name": "parcel",
      "url": "https://pokeapi.co/api/v2/item/436/"
    },
    {
      "name": "coupon-1",
      "url": "https://pokeapi.co/api/v2/item/437/"
    },
    {
      "name": "coupon-2",
      "url": "https://pokeapi.co/api/v2/item/438/"
    },
    {
      "name": "coupon-3",
      "url": "https://pokeapi.co/api/v2/item/439/"
    },
    {
      "name": "storage-key",
      "url": "https://pokeapi.co/api/v2/item/440/"
    },
    {
      "name": "secret-potion",
      "url": "https://pokeapi.co/api/v2/item/441/"
    },
    {
      "name": "griseous-orb",
      "url": "https://pokeapi.co/api/v2/item/442/"
    },
    {
      "name": "vs-recorder",
      "url": "https://pokeapi.co/api/v2/item/443/"
    },
    {
      "name": "gracidea",
      "url": "https://pokeapi.co/api/v2/item/444/"
    },
    {
      "name": "secret-key",
      "url": "https://pokeapi.co/api/v2/item/445/"
    },
    {
      "name": "apricorn-box",
      "url": "https://pokeapi.co/api/v2/item/446/"
    },
    {
      "name": "berry-pots",
      "url": "https://pokeapi.co/api/v2/item/447/"
    },
    {
      "name": "squirt-bottle",
      "url": "https://pokeapi.co/api/v2/item/448/"
    },
    {
      "name": "lure-ball",
      "url": "https://pokeapi.co/api/v2/item/449/"
    },
    {
      "name": "level-ball",
      "url": "https://pokeapi.co/api/v2/item/450/"
    },
    {
      "name": "moon-ball",
      "url": "https://pokeapi.co/api/v2/item/451/"
    },
    {
      "name": "heavy-ball",
      "url": "https://pokeapi.co/api/v2/item/452/"
    },
    {
      "name": "fast-ball",
      "url": "https://pokeapi.co/api/v2/item/453/"
    },
    {
      "name": "friend-ball",
      "url": "https://pokeapi.co/api/v2/item/454/"
    },
    {
      "name": "love-ball",
      "url": "https://pokeapi.co/api/v2/item/455/"
    },
    {
      "name": "park-ball",
      "url": "https://pokeapi.co/api/v2/item/456/"
    },
    {
      "name": "sport-ball",
      "url": "https://pokeapi.co/api/v2/item/457/"
    },
    {
      "name": "red-apricorn",
      "url": "https://pokeapi.co/api/v2/item/458/"
    },
    {
      "name": "blue-apricorn",
      "url": "https://pokeapi.co/api/v2/item/459/"
    },
    {
      "name": "yellow-apricorn",
      "url": "https://pokeapi.co/api/v2/item/460/"
    },
    {
      "name": "green-apricorn",
      "url": "https://pokeapi.co/api/v2/item/461/"
    },
    {
      "name": "pink-apricorn",
      "url": "https://pokeapi.co/api/v2/item/462/"
    },
    {
      "name": "white-apricorn",
      "url": "https://pokeapi.co/api/v2/item/463/"
    },
    {
      "name": "black-apricorn",
      "url": "https://pokeapi.co/api/v2/item/464/"
    },
    {
      "name": "dowsing-machine",
      "url": "https://pokeapi.co/api/v2/item/465/"
    },
    {
      "name": "rage-candy-bar",
      "url": "https://pokeapi.co/api/v2/item/466/"
    },
    {
      "name": "red-orb",
      "url": "https://pokeapi.co/api/v2/item/467/"
    },
    {
      "name": "blue-orb",
      "url": "https://pokeapi.co/api/v2/item/468/"
    },
    {
      "name": "jade-orb",
      "url": "https://pokeapi.co/api/v2/item/469/"
    },
    {
      "name": "enigma-stone",
      "url": "https://pokeapi.co/api/v2/item/470/"
    },
    {
      "name": "unown-report",
      "url": "https://pokeapi.co/api/v2/item/471/"
    },
    {
      "name": "blue-card",
      "url": "https://pokeapi.co/api/v2/item/472/"
    },
    {
      "name": "slowpoke-tail",
      "url": "https://pokeapi.co/api/v2/item/473/"
    },
    {
      "name": "clear-bell",
      "url": "https://pokeapi.co/api/v2/item/474/"
    },
    {
      "name": "card-key",
      "url": "https://pokeapi.co/api/v2/item/475/"
    },
    {
      "name": "basement-key",
      "url": "https://pokeapi.co/api/v2/item/476/"
    },
    {
      "name": "red-scale",
      "url": "https://pokeapi.co/api/v2/item/477/"
    },
    {
      "name": "lost-item",
      "url": "https://pokeapi.co/api/v2/item/478/"
    },
    {
      "name": "pass",
      "url": "https://pokeapi.co/api/v2/item/479/"
    },
    {
      "name": "machine-part",
      "url": "https://pokeapi.co/api/v2/item/480/"
    },
    {
      "name": "silver-wing",
      "url": "https://pokeapi.co/api/v2/item/481/"
    },
    {
      "name": "rainbow-wing",
      "url": "https://pokeapi.co/api/v2/item/482/"
    },
    {
      "name": "mystery-egg",
      "url": "https://pokeapi.co/api/v2/item/483/"
    },
    {
      "name": "gb-sounds",
      "url": "https://pokeapi.co/api/v2/item/484/"
    },
    {
      "name": "tidal-bell",
      "url": "https://pokeapi.co/api/v2/item/485/"
    },
    {
      "name": "data-card-01",
      "url": "https://pokeapi.co/api/v2/item/486/"
    },
    {
      "name": "data-card-02",
      "url": "https://pokeapi.co/api/v2/item/487/"
    },
    {
      "name": "data-card-03",
      "url": "https://pokeapi.co/api/v2/item/488/"
    },
    {
      "name": "data-card-04",
      "url": "https://pokeapi.co/api/v2/item/489/"
    },
    {
      "name": "data-card-05",
      "url": "https://pokeapi.co/api/v2/item/490/"
    },
    {
      "name": "data-card-06",
      "url": "https://pokeapi.co/api/v2/item/491/"
    },
    {
      "name": "data-card-07",
      "url": "https://pokeapi.co/api/v2/item/492/"
    },
    {
      "name": "data-card-08",
      "url": "https://pokeapi.co/api/v2/item/493/"
    },
    {
      "name": "data-card-09",
      "url": "https://pokeapi.co/api/v2/item/494/"
    },
    {
      "name": "data-card-10",
      "url": "https://pokeapi.co/api/v2/item/495/"
    },
    {
      "name": "data-card-11",
      "url": "https://pokeapi.co/api/v2/item/496/"
    },
    {
      "name": "data-card-12",
      "url": "https://pokeapi.co/api/v2/item/497/"
    },
    {
      "name": "data-card-13",
      "url": "https://pokeapi.co/api/v2/item/498/"
    },
    {
      "name": "data-card-14",
      "url": "https://pokeapi.co/api/v2/item/499/"
    },
    {
      "name": "data-card-15",
      "url": "https://pokeapi.co/api/v2/item/500/"
    },
    {
      "name": "data-card-16",
      "url": "https://pokeapi.co/api/v2/item/501/"
    },
    {
      "name": "data-card-17",
      "url": "https://pokeapi.co/api/v2/item/502/"
    },
    {
      "name": "data-card-18",
      "url": "https://pokeapi.co/api/v2/item/503/"
    },
    {
      "name": "data-card-19",
      "url": "https://pokeapi.co/api/v2/item/504/"
    },
    {
      "name": "data-card-20",
      "url": "https://pokeapi.co/api/v2/item/505/"
    },
    {
      "name": "data-card-21",
      "url": "https://pokeapi.co/api/v2/item/506/"
    },
    {
      "name": "data-card-22",
      "url": "https://pokeapi.co/api/v2/item/507/"
    },
    {
      "name": "data-card-23",
      "url": "https://pokeapi.co/api/v2/item/508/"
    },
    {
      "name": "data-card-24",
      "url": "https://pokeapi.co/api/v2/item/509/"
    },
    {
      "name": "data-card-25",
      "url": "https://pokeapi.co/api/v2/item/510/"
    },
    {
      "name": "data-card-26",
      "url": "https://pokeapi.co/api/v2/item/511/"
    },
    {
      "name": "data-card-27",
      "url": "https://pokeapi.co/api/v2/item/512/"
    },
    {
      "name": "lock-capsule",
      "url": "https://pokeapi.co/api/v2/item/513/"
    },
    {
      "name": "photo-album",
      "url": "https://pokeapi.co/api/v2/item/514/"
    },
    {
      "name": "orange-mail",
      "url": "https://pokeapi.co/api/v2/item/515/"
    },
    {
      "name": "harbor-mail",
      "url": "https://pokeapi.co/api/v2/item/516/"
    },
    {
      "name": "glitter-mail",
      "url": "https://pokeapi.co/api/v2/item/517/"
    },
    {
      "name": "mech-mail",
      "url": "https://pokeapi.co/api/v2/item/518/"
    },
    {
      "name": "wood-mail",
      "url": "https://pokeapi.co/api/v2/item/519/"
    },
    {
      "name": "wave-mail",
      "url": "https://pokeapi.co/api/v2/item/520/"
    },
    {
      "name": "bead-mail",
      "url": "https://pokeapi.co/api/v2/item/521/"
    },
    {
      "name": "shadow-mail",
      "url": "https://pokeapi.co/api/v2/item/522/"
    },
    {
      "name": "tropic-mail",
      "url": "https://pokeapi.co/api/v2/item/523/"
    },
    {
      "name": "dream-mail",
      "url": "https://pokeapi.co/api/v2/item/524/"
    },
    {
      "name": "fab-mail",
      "url": "https://pokeapi.co/api/v2/item/525/"
    },
    {
      "name": "retro-mail",
      "url": "https://pokeapi.co/api/v2/item/526/"
    },
    {
      "name": "mach-bike",
      "url": "https://pokeapi.co/api/v2/item/527/"
    },
    {
      "name": "acro-bike",
      "url": "https://pokeapi.co/api/v2/item/528/"
    },
    {
      "name": "wailmer-pail",
      "url": "https://pokeapi.co/api/v2/item/529/"
    },
    {
      "name": "devon-goods",
      "url": "https://pokeapi.co/api/v2/item/530/"
    },
    {
      "name": "soot-sack",
      "url": "https://pokeapi.co/api/v2/item/531/"
    },
    {
      "name": "pokeblock-case",
      "url": "https://pokeapi.co/api/v2/item/532/"
    },
    {
      "name": "letter",
      "url": "https://pokeapi.co/api/v2/item/533/"
    },
    {
      "name": "eon-ticket",
      "url": "https://pokeapi.co/api/v2/item/534/"
    },
    {
      "name": "scanner",
      "url": "https://pokeapi.co/api/v2/item/535/"
    },
    {
      "name": "go-goggles",
      "url": "https://pokeapi.co/api/v2/item/536/"
    },
    {
      "name": "meteorite",
      "url": "https://pokeapi.co/api/v2/item/537/"
    },
    {
      "name": "rm-1-key",
      "url": "https://pokeapi.co/api/v2/item/538/"
    },
    {
      "name": "rm-2-key",
      "url": "https://pokeapi.co/api/v2/item/539/"
    },
    {
      "name": "rm-4-key",
      "url": "https://pokeapi.co/api/v2/item/540/"
    },
    {
      "name": "rm-6-key",
      "url": "https://pokeapi.co/api/v2/item/541/"
    },
    {
      "name": "devon-scope",
      "url": "https://pokeapi.co/api/v2/item/542/"
    },
    {
      "name": "oaks-parcel",
      "url": "https://pokeapi.co/api/v2/item/543/"
    },
    {
      "name": "poke-flute",
      "url": "https://pokeapi.co/api/v2/item/544/"
    },
    {
      "name": "bike-voucher",
      "url": "https://pokeapi.co/api/v2/item/545/"
    },
    {
      "name": "gold-teeth",
      "url": "https://pokeapi.co/api/v2/item/546/"
    },
    {
      "name": "lift-key",
      "url": "https://pokeapi.co/api/v2/item/547/"
    },
    {
      "name": "silph-scope",
      "url": "https://pokeapi.co/api/v2/item/548/"
    },
    {
      "name": "fame-checker",
      "url": "https://pokeapi.co/api/v2/item/549/"
    },
    {
      "name": "tm-case",
      "url": "https://pokeapi.co/api/v2/item/550/"
    },
    {
      "name": "berry-pouch",
      "url": "https://pokeapi.co/api/v2/item/551/"
    },
    {
      "name": "teachy-tv",
      "url": "https://pokeapi.co/api/v2/item/552/"
    },
    {
      "name": "tri-pass",
      "url": "https://pokeapi.co/api/v2/item/553/"
    },
    {
      "name": "rainbow-pass",
      "url": "https://pokeapi.co/api/v2/item/554/"
    },
    {
      "name": "tea",
      "url": "https://pokeapi.co/api/v2/item/555/"
    },
    {
      "name": "mysticticket",
      "url": "https://pokeapi.co/api/v2/item/556/"
    },
    {
      "name": "auroraticket",
      "url": "https://pokeapi.co/api/v2/item/557/"
    },
    {
      "name": "powder-jar",
      "url": "https://pokeapi.co/api/v2/item/558/"
    },
    {
      "name": "ruby",
      "url": "https://pokeapi.co/api/v2/item/559/"
    },
    {
      "name": "sapphire",
      "url": "https://pokeapi.co/api/v2/item/560/"
    },
    {
      "name": "magma-emblem",
      "url": "https://pokeapi.co/api/v2/item/561/"
    },
    {
      "name": "old-sea-map",
      "url": "https://pokeapi.co/api/v2/item/562/"
    },
    {
      "name": "douse-drive",
      "url": "https://pokeapi.co/api/v2/item/563/"
    },
    {
      "name": "shock-drive",
      "url": "https://pokeapi.co/api/v2/item/564/"
    },
    {
      "name": "burn-drive",
      "url": "https://pokeapi.co/api/v2/item/565/"
    },
    {
      "name": "chill-drive",
      "url": "https://pokeapi.co/api/v2/item/566/"
    },
    {
      "name": "sweet-heart",
      "url": "https://pokeapi.co/api/v2/item/567/"
    },
    {
      "name": "greet-mail",
      "url": "https://pokeapi.co/api/v2/item/568/"
    },
    {
      "name": "favored-mail",
      "url": "https://pokeapi.co/api/v2/item/569/"
    },
    {
      "name": "rsvp-mail",
      "url": "https://pokeapi.co/api/v2/item/570/"
    },
    {
      "name": "thanks-mail",
      "url": "https://pokeapi.co/api/v2/item/571/"
    },
    {
      "name": "inquiry-mail",
      "url": "https://pokeapi.co/api/v2/item/572/"
    },
    {
      "name": "like-mail",
      "url": "https://pokeapi.co/api/v2/item/573/"
    },
    {
      "name": "reply-mail",
      "url": "https://pokeapi.co/api/v2/item/574/"
    },
    {
      "name": "bridge-mail-s",
      "url": "https://pokeapi.co/api/v2/item/575/"
    },
    {
      "name": "bridge-mail-d",
      "url": "https://pokeapi.co/api/v2/item/576/"
    },
    {
      "name": "bridge-mail-t",
      "url": "https://pokeapi.co/api/v2/item/577/"
    },
    {
      "name": "bridge-mail-v",
      "url": "https://pokeapi.co/api/v2/item/578/"
    },
    {
      "name": "bridge-mail-m",
      "url": "https://pokeapi.co/api/v2/item/579/"
    },
    {
      "name": "prism-scale",
      "url": "https://pokeapi.co/api/v2/item/580/"
    },
    {
      "name": "eviolite",
      "url": "https://pokeapi.co/api/v2/item/581/"
    },
    {
      "name": "float-stone",
      "url": "https://pokeapi.co/api/v2/item/582/"
    },
    {
      "name": "rocky-helmet",
      "url": "https://pokeapi.co/api/v2/item/583/"
    },
    {
      "name": "air-balloon",
      "url": "https://pokeapi.co/api/v2/item/584/"
    },
    {
      "name": "red-card",
      "url": "https://pokeapi.co/api/v2/item/585/"
    },
    {
      "name": "ring-target",
      "url": "https://pokeapi.co/api/v2/item/586/"
    },
    {
      "name": "binding-band",
      "url": "https://pokeapi.co/api/v2/item/587/"
    },
    {
      "name": "absorb-bulb",
      "url": "https://pokeapi.co/api/v2/item/588/"
    },
    {
      "name": "cell-battery",
      "url": "https://pokeapi.co/api/v2/item/589/"
    },
    {
      "name": "eject-button",
      "url": "https://pokeapi.co/api/v2/item/590/"
    },
    {
      "name": "fire-gem",
      "url": "https://pokeapi.co/api/v2/item/591/"
    },
    {
      "name": "water-gem",
      "url": "https://pokeapi.co/api/v2/item/592/"
    },
    {
      "name": "electric-gem",
      "url": "https://pokeapi.co/api/v2/item/593/"
    },
    {
      "name": "grass-gem",
      "url": "https://pokeapi.co/api/v2/item/594/"
    },
    {
      "name": "ice-gem",
      "url": "https://pokeapi.co/api/v2/item/595/"
    },
    {
      "name": "fighting-gem",
      "url": "https://pokeapi.co/api/v2/item/596/"
    },
    {
      "name": "poison-gem",
      "url": "https://pokeapi.co/api/v2/item/597/"
    },
    {
      "name": "ground-gem",
      "url": "https://pokeapi.co/api/v2/item/598/"
    },
    {
      "name": "flying-gem",
      "url": "https://pokeapi.co/api/v2/item/599/"
    },
    {
      "name": "psychic-gem",
      "url": "https://pokeapi.co/api/v2/item/600/"
    },
    {
      "name": "bug-gem",
      "url": "https://pokeapi.co/api/v2/item/601/"
    },
    {
      "name": "rock-gem",
      "url": "https://pokeapi.co/api/v2/item/602/"
    },
    {
      "name": "ghost-gem",
      "url": "https://pokeapi.co/api/v2/item/603/"
    },
    {
      "name": "dark-gem",
      "url": "https://pokeapi.co/api/v2/item/604/"
    },
    {
      "name": "steel-gem",
      "url": "https://pokeapi.co/api/v2/item/605/"
    },
    {
      "name": "health-wing",
      "url": "https://pokeapi.co/api/v2/item/606/"
    },
    {
      "name": "muscle-wing",
      "url": "https://pokeapi.co/api/v2/item/607/"
    },
    {
      "name": "resist-wing",
      "url": "https://pokeapi.co/api/v2/item/608/"
    },
    {
      "name": "genius-wing",
      "url": "https://pokeapi.co/api/v2/item/609/"
    },
    {
      "name": "clever-wing",
      "url": "https://pokeapi.co/api/v2/item/610/"
    },
    {
      "name": "swift-wing",
      "url": "https://pokeapi.co/api/v2/item/611/"
    },
    {
      "name": "pretty-wing",
      "url": "https://pokeapi.co/api/v2/item/612/"
    },
    {
      "name": "cover-fossil",
      "url": "https://pokeapi.co/api/v2/item/613/"
    },
    {
      "name": "plume-fossil",
      "url": "https://pokeapi.co/api/v2/item/614/"
    },
    {
      "name": "liberty-pass",
      "url": "https://pokeapi.co/api/v2/item/615/"
    },
    {
      "name": "pass-orb",
      "url": "https://pokeapi.co/api/v2/item/616/"
    },
    {
      "name": "dream-ball",
      "url": "https://pokeapi.co/api/v2/item/617/"
    },
    {
      "name": "poke-toy",
      "url": "https://pokeapi.co/api/v2/item/618/"
    },
    {
      "name": "prop-case",
      "url": "https://pokeapi.co/api/v2/item/619/"
    },
    {
      "name": "dragon-skull",
      "url": "https://pokeapi.co/api/v2/item/620/"
    },
    {
      "name": "balm-mushroom",
      "url": "https://pokeapi.co/api/v2/item/621/"
    },
    {
      "name": "big-nugget",
      "url": "https://pokeapi.co/api/v2/item/622/"
    },
    {
      "name": "pearl-string",
      "url": "https://pokeapi.co/api/v2/item/623/"
    },
    {
      "name": "comet-shard",
      "url": "https://pokeapi.co/api/v2/item/624/"
    },
    {
      "name": "relic-copper",
      "url": "https://pokeapi.co/api/v2/item/625/"
    },
    {
      "name": "relic-silver",
      "url": "https://pokeapi.co/api/v2/item/626/"
    },
    {
      "name": "relic-gold",
      "url": "https://pokeapi.co/api/v2/item/627/"
    },
    {
      "name": "relic-vase",
      "url": "https://pokeapi.co/api/v2/item/628/"
    },
    {
      "name": "relic-band",
      "url": "https://pokeapi.co/api/v2/item/629/"
    },
    {
      "name": "relic-statue",
      "url": "https://pokeapi.co/api/v2/item/630/"
    },
    {
      "name": "relic-crown",
      "url": "https://pokeapi.co/api/v2/item/631/"
    },
    {
      "name": "casteliacone",
      "url": "https://pokeapi.co/api/v2/item/632/"
    },
    {
      "name": "dire-hit-2",
      "url": "https://pokeapi.co/api/v2/item/633/"
    },
    {
      "name": "x-speed-2",
      "url": "https://pokeapi.co/api/v2/item/634/"
    },
    {
      "name": "x-sp-atk-2",
      "url": "https://pokeapi.co/api/v2/item/635/"
    },
    {
      "name": "x-sp-def-2",
      "url": "https://pokeapi.co/api/v2/item/636/"
    },
    {
      "name": "x-defense-2",
      "url": "https://pokeapi.co/api/v2/item/637/"
    },
    {
      "name": "x-attack-2",
      "url": "https://pokeapi.co/api/v2/item/638/"
    },
    {
      "name": "x-accuracy-2",
      "url": "https://pokeapi.co/api/v2/item/639/"
    },
    {
      "name": "x-speed-3",
      "url": "https://pokeapi.co/api/v2/item/640/"
    },
    {
      "name": "x-sp-atk-3",
      "url": "https://pokeapi.co/api/v2/item/641/"
    },
    {
      "name": "x-sp-def-3",
      "url": "https://pokeapi.co/api/v2/item/642/"
    },
    {
      "name": "x-defense-3",
      "url": "https://pokeapi.co/api/v2/item/643/"
    },
    {
      "name": "x-attack-3",
      "url": "https://pokeapi.co/api/v2/item/644/"
    },
    {
      "name": "x-accuracy-3",
      "url": "https://pokeapi.co/api/v2/item/645/"
    },
    {
      "name": "x-speed-6",
      "url": "https://pokeapi.co/api/v2/item/646/"
    },
    {
      "name": "x-sp-atk-6",
      "url": "https://pokeapi.co/api/v2/item/647/"
    },
    {
      "name": "x-sp-def-6",
      "url": "https://pokeapi.co/api/v2/item/648/"
    },
    {
      "name": "x-defense-6",
      "url": "https://pokeapi.co/api/v2/item/649/"
    },
    {
      "name": "x-attack-6",
      "url": "https://pokeapi.co/api/v2/item/650/"
    },
    {
      "name": "x-accuracy-6",
      "url": "https://pokeapi.co/api/v2/item/651/"
    },
    {
      "name": "ability-urge",
      "url": "https://pokeapi.co/api/v2/item/652/"
    },
    {
      "name": "item-drop",
      "url": "https://pokeapi.co/api/v2/item/653/"
    },
    {
      "name": "item-urge",
      "url": "https://pokeapi.co/api/v2/item/654/"
    },
    {
      "name": "reset-urge",
      "url": "https://pokeapi.co/api/v2/item/655/"
    },
    {
      "name": "dire-hit-3",
      "url": "https://pokeapi.co/api/v2/item/656/"
    },
    {
      "name": "light-stone",
      "url": "https://pokeapi.co/api/v2/item/657/"
    },
    {
      "name": "dark-stone",
      "url": "https://pokeapi.co/api/v2/item/658/"
    },
    {
      "name": "tm93",
      "url": "https://pokeapi.co/api/v2/item/659/"
    },
    {
      "name": "tm94",
      "url": "https://pokeapi.co/api/v2/item/660/"
    },
    {
      "name": "tm95",
      "url": "https://pokeapi.co/api/v2/item/661/"
    },
    {
      "name": "xtransceiver",
      "url": "https://pokeapi.co/api/v2/item/662/"
    },
    {
      "name": "god-stone",
      "url": "https://pokeapi.co/api/v2/item/663/"
    },
    {
      "name": "gram-1",
      "url": "https://pokeapi.co/api/v2/item/664/"
    },
    {
      "name": "gram-2",
      "url": "https://pokeapi.co/api/v2/item/665/"
    },
    {
      "name": "gram-3",
      "url": "https://pokeapi.co/api/v2/item/666/"
    },
    {
      "name": "dragon-gem",
      "url": "https://pokeapi.co/api/v2/item/668/"
    },
    {
      "name": "normal-gem",
      "url": "https://pokeapi.co/api/v2/item/669/"
    },
    {
      "name": "medal-box",
      "url": "https://pokeapi.co/api/v2/item/670/"
    },
    {
      "name": "dna-splicers",
      "url": "https://pokeapi.co/api/v2/item/671/"
    },
    {
      "name": "permit",
      "url": "https://pokeapi.co/api/v2/item/673/"
    },
    {
      "name": "oval-charm",
      "url": "https://pokeapi.co/api/v2/item/674/"
    },
    {
      "name": "shiny-charm",
      "url": "https://pokeapi.co/api/v2/item/675/"
    },
    {
      "name": "plasma-card",
      "url": "https://pokeapi.co/api/v2/item/676/"
    },
    {
      "name": "grubby-hanky",
      "url": "https://pokeapi.co/api/v2/item/677/"
    },
    {
      "name": "colress-machine",
      "url": "https://pokeapi.co/api/v2/item/678/"
    },
    {
      "name": "dropped-item",
      "url": "https://pokeapi.co/api/v2/item/679/"
    },
    {
      "name": "reveal-glass",
      "url": "https://pokeapi.co/api/v2/item/681/"
    },
    {
      "name": "weakness-policy",
      "url": "https://pokeapi.co/api/v2/item/682/"
    },
    {
      "name": "assault-vest",
      "url": "https://pokeapi.co/api/v2/item/683/"
    },
    {
      "name": "pixie-plate",
      "url": "https://pokeapi.co/api/v2/item/684/"
    },
    {
      "name": "ability-capsule",
      "url": "https://pokeapi.co/api/v2/item/685/"
    },
    {
      "name": "whipped-dream",
      "url": "https://pokeapi.co/api/v2/item/686/"
    },
    {
      "name": "sachet",
      "url": "https://pokeapi.co/api/v2/item/687/"
    },
    {
      "name": "luminous-moss",
      "url": "https://pokeapi.co/api/v2/item/688/"
    },
    {
      "name": "snowball",
      "url": "https://pokeapi.co/api/v2/item/689/"
    },
    {
      "name": "safety-goggles",
      "url": "https://pokeapi.co/api/v2/item/690/"
    },
    {
      "name": "rich-mulch",
      "url": "https://pokeapi.co/api/v2/item/691/"
    },
    {
      "name": "surprise-mulch",
      "url": "https://pokeapi.co/api/v2/item/692/"
    },
    {
      "name": "boost-mulch",
      "url": "https://pokeapi.co/api/v2/item/693/"
    },
    {
      "name": "amaze-mulch",
      "url": "https://pokeapi.co/api/v2/item/694/"
    },
    {
      "name": "gengarite",
      "url": "https://pokeapi.co/api/v2/item/695/"
    },
    {
      "name": "gardevoirite",
      "url": "https://pokeapi.co/api/v2/item/696/"
    },
    {
      "name": "ampharosite",
      "url": "https://pokeapi.co/api/v2/item/697/"
    },
    {
      "name": "venusaurite",
      "url": "https://pokeapi.co/api/v2/item/698/"
    },
    {
      "name": "charizardite-x",
      "url": "https://pokeapi.co/api/v2/item/699/"
    },
    {
      "name": "blastoisinite",
      "url": "https://pokeapi.co/api/v2/item/700/"
    },
    {
      "name": "mewtwonite-x",
      "url": "https://pokeapi.co/api/v2/item/701/"
    },
    {
      "name": "mewtwonite-y",
      "url": "https://pokeapi.co/api/v2/item/702/"
    },
    {
      "name": "blazikenite",
      "url": "https://pokeapi.co/api/v2/item/703/"
    },
    {
      "name": "medichamite",
      "url": "https://pokeapi.co/api/v2/item/704/"
    },
    {
      "name": "houndoominite",
      "url": "https://pokeapi.co/api/v2/item/705/"
    },
    {
      "name": "aggronite",
      "url": "https://pokeapi.co/api/v2/item/706/"
    },
    {
      "name": "banettite",
      "url": "https://pokeapi.co/api/v2/item/707/"
    },
    {
      "name": "tyranitarite",
      "url": "https://pokeapi.co/api/v2/item/708/"
    },
    {
      "name": "scizorite",
      "url": "https://pokeapi.co/api/v2/item/709/"
    },
    {
      "name": "pinsirite",
      "url": "https://pokeapi.co/api/v2/item/710/"
    },
    {
      "name": "aerodactylite",
      "url": "https://pokeapi.co/api/v2/item/711/"
    },
    {
      "name": "lucarionite",
      "url": "https://pokeapi.co/api/v2/item/712/"
    },
    {
      "name": "abomasite",
      "url": "https://pokeapi.co/api/v2/item/713/"
    },
    {
      "name": "kangaskhanite",
      "url": "https://pokeapi.co/api/v2/item/714/"
    },
    {
      "name": "gyaradosite",
      "url": "https://pokeapi.co/api/v2/item/715/"
    },
    {
      "name": "absolite",
      "url": "https://pokeapi.co/api/v2/item/716/"
    },
    {
      "name": "charizardite-y",
      "url": "https://pokeapi.co/api/v2/item/717/"
    },
    {
      "name": "alakazite",
      "url": "https://pokeapi.co/api/v2/item/718/"
    },
    {
      "name": "heracronite",
      "url": "https://pokeapi.co/api/v2/item/719/"
    },
    {
      "name": "mawilite",
      "url": "https://pokeapi.co/api/v2/item/720/"
    },
    {
      "name": "manectite",
      "url": "https://pokeapi.co/api/v2/item/721/"
    },
    {
      "name": "garchompite",
      "url": "https://pokeapi.co/api/v2/item/722/"
    },
    {
      "name": "roseli-berry",
      "url": "https://pokeapi.co/api/v2/item/723/"
    },
    {
      "name": "kee-berry",
      "url": "https://pokeapi.co/api/v2/item/724/"
    },
    {
      "name": "maranga-berry",
      "url": "https://pokeapi.co/api/v2/item/725/"
    },
    {
      "name": "discount-coupon",
      "url": "https://pokeapi.co/api/v2/item/726/"
    },
    {
      "name": "strange-souvenir",
      "url": "https://pokeapi.co/api/v2/item/727/"
    },
    {
      "name": "lumiose-galette",
      "url": "https://pokeapi.co/api/v2/item/728/"
    },
    {
      "name": "jaw-fossil",
      "url": "https://pokeapi.co/api/v2/item/729/"
    },
    {
      "name": "sail-fossil",
      "url": "https://pokeapi.co/api/v2/item/730/"
    },
    {
      "name": "fairy-gem",
      "url": "https://pokeapi.co/api/v2/item/731/"
    },
    {
      "name": "adventure-rules",
      "url": "https://pokeapi.co/api/v2/item/732/"
    },
    {
      "name": "elevator-key",
      "url": "https://pokeapi.co/api/v2/item/733/"
    },
    {
      "name": "holo-caster",
      "url": "https://pokeapi.co/api/v2/item/734/"
    },
    {
      "name": "honor-of-kalos",
      "url": "https://pokeapi.co/api/v2/item/735/"
    },
    {
      "name": "intriguing-stone",
      "url": "https://pokeapi.co/api/v2/item/736/"
    },
    {
      "name": "lens-case",
      "url": "https://pokeapi.co/api/v2/item/737/"
    },
    {
      "name": "looker-ticket",
      "url": "https://pokeapi.co/api/v2/item/738/"
    },
    {
      "name": "mega-ring",
      "url": "https://pokeapi.co/api/v2/item/739/"
    },
    {
      "name": "power-plant-pass",
      "url": "https://pokeapi.co/api/v2/item/740/"
    },
    {
      "name": "profs-letter",
      "url": "https://pokeapi.co/api/v2/item/741/"
    },
    {
      "name": "roller-skates",
      "url": "https://pokeapi.co/api/v2/item/742/"
    },
    {
      "name": "sprinklotad",
      "url": "https://pokeapi.co/api/v2/item/743/"
    },
    {
      "name": "tmv-pass",
      "url": "https://pokeapi.co/api/v2/item/744/"
    },
    {
      "name": "tm96",
      "url": "https://pokeapi.co/api/v2/item/745/"
    },
    {
      "name": "tm97",
      "url": "https://pokeapi.co/api/v2/item/746/"
    },
    {
      "name": "tm98",
      "url": "https://pokeapi.co/api/v2/item/747/"
    },
    {
      "name": "tm99",
      "url": "https://pokeapi.co/api/v2/item/748/"
    },
    {
      "name": "tm100",
      "url": "https://pokeapi.co/api/v2/item/749/"
    },
    {
      "name": "latiasite",
      "url": "https://pokeapi.co/api/v2/item/760/"
    },
    {
      "name": "latiosite",
      "url": "https://pokeapi.co/api/v2/item/761/"
    },
    {
      "name": "common-stone",
      "url": "https://pokeapi.co/api/v2/item/762/"
    },
    {
      "name": "makeup-bag",
      "url": "https://pokeapi.co/api/v2/item/763/"
    },
    {
      "name": "travel-trunk",
      "url": "https://pokeapi.co/api/v2/item/764/"
    },
    {
      "name": "shalour-sable",
      "url": "https://pokeapi.co/api/v2/item/765/"
    },
    {
      "name": "mega-charm",
      "url": "https://pokeapi.co/api/v2/item/768/"
    },
    {
      "name": "mega-glove",
      "url": "https://pokeapi.co/api/v2/item/769/"
    },
    {
      "name": "devon-parts",
      "url": "https://pokeapi.co/api/v2/item/770/"
    },
    {
      "name": "pokeblock-kit",
      "url": "https://pokeapi.co/api/v2/item/772/"
    },
    {
      "name": "key-to-room-1",
      "url": "https://pokeapi.co/api/v2/item/773/"
    },
    {
      "name": "key-to-room-2",
      "url": "https://pokeapi.co/api/v2/item/774/"
    },
    {
      "name": "key-to-room-4",
      "url": "https://pokeapi.co/api/v2/item/775/"
    },
    {
      "name": "key-to-room-6",
      "url": "https://pokeapi.co/api/v2/item/776/"
    },
    {
      "name": "devon-scuba-gear",
      "url": "https://pokeapi.co/api/v2/item/779/"
    },
    {
      "name": "contest-costume--jacket",
      "url": "https://pokeapi.co/api/v2/item/780/"
    },
    {
      "name": "magma-suit",
      "url": "https://pokeapi.co/api/v2/item/782/"
    },
    {
      "name": "aqua-suit",
      "url": "https://pokeapi.co/api/v2/item/783/"
    },
    {
      "name": "pair-of-tickets",
      "url": "https://pokeapi.co/api/v2/item/784/"
    },
    {
      "name": "mega-bracelet",
      "url": "https://pokeapi.co/api/v2/item/785/"
    },
    {
      "name": "mega-pendant",
      "url": "https://pokeapi.co/api/v2/item/786/"
    },
    {
      "name": "mega-glasses",
      "url": "https://pokeapi.co/api/v2/item/787/"
    },
    {
      "name": "mega-anchor",
      "url": "https://pokeapi.co/api/v2/item/788/"
    },
    {
      "name": "mega-stickpin",
      "url": "https://pokeapi.co/api/v2/item/789/"
    },
    {
      "name": "mega-tiara",
      "url": "https://pokeapi.co/api/v2/item/790/"
    },
    {
      "name": "mega-anklet",
      "url": "https://pokeapi.co/api/v2/item/791/"
    },
    {
      "name": "swampertite",
      "url": "https://pokeapi.co/api/v2/item/793/"
    },
    {
      "name": "sceptilite",
      "url": "https://pokeapi.co/api/v2/item/794/"
    },
    {
      "name": "sablenite",
      "url": "https://pokeapi.co/api/v2/item/795/"
    },
    {
      "name": "altarianite",
      "url": "https://pokeapi.co/api/v2/item/796/"
    },
    {
      "name": "galladite",
      "url": "https://pokeapi.co/api/v2/item/797/"
    },
    {
      "name": "audinite",
      "url": "https://pokeapi.co/api/v2/item/798/"
    },
    {
      "name": "metagrossite",
      "url": "https://pokeapi.co/api/v2/item/799/"
    },
    {
      "name": "sharpedonite",
      "url": "https://pokeapi.co/api/v2/item/800/"
    },
    {
      "name": "slowbronite",
      "url": "https://pokeapi.co/api/v2/item/801/"
    },
    {
      "name": "steelixite",
      "url": "https://pokeapi.co/api/v2/item/802/"
    },
    {
      "name": "pidgeotite",
      "url": "https://pokeapi.co/api/v2/item/803/"
    },
    {
      "name": "glalitite",
      "url": "https://pokeapi.co/api/v2/item/804/"
    },
    {
      "name": "diancite",
      "url": "https://pokeapi.co/api/v2/item/805/"
    },
    {
      "name": "prison-bottle",
      "url": "https://pokeapi.co/api/v2/item/806/"
    },
    {
      "name": "mega-cuff",
      "url": "https://pokeapi.co/api/v2/item/807/"
    },
    {
      "name": "cameruptite",
      "url": "https://pokeapi.co/api/v2/item/808/"
    },
    {
      "name": "lopunnite",
      "url": "https://pokeapi.co/api/v2/item/809/"
    },
    {
      "name": "salamencite",
      "url": "https://pokeapi.co/api/v2/item/810/"
    },
    {
      "name": "beedrillite",
      "url": "https://pokeapi.co/api/v2/item/811/"
    },
    {
      "name": "key-stone",
      "url": "https://pokeapi.co/api/v2/item/814/"
    },
    {
      "name": "meteorite-shard",
      "url": "https://pokeapi.co/api/v2/item/815/"
    },
    {
      "name": "eon-flute",
      "url": "https://pokeapi.co/api/v2/item/816/"
    },
    {
      "name": "normalium-z--held",
      "url": "https://pokeapi.co/api/v2/item/817/"
    },
    {
      "name": "firium-z--held",
      "url": "https://pokeapi.co/api/v2/item/818/"
    },
    {
      "name": "waterium-z--held",
      "url": "https://pokeapi.co/api/v2/item/819/"
    },
    {
      "name": "electrium-z--held",
      "url": "https://pokeapi.co/api/v2/item/820/"
    },
    {
      "name": "grassium-z--held",
      "url": "https://pokeapi.co/api/v2/item/821/"
    },
    {
      "name": "icium-z--held",
      "url": "https://pokeapi.co/api/v2/item/822/"
    },
    {
      "name": "fightinium-z--held",
      "url": "https://pokeapi.co/api/v2/item/823/"
    },
    {
      "name": "poisonium-z--held",
      "url": "https://pokeapi.co/api/v2/item/824/"
    },
    {
      "name": "groundium-z--held",
      "url": "https://pokeapi.co/api/v2/item/825/"
    },
    {
      "name": "flyinium-z--held",
      "url": "https://pokeapi.co/api/v2/item/826/"
    },
    {
      "name": "psychium-z--held",
      "url": "https://pokeapi.co/api/v2/item/827/"
    },
    {
      "name": "buginium-z--held",
      "url": "https://pokeapi.co/api/v2/item/828/"
    },
    {
      "name": "rockium-z--held",
      "url": "https://pokeapi.co/api/v2/item/829/"
    },
    {
      "name": "ghostium-z--held",
      "url": "https://pokeapi.co/api/v2/item/830/"
    },
    {
      "name": "dragonium-z--held",
      "url": "https://pokeapi.co/api/v2/item/831/"
    },
    {
      "name": "darkinium-z--held",
      "url": "https://pokeapi.co/api/v2/item/832/"
    },
    {
      "name": "steelium-z--held",
      "url": "https://pokeapi.co/api/v2/item/833/"
    },
    {
      "name": "fairium-z--held",
      "url": "https://pokeapi.co/api/v2/item/834/"
    },
    {
      "name": "pikanium-z--held",
      "url": "https://pokeapi.co/api/v2/item/835/"
    },
    {
      "name": "bottle-cap",
      "url": "https://pokeapi.co/api/v2/item/836/"
    },
    {
      "name": "gold-bottle-cap",
      "url": "https://pokeapi.co/api/v2/item/837/"
    },
    {
      "name": "z-ring",
      "url": "https://pokeapi.co/api/v2/item/838/"
    },
    {
      "name": "decidium-z--held",
      "url": "https://pokeapi.co/api/v2/item/839/"
    },
    {
      "name": "incinium-z--held",
      "url": "https://pokeapi.co/api/v2/item/840/"
    },
    {
      "name": "primarium-z--held",
      "url": "https://pokeapi.co/api/v2/item/841/"
    },
    {
      "name": "tapunium-z--held",
      "url": "https://pokeapi.co/api/v2/item/842/"
    },
    {
      "name": "marshadium-z--held",
      "url": "https://pokeapi.co/api/v2/item/843/"
    },
    {
      "name": "aloraichium-z--held",
      "url": "https://pokeapi.co/api/v2/item/844/"
    },
    {
      "name": "snorlium-z--held",
      "url": "https://pokeapi.co/api/v2/item/845/"
    },
    {
      "name": "eevium-z--held",
      "url": "https://pokeapi.co/api/v2/item/846/"
    },
    {
      "name": "mewnium-z--held",
      "url": "https://pokeapi.co/api/v2/item/847/"
    },
    {
      "name": "pikashunium-z--held",
      "url": "https://pokeapi.co/api/v2/item/877/"
    },
    {
      "name": "forage-bag",
      "url": "https://pokeapi.co/api/v2/item/878/"
    },
    {
      "name": "fishing-rod",
      "url": "https://pokeapi.co/api/v2/item/879/"
    },
    {
      "name": "professors-mask",
      "url": "https://pokeapi.co/api/v2/item/880/"
    },
    {
      "name": "festival-ticket",
      "url": "https://pokeapi.co/api/v2/item/881/"
    },
    {
      "name": "sparkling-stone",
      "url": "https://pokeapi.co/api/v2/item/882/"
    },
    {
      "name": "adrenaline-orb",
      "url": "https://pokeapi.co/api/v2/item/883/"
    },
    {
      "name": "zygarde-cube",
      "url": "https://pokeapi.co/api/v2/item/884/"
    },
    {
      "name": "ice-stone",
      "url": "https://pokeapi.co/api/v2/item/885/"
    },
    {
      "name": "ride-pager",
      "url": "https://pokeapi.co/api/v2/item/886/"
    },
    {
      "name": "beast-ball",
      "url": "https://pokeapi.co/api/v2/item/887/"
    },
    {
      "name": "big-malasada",
      "url": "https://pokeapi.co/api/v2/item/888/"
    },
    {
      "name": "red-nectar",
      "url": "https://pokeapi.co/api/v2/item/889/"
    },
    {
      "name": "yellow-nectar",
      "url": "https://pokeapi.co/api/v2/item/890/"
    },
    {
      "name": "pink-nectar",
      "url": "https://pokeapi.co/api/v2/item/891/"
    },
    {
      "name": "purple-nectar",
      "url": "https://pokeapi.co/api/v2/item/892/"
    },
    {
      "name": "sun-flute",
      "url": "https://pokeapi.co/api/v2/item/893/"
    },
    {
      "name": "moon-flute",
      "url": "https://pokeapi.co/api/v2/item/894/"
    },
    {
      "name": "enigmatic-card",
      "url": "https://pokeapi.co/api/v2/item/895/"
    },
    {
      "name": "terrain-extender",
      "url": "https://pokeapi.co/api/v2/item/896/"
    },
    {
      "name": "protective-pads",
      "url": "https://pokeapi.co/api/v2/item/897/"
    },
    {
      "name": "electric-seed",
      "url": "https://pokeapi.co/api/v2/item/898/"
    },
    {
      "name": "psychic-seed",
      "url": "https://pokeapi.co/api/v2/item/899/"
    },
    {
      "name": "misty-seed",
      "url": "https://pokeapi.co/api/v2/item/900/"
    },
    {
      "name": "grassy-seed",
      "url": "https://pokeapi.co/api/v2/item/901/"
    },
    {
      "name": "fighting-memory",
      "url": "https://pokeapi.co/api/v2/item/902/"
    },
    {
      "name": "flying-memory",
      "url": "https://pokeapi.co/api/v2/item/903/"
    },
    {
      "name": "poison-memory",
      "url": "https://pokeapi.co/api/v2/item/904/"
    },
    {
      "name": "ground-memory",
      "url": "https://pokeapi.co/api/v2/item/905/"
    },
    {
      "name": "rock-memory",
      "url": "https://pokeapi.co/api/v2/item/906/"
    },
    {
      "name": "bug-memory",
      "url": "https://pokeapi.co/api/v2/item/907/"
    },
    {
      "name": "ghost-memory",
      "url": "https://pokeapi.co/api/v2/item/908/"
    },
    {
      "name": "steel-memory",
      "url": "https://pokeapi.co/api/v2/item/909/"
    },
    {
      "name": "fire-memory",
      "url": "https://pokeapi.co/api/v2/item/910/"
    },
    {
      "name": "water-memory",
      "url": "https://pokeapi.co/api/v2/item/911/"
    },
    {
      "name": "grass-memory",
      "url": "https://pokeapi.co/api/v2/item/912/"
    },
    {
      "name": "electric-memory",
      "url": "https://pokeapi.co/api/v2/item/913/"
    },
    {
      "name": "psychic-memory",
      "url": "https://pokeapi.co/api/v2/item/914/"
    },
    {
      "name": "ice-memory",
      "url": "https://pokeapi.co/api/v2/item/915/"
    },
    {
      "name": "dragon-memory",
      "url": "https://pokeapi.co/api/v2/item/916/"
    },
    {
      "name": "dark-memory",
      "url": "https://pokeapi.co/api/v2/item/917/"
    },
    {
      "name": "fairy-memory",
      "url": "https://pokeapi.co/api/v2/item/918/"
    },
    {
      "name": "bike--green",
      "url": "https://pokeapi.co/api/v2/item/919/"
    },
    {
      "name": "storage-key--galactic-warehouse",
      "url": "https://pokeapi.co/api/v2/item/920/"
    },
    {
      "name": "basement-key--goldenrod",
      "url": "https://pokeapi.co/api/v2/item/921/"
    },
    {
      "name": "xtransceiver--red",
      "url": "https://pokeapi.co/api/v2/item/922/"
    },
    {
      "name": "xtransceiver--yellow",
      "url": "https://pokeapi.co/api/v2/item/923/"
    },
    {
      "name": "dna-splicers--merge",
      "url": "https://pokeapi.co/api/v2/item/924/"
    },
    {
      "name": "dna-splicers--split",
      "url": "https://pokeapi.co/api/v2/item/925/"
    },
    {
      "name": "dropped-item--red",
      "url": "https://pokeapi.co/api/v2/item/926/"
    },
    {
      "name": "dropped-item--yellow",
      "url": "https://pokeapi.co/api/v2/item/927/"
    },
    {
      "name": "holo-caster--green",
      "url": "https://pokeapi.co/api/v2/item/928/"
    },
    {
      "name": "bike--yellow",
      "url": "https://pokeapi.co/api/v2/item/929/"
    },
    {
      "name": "holo-caster--red",
      "url": "https://pokeapi.co/api/v2/item/930/"
    },
    {
      "name": "basement-key--new-mauville",
      "url": "https://pokeapi.co/api/v2/item/931/"
    },
    {
      "name": "storage-key--sea-mauville",
      "url": "https://pokeapi.co/api/v2/item/932/"
    },
    {
      "name": "ss-ticket--hoenn",
      "url": "https://pokeapi.co/api/v2/item/933/"
    },
    {
      "name": "contest-costume--dress",
      "url": "https://pokeapi.co/api/v2/item/934/"
    },
    {
      "name": "meteorite--2",
      "url": "https://pokeapi.co/api/v2/item/935/"
    },
    {
      "name": "meteorite--3",
      "url": "https://pokeapi.co/api/v2/item/936/"
    },
    {
      "name": "meteorite--4",
      "url": "https://pokeapi.co/api/v2/item/937/"
    },
    {
      "name": "normalium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/938/"
    },
    {
      "name": "firium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/939/"
    },
    {
      "name": "waterium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/940/"
    },
    {
      "name": "electrium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/941/"
    },
    {
      "name": "grassium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/942/"
    },
    {
      "name": "icium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/943/"
    },
    {
      "name": "fightinium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/944/"
    },
    {
      "name": "poisonium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/945/"
    },
    {
      "name": "groundium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/946/"
    },
    {
      "name": "flyinium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/947/"
    },
    {
      "name": "psychium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/948/"
    },
    {
      "name": "buginium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/949/"
    },
    {
      "name": "rockium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/950/"
    },
    {
      "name": "ghostium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/951/"
    },
    {
      "name": "dragonium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/952/"
    },
    {
      "name": "darkinium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/953/"
    },
    {
      "name": "steelium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/954/"
    },
    {
      "name": "fairium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/955/"
    },
    {
      "name": "pikanium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/956/"
    },
    {
      "name": "decidium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/957/"
    },
    {
      "name": "incinium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/958/"
    },
    {
      "name": "primarium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/959/"
    },
    {
      "name": "tapunium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/960/"
    },
    {
      "name": "marshadium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/961/"
    },
    {
      "name": "aloraichium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/962/"
    },
    {
      "name": "snorlium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/963/"
    },
    {
      "name": "eevium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/964/"
    },
    {
      "name": "mewnium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/965/"
    },
    {
      "name": "pikashunium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/966/"
    },
    {
      "name": "solganium-z--held",
      "url": "https://pokeapi.co/api/v2/item/967/"
    },
    {
      "name": "lunalium-z--held",
      "url": "https://pokeapi.co/api/v2/item/968/"
    },
    {
      "name": "ultranecrozium-z--held",
      "url": "https://pokeapi.co/api/v2/item/969/"
    },
    {
      "name": "mimikium-z--held",
      "url": "https://pokeapi.co/api/v2/item/970/"
    },
    {
      "name": "lycanium-z--held",
      "url": "https://pokeapi.co/api/v2/item/971/"
    },
    {
      "name": "kommonium-z--held",
      "url": "https://pokeapi.co/api/v2/item/972/"
    },
    {
      "name": "solganium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/973/"
    },
    {
      "name": "lunalium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/974/"
    },
    {
      "name": "ultranecrozium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/975/"
    },
    {
      "name": "mimikium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/976/"
    },
    {
      "name": "lycanium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/977/"
    },
    {
      "name": "kommonium-z--bag",
      "url": "https://pokeapi.co/api/v2/item/978/"
    },
    {
      "name": "z-power-ring",
      "url": "https://pokeapi.co/api/v2/item/979/"
    },
    {
      "name": "pink-petal",
      "url": "https://pokeapi.co/api/v2/item/980/"
    },
    {
      "name": "orange-petal",
      "url": "https://pokeapi.co/api/v2/item/981/"
    },
    {
      "name": "blue-petal",
      "url": "https://pokeapi.co/api/v2/item/982/"
    },
    {
      "name": "red-petal",
      "url": "https://pokeapi.co/api/v2/item/983/"
    },
    {
      "name": "green-petal",
      "url": "https://pokeapi.co/api/v2/item/984/"
    },
    {
      "name": "yellow-petal",
      "url": "https://pokeapi.co/api/v2/item/985/"
    },
    {
      "name": "purple-petal",
      "url": "https://pokeapi.co/api/v2/item/986/"
    },
    {
      "name": "rainbow-flower",
      "url": "https://pokeapi.co/api/v2/item/987/"
    },
    {
      "name": "surge-badge",
      "url": "https://pokeapi.co/api/v2/item/988/"
    },
    {
      "name": "n-solarizer--merge",
      "url": "https://pokeapi.co/api/v2/item/989/"
    },
    {
      "name": "n-lunarizer--merge",
      "url": "https://pokeapi.co/api/v2/item/990/"
    },
    {
      "name": "n-solarizer--split",
      "url": "https://pokeapi.co/api/v2/item/991/"
    },
    {
      "name": "n-lunarizer--split",
      "url": "https://pokeapi.co/api/v2/item/992/"
    },
    {
      "name": "ilimas-normalium-z",
      "url": "https://pokeapi.co/api/v2/item/993/"
    },
    {
      "name": "left-poke-ball",
      "url": "https://pokeapi.co/api/v2/item/994/"
    },
    {
      "name": "roto-hatch",
      "url": "https://pokeapi.co/api/v2/item/995/"
    },
    {
      "name": "roto-bargain",
      "url": "https://pokeapi.co/api/v2/item/996/"
    },
    {
      "name": "roto-prize-money",
      "url": "https://pokeapi.co/api/v2/item/997/"
    },
    {
      "name": "roto-exp-points",
      "url": "https://pokeapi.co/api/v2/item/998/"
    },
    {
      "name": "roto-friendship",
      "url": "https://pokeapi.co/api/v2/item/999/"
    },
    {
      "name": "roto-encounter",
      "url": "https://pokeapi.co/api/v2/item/1000/"
    },
    {
      "name": "roto-stealth",
      "url": "https://pokeapi.co/api/v2/item/1001/"
    },
    {
      "name": "roto-hp-restore",
      "url": "https://pokeapi.co/api/v2/item/1002/"
    },
    {
      "name": "roto-pp-restore",
      "url": "https://pokeapi.co/api/v2/item/1003/"
    },
    {
      "name": "roto-boost",
      "url": "https://pokeapi.co/api/v2/item/1004/"
    },
    {
      "name": "roto-catch",
      "url": "https://pokeapi.co/api/v2/item/1005/"
    },
    {
      "name": "autograph",
      "url": "https://pokeapi.co/api/v2/item/1006/"
    },
    {
      "name": "pokemon-box",
      "url": "https://pokeapi.co/api/v2/item/1007/"
    },
    {
      "name": "medicine-pocket",
      "url": "https://pokeapi.co/api/v2/item/1008/"
    },
    {
      "name": "candy-jar",
      "url": "https://pokeapi.co/api/v2/item/1009/"
    },
    {
      "name": "power-up-pocket",
      "url": "https://pokeapi.co/api/v2/item/1010/"
    },
    {
      "name": "clothing-trunk",
      "url": "https://pokeapi.co/api/v2/item/1011/"
    },
    {
      "name": "catching-pocket",
      "url": "https://pokeapi.co/api/v2/item/1012/"
    },
    {
      "name": "battle-pocket",
      "url": "https://pokeapi.co/api/v2/item/1013/"
    },
    {
      "name": "silver-razz-berry",
      "url": "https://pokeapi.co/api/v2/item/1014/"
    },
    {
      "name": "golden-razz-berry",
      "url": "https://pokeapi.co/api/v2/item/1015/"
    },
    {
      "name": "silver-nanab-berry",
      "url": "https://pokeapi.co/api/v2/item/1016/"
    },
    {
      "name": "golden-nanab-berry",
      "url": "https://pokeapi.co/api/v2/item/1017/"
    },
    {
      "name": "silver-pinap-berry",
      "url": "https://pokeapi.co/api/v2/item/1018/"
    },
    {
      "name": "golden-pinap-berry",
      "url": "https://pokeapi.co/api/v2/item/1019/"
    },
    {
      "name": "secret-key--letsgo",
      "url": "https://pokeapi.co/api/v2/item/1020/"
    },
    {
      "name": "ss-ticket--letsgo",
      "url": "https://pokeapi.co/api/v2/item/1021/"
    },
    {
      "name": "parcel--letsgo",
      "url": "https://pokeapi.co/api/v2/item/1022/"
    },
    {
      "name": "card-key--letsgo",
      "url": "https://pokeapi.co/api/v2/item/1023/"
    },
    {
      "name": "stretchy-spring",
      "url": "https://pokeapi.co/api/v2/item/1024/"
    },
    {
      "name": "chalky-stone",
      "url": "https://pokeapi.co/api/v2/item/1025/"
    },
    {
      "name": "marble",
      "url": "https://pokeapi.co/api/v2/item/1026/"
    },
    {
      "name": "lone-earring",
      "url": "https://pokeapi.co/api/v2/item/1027/"
    },
    {
      "name": "beach-glass",
      "url": "https://pokeapi.co/api/v2/item/1028/"
    },
    {
      "name": "gold-leaf",
      "url": "https://pokeapi.co/api/v2/item/1029/"
    },
    {
      "name": "silver-leaf",
      "url": "https://pokeapi.co/api/v2/item/1030/"
    },
    {
      "name": "polished-mud-ball",
      "url": "https://pokeapi.co/api/v2/item/1031/"
    },
    {
      "name": "tropical-shell",
      "url": "https://pokeapi.co/api/v2/item/1032/"
    },
    {
      "name": "leaf-letter--pikachu",
      "url": "https://pokeapi.co/api/v2/item/1033/"
    },
    {
      "name": "leaf-letter--eevee",
      "url": "https://pokeapi.co/api/v2/item/1034/"
    },
    {
      "name": "small-bouquet",
      "url": "https://pokeapi.co/api/v2/item/1035/"
    },
    {
      "name": "lure",
      "url": "https://pokeapi.co/api/v2/item/1036/"
    },
    {
      "name": "super-lure",
      "url": "https://pokeapi.co/api/v2/item/1037/"
    },
    {
      "name": "max-lure",
      "url": "https://pokeapi.co/api/v2/item/1038/"
    },
    {
      "name": "pewter-crunchies",
      "url": "https://pokeapi.co/api/v2/item/1039/"
    },
    {
      "name": "health-candy",
      "url": "https://pokeapi.co/api/v2/item/1040/"
    },
    {
      "name": "mighty-candy",
      "url": "https://pokeapi.co/api/v2/item/1041/"
    },
    {
      "name": "tough-candy",
      "url": "https://pokeapi.co/api/v2/item/1042/"
    },
    {
      "name": "smart-candy",
      "url": "https://pokeapi.co/api/v2/item/1043/"
    },
    {
      "name": "courage-candy",
      "url": "https://pokeapi.co/api/v2/item/1044/"
    },
    {
      "name": "quick-candy",
      "url": "https://pokeapi.co/api/v2/item/1045/"
    },
    {
      "name": "health-candy-l",
      "url": "https://pokeapi.co/api/v2/item/1046/"
    },
    {
      "name": "mighty-candy-l",
      "url": "https://pokeapi.co/api/v2/item/1047/"
    },
    {
      "name": "tough-candy-l",
      "url": "https://pokeapi.co/api/v2/item/1048/"
    },
    {
      "name": "smart-candy-l",
      "url": "https://pokeapi.co/api/v2/item/1049/"
    },
    {
      "name": "courage-candy-l",
      "url": "https://pokeapi.co/api/v2/item/1050/"
    },
    {
      "name": "quick-candy-l",
      "url": "https://pokeapi.co/api/v2/item/1051/"
    },
    {
      "name": "health-candy-xl",
      "url": "https://pokeapi.co/api/v2/item/1052/"
    },
    {
      "name": "mighty-candy-xl",
      "url": "https://pokeapi.co/api/v2/item/1053/"
    },
    {
      "name": "tough-candy-xl",
      "url": "https://pokeapi.co/api/v2/item/1054/"
    },
    {
      "name": "smart-candy-xl",
      "url": "https://pokeapi.co/api/v2/item/1055/"
    },
    {
      "name": "courage-candy-xl",
      "url": "https://pokeapi.co/api/v2/item/1056/"
    },
    {
      "name": "quick-candy-xl",
      "url": "https://pokeapi.co/api/v2/item/1057/"
    },
    {
      "name": "bulbasaur-candy",
      "url": "https://pokeapi.co/api/v2/item/1058/"
    },
    {
      "name": "charmander-candy",
      "url": "https://pokeapi.co/api/v2/item/1059/"
    },
    {
      "name": "squirtle-candy",
      "url": "https://pokeapi.co/api/v2/item/1060/"
    },
    {
      "name": "caterpie-candy",
      "url": "https://pokeapi.co/api/v2/item/1061/"
    },
    {
      "name": "weedle-candy",
      "url": "https://pokeapi.co/api/v2/item/1062/"
    },
    {
      "name": "pidgey-candy",
      "url": "https://pokeapi.co/api/v2/item/1063/"
    },
    {
      "name": "rattata-candy",
      "url": "https://pokeapi.co/api/v2/item/1064/"
    },
    {
      "name": "spearow-candy",
      "url": "https://pokeapi.co/api/v2/item/1065/"
    },
    {
      "name": "ekans-candy",
      "url": "https://pokeapi.co/api/v2/item/1066/"
    },
    {
      "name": "pikachu-candy",
      "url": "https://pokeapi.co/api/v2/item/1067/"
    },
    {
      "name": "sandshrew-candy",
      "url": "https://pokeapi.co/api/v2/item/1068/"
    },
    {
      "name": "nidoran-f-candy",
      "url": "https://pokeapi.co/api/v2/item/1069/"
    },
    {
      "name": "nidoran-m-candy",
      "url": "https://pokeapi.co/api/v2/item/1070/"
    },
    {
      "name": "clefairy-candy",
      "url": "https://pokeapi.co/api/v2/item/1071/"
    },
    {
      "name": "vulpix-candy",
      "url": "https://pokeapi.co/api/v2/item/1072/"
    },
    {
      "name": "jigglypuff-candy",
      "url": "https://pokeapi.co/api/v2/item/1073/"
    },
    {
      "name": "zubat-candy",
      "url": "https://pokeapi.co/api/v2/item/1074/"
    },
    {
      "name": "oddish-candy",
      "url": "https://pokeapi.co/api/v2/item/1075/"
    },
    {
      "name": "paras-candy",
      "url": "https://pokeapi.co/api/v2/item/1076/"
    },
    {
      "name": "venonat-candy",
      "url": "https://pokeapi.co/api/v2/item/1077/"
    },
    {
      "name": "diglett-candy",
      "url": "https://pokeapi.co/api/v2/item/1078/"
    },
    {
      "name": "meowth-candy",
      "url": "https://pokeapi.co/api/v2/item/1079/"
    },
    {
      "name": "psyduck-candy",
      "url": "https://pokeapi.co/api/v2/item/1080/"
    },
    {
      "name": "mankey-candy",
      "url": "https://pokeapi.co/api/v2/item/1081/"
    },
    {
      "name": "growlithe-candy",
      "url": "https://pokeapi.co/api/v2/item/1082/"
    },
    {
      "name": "poliwag-candy",
      "url": "https://pokeapi.co/api/v2/item/1083/"
    },
    {
      "name": "abra-candy",
      "url": "https://pokeapi.co/api/v2/item/1084/"
    },
    {
      "name": "machop-candy",
      "url": "https://pokeapi.co/api/v2/item/1085/"
    },
    {
      "name": "bellsprout-candy",
      "url": "https://pokeapi.co/api/v2/item/1086/"
    },
    {
      "name": "tentacool-candy",
      "url": "https://pokeapi.co/api/v2/item/1087/"
    },
    {
      "name": "geodude-candy",
      "url": "https://pokeapi.co/api/v2/item/1088/"
    },
    {
      "name": "ponyta-candy",
      "url": "https://pokeapi.co/api/v2/item/1089/"
    },
    {
      "name": "slowpoke-candy",
      "url": "https://pokeapi.co/api/v2/item/1090/"
    },
    {
      "name": "magnemite-candy",
      "url": "https://pokeapi.co/api/v2/item/1091/"
    },
    {
      "name": "farfetchd-candy",
      "url": "https://pokeapi.co/api/v2/item/1092/"
    },
    {
      "name": "doduo-candy",
      "url": "https://pokeapi.co/api/v2/item/1093/"
    },
    {
      "name": "seel-candy",
      "url": "https://pokeapi.co/api/v2/item/1094/"
    },
    {
      "name": "grimer-candy",
      "url": "https://pokeapi.co/api/v2/item/1095/"
    },
    {
      "name": "shellder-candy",
      "url": "https://pokeapi.co/api/v2/item/1096/"
    },
    {
      "name": "gastly-candy",
      "url": "https://pokeapi.co/api/v2/item/1097/"
    },
    {
      "name": "onix-candy",
      "url": "https://pokeapi.co/api/v2/item/1098/"
    },
    {
      "name": "drowzee-candy",
      "url": "https://pokeapi.co/api/v2/item/1099/"
    },
    {
      "name": "krabby-candy",
      "url": "https://pokeapi.co/api/v2/item/1100/"
    },
    {
      "name": "voltorb-candy",
      "url": "https://pokeapi.co/api/v2/item/1101/"
    },
    {
      "name": "exeggcute-candy",
      "url": "https://pokeapi.co/api/v2/item/1102/"
    },
    {
      "name": "cubone-candy",
      "url": "https://pokeapi.co/api/v2/item/1103/"
    },
    {
      "name": "hitmonlee-candy",
      "url": "https://pokeapi.co/api/v2/item/1104/"
    },
    {
      "name": "hitmonchan-candy",
      "url": "https://pokeapi.co/api/v2/item/1105/"
    },
    {
      "name": "lickitung-candy",
      "url": "https://pokeapi.co/api/v2/item/1106/"
    },
    {
      "name": "koffing-candy",
      "url": "https://pokeapi.co/api/v2/item/1107/"
    },
    {
      "name": "rhyhorn-candy",
      "url": "https://pokeapi.co/api/v2/item/1108/"
    },
    {
      "name": "chansey-candy",
      "url": "https://pokeapi.co/api/v2/item/1109/"
    },
    {
      "name": "tangela-candy",
      "url": "https://pokeapi.co/api/v2/item/1110/"
    },
    {
      "name": "kangaskhan-candy",
      "url": "https://pokeapi.co/api/v2/item/1111/"
    },
    {
      "name": "horsea-candy",
      "url": "https://pokeapi.co/api/v2/item/1112/"
    },
    {
      "name": "goldeen-candy",
      "url": "https://pokeapi.co/api/v2/item/1113/"
    },
    {
      "name": "staryu-candy",
      "url": "https://pokeapi.co/api/v2/item/1114/"
    },
    {
      "name": "mr-mime-candy",
      "url": "https://pokeapi.co/api/v2/item/1115/"
    },
    {
      "name": "scyther-candy",
      "url": "https://pokeapi.co/api/v2/item/1116/"
    },
    {
      "name": "jynx-candy",
      "url": "https://pokeapi.co/api/v2/item/1117/"
    },
    {
      "name": "electabuzz-candy",
      "url": "https://pokeapi.co/api/v2/item/1118/"
    },
    {
      "name": "pinsir-candy",
      "url": "https://pokeapi.co/api/v2/item/1119/"
    },
    {
      "name": "tauros-candy",
      "url": "https://pokeapi.co/api/v2/item/1120/"
    },
    {
      "name": "magikarp-candy",
      "url": "https://pokeapi.co/api/v2/item/1121/"
    },
    {
      "name": "lapras-candy",
      "url": "https://pokeapi.co/api/v2/item/1122/"
    },
    {
      "name": "ditto-candy",
      "url": "https://pokeapi.co/api/v2/item/1123/"
    },
    {
      "name": "eevee-candy",
      "url": "https://pokeapi.co/api/v2/item/1124/"
    },
    {
      "name": "porygon-candy",
      "url": "https://pokeapi.co/api/v2/item/1125/"
    },
    {
      "name": "omanyte-candy",
      "url": "https://pokeapi.co/api/v2/item/1126/"
    },
    {
      "name": "kabuto-candy",
      "url": "https://pokeapi.co/api/v2/item/1127/"
    },
    {
      "name": "aerodactyl-candy",
      "url": "https://pokeapi.co/api/v2/item/1128/"
    },
    {
      "name": "snorlax-candy",
      "url": "https://pokeapi.co/api/v2/item/1129/"
    },
    {
      "name": "articuno-candy",
      "url": "https://pokeapi.co/api/v2/item/1130/"
    },
    {
      "name": "zapdos-candy",
      "url": "https://pokeapi.co/api/v2/item/1131/"
    },
    {
      "name": "moltres-candy",
      "url": "https://pokeapi.co/api/v2/item/1132/"
    },
    {
      "name": "dratini-candy",
      "url": "https://pokeapi.co/api/v2/item/1133/"
    },
    {
      "name": "mewtwo-candy",
      "url": "https://pokeapi.co/api/v2/item/1134/"
    },
    {
      "name": "mew-candy",
      "url": "https://pokeapi.co/api/v2/item/1135/"
    },
    {
      "name": "meltan-candy",
      "url": "https://pokeapi.co/api/v2/item/1136/"
    },
    {
      "name": "magmar-candy",
      "url": "https://pokeapi.co/api/v2/item/1137/"
    },
    {
      "name": "endorsement",
      "url": "https://pokeapi.co/api/v2/item/1138/"
    },
    {
      "name": "pokemon-box-link",
      "url": "https://pokeapi.co/api/v2/item/1139/"
    },
    {
      "name": "wishing-star",
      "url": "https://pokeapi.co/api/v2/item/1140/"
    },
    {
      "name": "dynamax-band",
      "url": "https://pokeapi.co/api/v2/item/1141/"
    },
    {
      "name": "fishing-rod--galar",
      "url": "https://pokeapi.co/api/v2/item/1142/"
    },
    {
      "name": "rotom-bike",
      "url": "https://pokeapi.co/api/v2/item/1143/"
    },
    {
      "name": "sausages",
      "url": "https://pokeapi.co/api/v2/item/1144/"
    },
    {
      "name": "bobs-food-tin",
      "url": "https://pokeapi.co/api/v2/item/1145/"
    },
    {
      "name": "bachs-food-tin",
      "url": "https://pokeapi.co/api/v2/item/1146/"
    },
    {
      "name": "tin-of-beans",
      "url": "https://pokeapi.co/api/v2/item/1147/"
    },
    {
      "name": "bread",
      "url": "https://pokeapi.co/api/v2/item/1148/"
    },
    {
      "name": "pasta",
      "url": "https://pokeapi.co/api/v2/item/1149/"
    },
    {
      "name": "mixed-mushrooms",
      "url": "https://pokeapi.co/api/v2/item/1150/"
    },
    {
      "name": "smoke-poke-tail",
      "url": "https://pokeapi.co/api/v2/item/1151/"
    },
    {
      "name": "large-leek",
      "url": "https://pokeapi.co/api/v2/item/1152/"
    },
    {
      "name": "fancy-apple",
      "url": "https://pokeapi.co/api/v2/item/1153/"
    },
    {
      "name": "brittle-bones",
      "url": "https://pokeapi.co/api/v2/item/1154/"
    },
    {
      "name": "pack-of-potatoes",
      "url": "https://pokeapi.co/api/v2/item/1155/"
    },
    {
      "name": "pungent-root",
      "url": "https://pokeapi.co/api/v2/item/1156/"
    },
    {
      "name": "salad-mix",
      "url": "https://pokeapi.co/api/v2/item/1157/"
    },
    {
      "name": "fried-food",
      "url": "https://pokeapi.co/api/v2/item/1158/"
    },
    {
      "name": "boiled-egg",
      "url": "https://pokeapi.co/api/v2/item/1159/"
    },
    {
      "name": "camping-gear",
      "url": "https://pokeapi.co/api/v2/item/1160/"
    },
    {
      "name": "rusted-sword",
      "url": "https://pokeapi.co/api/v2/item/1161/"
    },
    {
      "name": "rusted-shield",
      "url": "https://pokeapi.co/api/v2/item/1162/"
    },
    {
      "name": "fossilized-bird",
      "url": "https://pokeapi.co/api/v2/item/1163/"
    },
    {
      "name": "fossilized-fish",
      "url": "https://pokeapi.co/api/v2/item/1164/"
    },
    {
      "name": "fossilized-drake",
      "url": "https://pokeapi.co/api/v2/item/1165/"
    },
    {
      "name": "fossilized-dino",
      "url": "https://pokeapi.co/api/v2/item/1166/"
    },
    {
      "name": "strawberry-sweet",
      "url": "https://pokeapi.co/api/v2/item/1167/"
    },
    {
      "name": "love-sweet",
      "url": "https://pokeapi.co/api/v2/item/1168/"
    },
    {
      "name": "berry-sweet",
      "url": "https://pokeapi.co/api/v2/item/1169/"
    },
    {
      "name": "clover-sweet",
      "url": "https://pokeapi.co/api/v2/item/1170/"
    },
    {
      "name": "flower-sweet",
      "url": "https://pokeapi.co/api/v2/item/1171/"
    },
    {
      "name": "star-sweet",
      "url": "https://pokeapi.co/api/v2/item/1172/"
    },
    {
      "name": "ribbon-sweet",
      "url": "https://pokeapi.co/api/v2/item/1173/"
    },
    {
      "name": "sweet-apple",
      "url": "https://pokeapi.co/api/v2/item/1174/"
    },
    {
      "name": "tart-apple",
      "url": "https://pokeapi.co/api/v2/item/1175/"
    },
    {
      "name": "throat-spray",
      "url": "https://pokeapi.co/api/v2/item/1176/"
    },
    {
      "name": "eject-pack",
      "url": "https://pokeapi.co/api/v2/item/1177/"
    },
    {
      "name": "heavy-duty-boots",
      "url": "https://pokeapi.co/api/v2/item/1178/"
    },
    {
      "name": "blunder-policy",
      "url": "https://pokeapi.co/api/v2/item/1179/"
    },
    {
      "name": "room-service",
      "url": "https://pokeapi.co/api/v2/item/1180/"
    },
    {
      "name": "utility-umbrella",
      "url": "https://pokeapi.co/api/v2/item/1181/"
    },
    {
      "name": "exp-candy-xs",
      "url": "https://pokeapi.co/api/v2/item/1182/"
    },
    {
      "name": "exp-candy-s",
      "url": "https://pokeapi.co/api/v2/item/1183/"
    },
    {
      "name": "exp-candy-m",
      "url": "https://pokeapi.co/api/v2/item/1184/"
    },
    {
      "name": "exp-candy-l",
      "url": "https://pokeapi.co/api/v2/item/1185/"
    },
    {
      "name": "exp-candy-xl",
      "url": "https://pokeapi.co/api/v2/item/1186/"
    },
    {
      "name": "dynamax-candy",
      "url": "https://pokeapi.co/api/v2/item/1187/"
    },
    {
      "name": "tr00",
      "url": "https://pokeapi.co/api/v2/item/1188/"
    },
    {
      "name": "tr01",
      "url": "https://pokeapi.co/api/v2/item/1189/"
    },
    {
      "name": "tr02",
      "url": "https://pokeapi.co/api/v2/item/1190/"
    },
    {
      "name": "tr03",
      "url": "https://pokeapi.co/api/v2/item/1191/"
    },
    {
      "name": "tr04",
      "url": "https://pokeapi.co/api/v2/item/1192/"
    },
    {
      "name": "tr05",
      "url": "https://pokeapi.co/api/v2/item/1193/"
    },
    {
      "name": "tr06",
      "url": "https://pokeapi.co/api/v2/item/1194/"
    },
    {
      "name": "tr07",
      "url": "https://pokeapi.co/api/v2/item/1195/"
    },
    {
      "name": "tr08",
      "url": "https://pokeapi.co/api/v2/item/1196/"
    },
    {
      "name": "tr09",
      "url": "https://pokeapi.co/api/v2/item/1197/"
    },
    {
      "name": "tr10",
      "url": "https://pokeapi.co/api/v2/item/1198/"
    },
    {
      "name": "tr11",
      "url": "https://pokeapi.co/api/v2/item/1199/"
    },
    {
      "name": "tr12",
      "url": "https://pokeapi.co/api/v2/item/1200/"
    },
    {
      "name": "tr13",
      "url": "https://pokeapi.co/api/v2/item/1201/"
    },
    {
      "name": "tr14",
      "url": "https://pokeapi.co/api/v2/item/1202/"
    },
    {
      "name": "tr15",
      "url": "https://pokeapi.co/api/v2/item/1203/"
    },
    {
      "name": "tr16",
      "url": "https://pokeapi.co/api/v2/item/1204/"
    },
    {
      "name": "tr17",
      "url": "https://pokeapi.co/api/v2/item/1205/"
    },
    {
      "name": "tr18",
      "url": "https://pokeapi.co/api/v2/item/1206/"
    },
    {
      "name": "tr19",
      "url": "https://pokeapi.co/api/v2/item/1207/"
    },
    {
      "name": "tr20",
      "url": "https://pokeapi.co/api/v2/item/1208/"
    },
    {
      "name": "tr21",
      "url": "https://pokeapi.co/api/v2/item/1209/"
    },
    {
      "name": "tr22",
      "url": "https://pokeapi.co/api/v2/item/1210/"
    },
    {
      "name": "tr23",
      "url": "https://pokeapi.co/api/v2/item/1211/"
    },
    {
      "name": "tr24",
      "url": "https://pokeapi.co/api/v2/item/1212/"
    },
    {
      "name": "tr25",
      "url": "https://pokeapi.co/api/v2/item/1213/"
    },
    {
      "name": "tr26",
      "url": "https://pokeapi.co/api/v2/item/1214/"
    },
    {
      "name": "tr27",
      "url": "https://pokeapi.co/api/v2/item/1215/"
    },
    {
      "name": "tr28",
      "url": "https://pokeapi.co/api/v2/item/1216/"
    },
    {
      "name": "tr29",
      "url": "https://pokeapi.co/api/v2/item/1217/"
    },
    {
      "name": "tr30",
      "url": "https://pokeapi.co/api/v2/item/1218/"
    },
    {
      "name": "tr31",
      "url": "https://pokeapi.co/api/v2/item/1219/"
    },
    {
      "name": "tr32",
      "url": "https://pokeapi.co/api/v2/item/1220/"
    },
    {
      "name": "tr33",
      "url": "https://pokeapi.co/api/v2/item/1221/"
    },
    {
      "name": "tr34",
      "url": "https://pokeapi.co/api/v2/item/1222/"
    },
    {
      "name": "tr35",
      "url": "https://pokeapi.co/api/v2/item/1223/"
    },
    {
      "name": "tr36",
      "url": "https://pokeapi.co/api/v2/item/1224/"
    },
    {
      "name": "tr37",
      "url": "https://pokeapi.co/api/v2/item/1225/"
    },
    {
      "name": "tr38",
      "url": "https://pokeapi.co/api/v2/item/1226/"
    },
    {
      "name": "tr39",
      "url": "https://pokeapi.co/api/v2/item/1227/"
    },
    {
      "name": "tr40",
      "url": "https://pokeapi.co/api/v2/item/1228/"
    },
    {
      "name": "tr41",
      "url": "https://pokeapi.co/api/v2/item/1229/"
    },
    {
      "name": "tr42",
      "url": "https://pokeapi.co/api/v2/item/1230/"
    },
    {
      "name": "tr43",
      "url": "https://pokeapi.co/api/v2/item/1231/"
    },
    {
      "name": "tr44",
      "url": "https://pokeapi.co/api/v2/item/1232/"
    },
    {
      "name": "tr45",
      "url": "https://pokeapi.co/api/v2/item/1233/"
    },
    {
      "name": "tr46",
      "url": "https://pokeapi.co/api/v2/item/1234/"
    },
    {
      "name": "tr47",
      "url": "https://pokeapi.co/api/v2/item/1235/"
    },
    {
      "name": "tr48",
      "url": "https://pokeapi.co/api/v2/item/1236/"
    },
    {
      "name": "tr49",
      "url": "https://pokeapi.co/api/v2/item/1237/"
    },
    {
      "name": "tr50",
      "url": "https://pokeapi.co/api/v2/item/1238/"
    },
    {
      "name": "tr51",
      "url": "https://pokeapi.co/api/v2/item/1239/"
    },
    {
      "name": "tr52",
      "url": "https://pokeapi.co/api/v2/item/1240/"
    },
    {
      "name": "tr53",
      "url": "https://pokeapi.co/api/v2/item/1241/"
    },
    {
      "name": "tr54",
      "url": "https://pokeapi.co/api/v2/item/1242/"
    },
    {
      "name": "tr55",
      "url": "https://pokeapi.co/api/v2/item/1243/"
    },
    {
      "name": "tr56",
      "url": "https://pokeapi.co/api/v2/item/1244/"
    },
    {
      "name": "tr57",
      "url": "https://pokeapi.co/api/v2/item/1245/"
    },
    {
      "name": "tr58",
      "url": "https://pokeapi.co/api/v2/item/1246/"
    },
    {
      "name": "tr59",
      "url": "https://pokeapi.co/api/v2/item/1247/"
    },
    {
      "name": "tr60",
      "url": "https://pokeapi.co/api/v2/item/1248/"
    },
    {
      "name": "tr61",
      "url": "https://pokeapi.co/api/v2/item/1249/"
    },
    {
      "name": "tr62",
      "url": "https://pokeapi.co/api/v2/item/1250/"
    },
    {
      "name": "tr63",
      "url": "https://pokeapi.co/api/v2/item/1251/"
    },
    {
      "name": "tr64",
      "url": "https://pokeapi.co/api/v2/item/1252/"
    },
    {
      "name": "tr65",
      "url": "https://pokeapi.co/api/v2/item/1253/"
    },
    {
      "name": "tr66",
      "url": "https://pokeapi.co/api/v2/item/1254/"
    },
    {
      "name": "tr67",
      "url": "https://pokeapi.co/api/v2/item/1255/"
    },
    {
      "name": "tr68",
      "url": "https://pokeapi.co/api/v2/item/1256/"
    },
    {
      "name": "tr69",
      "url": "https://pokeapi.co/api/v2/item/1257/"
    },
    {
      "name": "tr70",
      "url": "https://pokeapi.co/api/v2/item/1258/"
    },
    {
      "name": "tr71",
      "url": "https://pokeapi.co/api/v2/item/1259/"
    },
    {
      "name": "tr72",
      "url": "https://pokeapi.co/api/v2/item/1260/"
    },
    {
      "name": "tr73",
      "url": "https://pokeapi.co/api/v2/item/1261/"
    },
    {
      "name": "tr74",
      "url": "https://pokeapi.co/api/v2/item/1262/"
    },
    {
      "name": "tr75",
      "url": "https://pokeapi.co/api/v2/item/1263/"
    },
    {
      "name": "tr76",
      "url": "https://pokeapi.co/api/v2/item/1264/"
    },
    {
      "name": "tr77",
      "url": "https://pokeapi.co/api/v2/item/1265/"
    },
    {
      "name": "tr78",
      "url": "https://pokeapi.co/api/v2/item/1266/"
    },
    {
      "name": "tr79",
      "url": "https://pokeapi.co/api/v2/item/1267/"
    },
    {
      "name": "tr80",
      "url": "https://pokeapi.co/api/v2/item/1268/"
    },
    {
      "name": "tr81",
      "url": "https://pokeapi.co/api/v2/item/1269/"
    },
    {
      "name": "tr82",
      "url": "https://pokeapi.co/api/v2/item/1270/"
    },
    {
      "name": "tr83",
      "url": "https://pokeapi.co/api/v2/item/1271/"
    },
    {
      "name": "tr84",
      "url": "https://pokeapi.co/api/v2/item/1272/"
    },
    {
      "name": "tr85",
      "url": "https://pokeapi.co/api/v2/item/1273/"
    },
    {
      "name": "tr86",
      "url": "https://pokeapi.co/api/v2/item/1274/"
    },
    {
      "name": "tr87",
      "url": "https://pokeapi.co/api/v2/item/1275/"
    },
    {
      "name": "tr88",
      "url": "https://pokeapi.co/api/v2/item/1276/"
    },
    {
      "name": "tr89",
      "url": "https://pokeapi.co/api/v2/item/1277/"
    },
    {
      "name": "tr90",
      "url": "https://pokeapi.co/api/v2/item/1278/"
    },
    {
      "name": "tr91",
      "url": "https://pokeapi.co/api/v2/item/1279/"
    },
    {
      "name": "tr92",
      "url": "https://pokeapi.co/api/v2/item/1280/"
    },
    {
      "name": "tr93",
      "url": "https://pokeapi.co/api/v2/item/1281/"
    },
    {
      "name": "tr94",
      "url": "https://pokeapi.co/api/v2/item/1282/"
    },
    {
      "name": "tr95",
      "url": "https://pokeapi.co/api/v2/item/1283/"
    },
    {
      "name": "tr96",
      "url": "https://pokeapi.co/api/v2/item/1284/"
    },
    {
      "name": "tr97",
      "url": "https://pokeapi.co/api/v2/item/1285/"
    },
    {
      "name": "tr98",
      "url": "https://pokeapi.co/api/v2/item/1286/"
    },
    {
      "name": "tr99",
      "url": "https://pokeapi.co/api/v2/item/1287/"
    },
    {
      "name": "tm00",
      "url": "https://pokeapi.co/api/v2/item/1288/"
    },
    {
      "name": "lonely-mint",
      "url": "https://pokeapi.co/api/v2/item/1289/"
    },
    {
      "name": "adamant-mint",
      "url": "https://pokeapi.co/api/v2/item/1290/"
    },
    {
      "name": "naughty-mint",
      "url": "https://pokeapi.co/api/v2/item/1291/"
    },
    {
      "name": "brave-mint",
      "url": "https://pokeapi.co/api/v2/item/1292/"
    },
    {
      "name": "bold-mint",
      "url": "https://pokeapi.co/api/v2/item/1293/"
    },
    {
      "name": "impish-mint",
      "url": "https://pokeapi.co/api/v2/item/1294/"
    },
    {
      "name": "lax-mint",
      "url": "https://pokeapi.co/api/v2/item/1295/"
    },
    {
      "name": "relaxed-mint",
      "url": "https://pokeapi.co/api/v2/item/1296/"
    },
    {
      "name": "modest-mint",
      "url": "https://pokeapi.co/api/v2/item/1297/"
    },
    {
      "name": "mild-mint",
      "url": "https://pokeapi.co/api/v2/item/1298/"
    },
    {
      "name": "rash-mint",
      "url": "https://pokeapi.co/api/v2/item/1299/"
    },
    {
      "name": "quiet-mint",
      "url": "https://pokeapi.co/api/v2/item/1300/"
    },
    {
      "name": "calm-mint",
      "url": "https://pokeapi.co/api/v2/item/1301/"
    },
    {
      "name": "gentle-mint",
      "url": "https://pokeapi.co/api/v2/item/1302/"
    },
    {
      "name": "careful-mint",
      "url": "https://pokeapi.co/api/v2/item/1303/"
    },
    {
      "name": "sassy-mint",
      "url": "https://pokeapi.co/api/v2/item/1304/"
    },
    {
      "name": "timid-mint",
      "url": "https://pokeapi.co/api/v2/item/1305/"
    },
    {
      "name": "hasty-mint",
      "url": "https://pokeapi.co/api/v2/item/1306/"
    },
    {
      "name": "jolly-mint",
      "url": "https://pokeapi.co/api/v2/item/1307/"
    },
    {
      "name": "naive-mint",
      "url": "https://pokeapi.co/api/v2/item/1308/"
    },
    {
      "name": "serious-mint",
      "url": "https://pokeapi.co/api/v2/item/1309/"
    },
    {
      "name": "wishing-piece",
      "url": "https://pokeapi.co/api/v2/item/1310/"
    },
    {
      "name": "cracked-pot",
      "url": "https://pokeapi.co/api/v2/item/1311/"
    },
    {
      "name": "chipped-pot",
      "url": "https://pokeapi.co/api/v2/item/1312/"
    },
    {
      "name": "hi-tech-earbuds",
      "url": "https://pokeapi.co/api/v2/item/1313/"
    },
    {
      "name": "fruit-bunch",
      "url": "https://pokeapi.co/api/v2/item/1314/"
    },
    {
      "name": "moomoo-cheese",
      "url": "https://pokeapi.co/api/v2/item/1315/"
    },
    {
      "name": "spice-mix",
      "url": "https://pokeapi.co/api/v2/item/1316/"
    },
    {
      "name": "fresh-cream",
      "url": "https://pokeapi.co/api/v2/item/1317/"
    },
    {
      "name": "packaged-curry",
      "url": "https://pokeapi.co/api/v2/item/1318/"
    },
    {
      "name": "coconut-milk",
      "url": "https://pokeapi.co/api/v2/item/1319/"
    },
    {
      "name": "instant-noodles",
      "url": "https://pokeapi.co/api/v2/item/1320/"
    },
    {
      "name": "precooked-burger",
      "url": "https://pokeapi.co/api/v2/item/1321/"
    },
    {
      "name": "gigantamix",
      "url": "https://pokeapi.co/api/v2/item/1322/"
    },
    {
      "name": "wishing-chip",
      "url": "https://pokeapi.co/api/v2/item/1323/"
    },
    {
      "name": "rotom-bike--water-mode",
      "url": "https://pokeapi.co/api/v2/item/1324/"
    },
    {
      "name": "catching-charm",
      "url": "https://pokeapi.co/api/v2/item/1325/"
    },
    {
      "name": "old-letter",
      "url": "https://pokeapi.co/api/v2/item/1326/"
    },
    {
      "name": "band-autograph",
      "url": "https://pokeapi.co/api/v2/item/1327/"
    },
    {
      "name": "sonias-book",
      "url": "https://pokeapi.co/api/v2/item/1328/"
    },
    {
      "name": "rotom-catalog",
      "url": "https://pokeapi.co/api/v2/item/1329/"
    },
    {
      "name": "dynamax-crystal-and458",
      "url": "https://pokeapi.co/api/v2/item/1330/"
    },
    {
      "name": "dynamax-crystal-and15",
      "url": "https://pokeapi.co/api/v2/item/1331/"
    },
    {
      "name": "dynamax-crystal-and337",
      "url": "https://pokeapi.co/api/v2/item/1332/"
    },
    {
      "name": "dynamax-crystal-and603",
      "url": "https://pokeapi.co/api/v2/item/1333/"
    },
    {
      "name": "dynamax-crystal-and390",
      "url": "https://pokeapi.co/api/v2/item/1334/"
    },
    {
      "name": "dynamax-crystal-sgr6879",
      "url": "https://pokeapi.co/api/v2/item/1335/"
    },
    {
      "name": "dynamax-crystal-sgr6859",
      "url": "https://pokeapi.co/api/v2/item/1336/"
    },
    {
      "name": "dynamax-crystal-sgr6913",
      "url": "https://pokeapi.co/api/v2/item/1337/"
    },
    {
      "name": "dynamax-crystal-sgr7348",
      "url": "https://pokeapi.co/api/v2/item/1338/"
    },
    {
      "name": "dynamax-crystal-sgr7121",
      "url": "https://pokeapi.co/api/v2/item/1339/"
    },
    {
      "name": "dynamax-crystal-sgr6746",
      "url": "https://pokeapi.co/api/v2/item/1340/"
    },
    {
      "name": "dynamax-crystal-sgr7194",
      "url": "https://pokeapi.co/api/v2/item/1341/"
    },
    {
      "name": "dynamax-crystal-sgr7337",
      "url": "https://pokeapi.co/api/v2/item/1342/"
    },
    {
      "name": "dynamax-crystal-sgr7343",
      "url": "https://pokeapi.co/api/v2/item/1343/"
    },
    {
      "name": "dynamax-crystal-sgr6812",
      "url": "https://pokeapi.co/api/v2/item/1344/"
    },
    {
      "name": "dynamax-crystal-sgr7116",
      "url": "https://pokeapi.co/api/v2/item/1345/"
    },
    {
      "name": "dynamax-crystal-sgr7264",
      "url": "https://pokeapi.co/api/v2/item/1346/"
    },
    {
      "name": "dynamax-crystal-sgr7597",
      "url": "https://pokeapi.co/api/v2/item/1347/"
    },
    {
      "name": "dynamax-crystal-del7882",
      "url": "https://pokeapi.co/api/v2/item/1348/"
    },
    {
      "name": "dynamax-crystal-del7906",
      "url": "https://pokeapi.co/api/v2/item/1349/"
    },
    {
      "name": "dynamax-crystal-del7852",
      "url": "https://pokeapi.co/api/v2/item/1350/"
    },
    {
      "name": "dynamax-crystal-psc596",
      "url": "https://pokeapi.co/api/v2/item/1351/"
    },
    {
      "name": "dynamax-crystal-psc361",
      "url": "https://pokeapi.co/api/v2/item/1352/"
    },
    {
      "name": "dynamax-crystal-psc510",
      "url": "https://pokeapi.co/api/v2/item/1353/"
    },
    {
      "name": "dynamax-crystal-psc437",
      "url": "https://pokeapi.co/api/v2/item/1354/"
    },
    {
      "name": "dynamax-crystal-psc8773",
      "url": "https://pokeapi.co/api/v2/item/1355/"
    },
    {
      "name": "dynamax-crystal-lep1865",
      "url": "https://pokeapi.co/api/v2/item/1356/"
    },
    {
      "name": "dynamax-crystal-lep1829",
      "url": "https://pokeapi.co/api/v2/item/1357/"
    },
    {
      "name": "dynamax-crystal-boo5340",
      "url": "https://pokeapi.co/api/v2/item/1358/"
    },
    {
      "name": "dynamax-crystal-boo5506",
      "url": "https://pokeapi.co/api/v2/item/1359/"
    },
    {
      "name": "dynamax-crystal-boo5435",
      "url": "https://pokeapi.co/api/v2/item/1360/"
    },
    {
      "name": "dynamax-crystal-boo5602",
      "url": "https://pokeapi.co/api/v2/item/1361/"
    },
    {
      "name": "dynamax-crystal-boo5733",
      "url": "https://pokeapi.co/api/v2/item/1362/"
    },
    {
      "name": "dynamax-crystal-boo5235",
      "url": "https://pokeapi.co/api/v2/item/1363/"
    },
    {
      "name": "dynamax-crystal-boo5351",
      "url": "https://pokeapi.co/api/v2/item/1364/"
    },
    {
      "name": "dynamax-crystal-hya3748",
      "url": "https://pokeapi.co/api/v2/item/1365/"
    },
    {
      "name": "dynamax-crystal-hya3903",
      "url": "https://pokeapi.co/api/v2/item/1366/"
    },
    {
      "name": "dynamax-crystal-hya3418",
      "url": "https://pokeapi.co/api/v2/item/1367/"
    },
    {
      "name": "dynamax-crystal-hya3482",
      "url": "https://pokeapi.co/api/v2/item/1368/"
    },
    {
      "name": "dynamax-crystal-hya3845",
      "url": "https://pokeapi.co/api/v2/item/1369/"
    },
    {
      "name": "dynamax-crystal-eri1084",
      "url": "https://pokeapi.co/api/v2/item/1370/"
    },
    {
      "name": "dynamax-crystal-eri472",
      "url": "https://pokeapi.co/api/v2/item/1371/"
    },
    {
      "name": "dynamax-crystal-eri1666",
      "url": "https://pokeapi.co/api/v2/item/1372/"
    },
    {
      "name": "dynamax-crystal-eri897",
      "url": "https://pokeapi.co/api/v2/item/1373/"
    },
    {
      "name": "dynamax-crystal-eri1231",
      "url": "https://pokeapi.co/api/v2/item/1374/"
    },
    {
      "name": "dynamax-crystal-eri874",
      "url": "https://pokeapi.co/api/v2/item/1375/"
    },
    {
      "name": "dynamax-crystal-eri1298",
      "url": "https://pokeapi.co/api/v2/item/1376/"
    },
    {
      "name": "dynamax-crystal-eri1325",
      "url": "https://pokeapi.co/api/v2/item/1377/"
    },
    {
      "name": "dynamax-crystal-eri984",
      "url": "https://pokeapi.co/api/v2/item/1378/"
    },
    {
      "name": "dynamax-crystal-eri1464",
      "url": "https://pokeapi.co/api/v2/item/1379/"
    },
    {
      "name": "dynamax-crystal-eri1393",
      "url": "https://pokeapi.co/api/v2/item/1380/"
    },
    {
      "name": "dynamax-crystal-eri850",
      "url": "https://pokeapi.co/api/v2/item/1381/"
    },
    {
      "name": "dynamax-crystal-tau1409",
      "url": "https://pokeapi.co/api/v2/item/1382/"
    },
    {
      "name": "dynamax-crystal-tau1457",
      "url": "https://pokeapi.co/api/v2/item/1383/"
    },
    {
      "name": "dynamax-crystal-tau1165",
      "url": "https://pokeapi.co/api/v2/item/1384/"
    },
    {
      "name": "dynamax-crystal-tau1791",
      "url": "https://pokeapi.co/api/v2/item/1385/"
    },
    {
      "name": "dynamax-crystal-tau1910",
      "url": "https://pokeapi.co/api/v2/item/1386/"
    },
    {
      "name": "dynamax-crystal-tau1346",
      "url": "https://pokeapi.co/api/v2/item/1387/"
    },
    {
      "name": "dynamax-crystal-tau1373",
      "url": "https://pokeapi.co/api/v2/item/1388/"
    },
    {
      "name": "dynamax-crystal-tau1412",
      "url": "https://pokeapi.co/api/v2/item/1389/"
    },
    {
      "name": "dynamax-crystal-cma2491",
      "url": "https://pokeapi.co/api/v2/item/1390/"
    },
    {
      "name": "dynamax-crystal-cma2693",
      "url": "https://pokeapi.co/api/v2/item/1391/"
    },
    {
      "name": "dynamax-crystal-cma2294",
      "url": "https://pokeapi.co/api/v2/item/1392/"
    },
    {
      "name": "dynamax-crystal-cma2827",
      "url": "https://pokeapi.co/api/v2/item/1393/"
    },
    {
      "name": "dynamax-crystal-cma2282",
      "url": "https://pokeapi.co/api/v2/item/1394/"
    },
    {
      "name": "dynamax-crystal-cma2618",
      "url": "https://pokeapi.co/api/v2/item/1395/"
    },
    {
      "name": "dynamax-crystal-cma2657",
      "url": "https://pokeapi.co/api/v2/item/1396/"
    },
    {
      "name": "dynamax-crystal-cma2646",
      "url": "https://pokeapi.co/api/v2/item/1397/"
    },
    {
      "name": "dynamax-crystal-uma4905",
      "url": "https://pokeapi.co/api/v2/item/1398/"
    },
    {
      "name": "dynamax-crystal-uma4301",
      "url": "https://pokeapi.co/api/v2/item/1399/"
    },
    {
      "name": "dynamax-crystal-uma5191",
      "url": "https://pokeapi.co/api/v2/item/1400/"
    },
    {
      "name": "dynamax-crystal-uma5054",
      "url": "https://pokeapi.co/api/v2/item/1401/"
    },
    {
      "name": "dynamax-crystal-uma4295",
      "url": "https://pokeapi.co/api/v2/item/1402/"
    },
    {
      "name": "dynamax-crystal-uma4660",
      "url": "https://pokeapi.co/api/v2/item/1403/"
    },
    {
      "name": "dynamax-crystal-uma4554",
      "url": "https://pokeapi.co/api/v2/item/1404/"
    },
    {
      "name": "dynamax-crystal-uma4069",
      "url": "https://pokeapi.co/api/v2/item/1405/"
    },
    {
      "name": "dynamax-crystal-uma3569",
      "url": "https://pokeapi.co/api/v2/item/1406/"
    },
    {
      "name": "dynamax-crystal-uma3323",
      "url": "https://pokeapi.co/api/v2/item/1407/"
    },
    {
      "name": "dynamax-crystal-uma4033",
      "url": "https://pokeapi.co/api/v2/item/1408/"
    },
    {
      "name": "dynamax-crystal-uma4377",
      "url": "https://pokeapi.co/api/v2/item/1409/"
    },
    {
      "name": "dynamax-crystal-uma4375",
      "url": "https://pokeapi.co/api/v2/item/1410/"
    },
    {
      "name": "dynamax-crystal-uma4518",
      "url": "https://pokeapi.co/api/v2/item/1411/"
    },
    {
      "name": "dynamax-crystal-uma3594",
      "url": "https://pokeapi.co/api/v2/item/1412/"
    },
    {
      "name": "dynamax-crystal-vir5056",
      "url": "https://pokeapi.co/api/v2/item/1413/"
    },
    {
      "name": "dynamax-crystal-vir4825",
      "url": "https://pokeapi.co/api/v2/item/1414/"
    },
    {
      "name": "dynamax-crystal-vir4932",
      "url": "https://pokeapi.co/api/v2/item/1415/"
    },
    {
      "name": "dynamax-crystal-vir4540",
      "url": "https://pokeapi.co/api/v2/item/1416/"
    },
    {
      "name": "dynamax-crystal-vir4689",
      "url": "https://pokeapi.co/api/v2/item/1417/"
    },
    {
      "name": "dynamax-crystal-vir5338",
      "url": "https://pokeapi.co/api/v2/item/1418/"
    },
    {
      "name": "dynamax-crystal-vir4910",
      "url": "https://pokeapi.co/api/v2/item/1419/"
    },
    {
      "name": "dynamax-crystal-vir5315",
      "url": "https://pokeapi.co/api/v2/item/1420/"
    },
    {
      "name": "dynamax-crystal-vir5359",
      "url": "https://pokeapi.co/api/v2/item/1421/"
    },
    {
      "name": "dynamax-crystal-vir5409",
      "url": "https://pokeapi.co/api/v2/item/1422/"
    },
    {
      "name": "dynamax-crystal-vir5107",
      "url": "https://pokeapi.co/api/v2/item/1423/"
    },
    {
      "name": "dynamax-crystal-ari617",
      "url": "https://pokeapi.co/api/v2/item/1424/"
    },
    {
      "name": "dynamax-crystal-ari553",
      "url": "https://pokeapi.co/api/v2/item/1425/"
    },
    {
      "name": "dynamax-crystal-ari546",
      "url": "https://pokeapi.co/api/v2/item/1426/"
    },
    {
      "name": "dynamax-crystal-ari951",
      "url": "https://pokeapi.co/api/v2/item/1427/"
    },
    {
      "name": "dynamax-crystal-ori1713",
      "url": "https://pokeapi.co/api/v2/item/1428/"
    },
    {
      "name": "dynamax-crystal-ori2061",
      "url": "https://pokeapi.co/api/v2/item/1429/"
    },
    {
      "name": "dynamax-crystal-ori1790",
      "url": "https://pokeapi.co/api/v2/item/1430/"
    },
    {
      "name": "dynamax-crystal-ori1903",
      "url": "https://pokeapi.co/api/v2/item/1431/"
    },
    {
      "name": "dynamax-crystal-ori1948",
      "url": "https://pokeapi.co/api/v2/item/1432/"
    },
    {
      "name": "dynamax-crystal-ori2004",
      "url": "https://pokeapi.co/api/v2/item/1433/"
    },
    {
      "name": "dynamax-crystal-ori1852",
      "url": "https://pokeapi.co/api/v2/item/1434/"
    },
    {
      "name": "dynamax-crystal-ori1879",
      "url": "https://pokeapi.co/api/v2/item/1435/"
    },
    {
      "name": "dynamax-crystal-ori1899",
      "url": "https://pokeapi.co/api/v2/item/1436/"
    },
    {
      "name": "dynamax-crystal-ori1543",
      "url": "https://pokeapi.co/api/v2/item/1437/"
    },
    {
      "name": "dynamax-crystal-cas21",
      "url": "https://pokeapi.co/api/v2/item/1438/"
    },
    {
      "name": "dynamax-crystal-cas168",
      "url": "https://pokeapi.co/api/v2/item/1439/"
    },
    {
      "name": "dynamax-crystal-cas403",
      "url": "https://pokeapi.co/api/v2/item/1440/"
    },
    {
      "name": "dynamax-crystal-cas153",
      "url": "https://pokeapi.co/api/v2/item/1441/"
    },
    {
      "name": "dynamax-crystal-cas542",
      "url": "https://pokeapi.co/api/v2/item/1442/"
    },
    {
      "name": "dynamax-crystal-cas219",
      "url": "https://pokeapi.co/api/v2/item/1443/"
    },
    {
      "name": "dynamax-crystal-cas265",
      "url": "https://pokeapi.co/api/v2/item/1444/"
    },
    {
      "name": "dynamax-crystal-cnc3572",
      "url": "https://pokeapi.co/api/v2/item/1445/"
    },
    {
      "name": "dynamax-crystal-cnc3208",
      "url": "https://pokeapi.co/api/v2/item/1446/"
    },
    {
      "name": "dynamax-crystal-cnc3461",
      "url": "https://pokeapi.co/api/v2/item/1447/"
    },
    {
      "name": "dynamax-crystal-cnc3449",
      "url": "https://pokeapi.co/api/v2/item/1448/"
    },
    {
      "name": "dynamax-crystal-cnc3429",
      "url": "https://pokeapi.co/api/v2/item/1449/"
    },
    {
      "name": "dynamax-crystal-cnc3627",
      "url": "https://pokeapi.co/api/v2/item/1450/"
    },
    {
      "name": "dynamax-crystal-cnc3268",
      "url": "https://pokeapi.co/api/v2/item/1451/"
    },
    {
      "name": "dynamax-crystal-cnc3249",
      "url": "https://pokeapi.co/api/v2/item/1452/"
    },
    {
      "name": "dynamax-crystal-com4968",
      "url": "https://pokeapi.co/api/v2/item/1453/"
    },
    {
      "name": "dynamax-crystal-crv4757",
      "url": "https://pokeapi.co/api/v2/item/1454/"
    },
    {
      "name": "dynamax-crystal-crv4623",
      "url": "https://pokeapi.co/api/v2/item/1455/"
    },
    {
      "name": "dynamax-crystal-crv4662",
      "url": "https://pokeapi.co/api/v2/item/1456/"
    },
    {
      "name": "dynamax-crystal-crv4786",
      "url": "https://pokeapi.co/api/v2/item/1457/"
    },
    {
      "name": "dynamax-crystal-aur1708",
      "url": "https://pokeapi.co/api/v2/item/1458/"
    },
    {
      "name": "dynamax-crystal-aur2088",
      "url": "https://pokeapi.co/api/v2/item/1459/"
    },
    {
      "name": "dynamax-crystal-aur1605",
      "url": "https://pokeapi.co/api/v2/item/1460/"
    },
    {
      "name": "dynamax-crystal-aur2095",
      "url": "https://pokeapi.co/api/v2/item/1461/"
    },
    {
      "name": "dynamax-crystal-aur1577",
      "url": "https://pokeapi.co/api/v2/item/1462/"
    },
    {
      "name": "dynamax-crystal-aur1641",
      "url": "https://pokeapi.co/api/v2/item/1463/"
    },
    {
      "name": "dynamax-crystal-aur1612",
      "url": "https://pokeapi.co/api/v2/item/1464/"
    },
    {
      "name": "dynamax-crystal-pav7790",
      "url": "https://pokeapi.co/api/v2/item/1465/"
    },
    {
      "name": "dynamax-crystal-cet911",
      "url": "https://pokeapi.co/api/v2/item/1466/"
    },
    {
      "name": "dynamax-crystal-cet681",
      "url": "https://pokeapi.co/api/v2/item/1467/"
    },
    {
      "name": "dynamax-crystal-cet188",
      "url": "https://pokeapi.co/api/v2/item/1468/"
    },
    {
      "name": "dynamax-crystal-cet539",
      "url": "https://pokeapi.co/api/v2/item/1469/"
    },
    {
      "name": "dynamax-crystal-cet804",
      "url": "https://pokeapi.co/api/v2/item/1470/"
    },
    {
      "name": "dynamax-crystal-cep8974",
      "url": "https://pokeapi.co/api/v2/item/1471/"
    },
    {
      "name": "dynamax-crystal-cep8162",
      "url": "https://pokeapi.co/api/v2/item/1472/"
    },
    {
      "name": "dynamax-crystal-cep8238",
      "url": "https://pokeapi.co/api/v2/item/1473/"
    },
    {
      "name": "dynamax-crystal-cep8417",
      "url": "https://pokeapi.co/api/v2/item/1474/"
    },
    {
      "name": "dynamax-crystal-cen5267",
      "url": "https://pokeapi.co/api/v2/item/1475/"
    },
    {
      "name": "dynamax-crystal-cen5288",
      "url": "https://pokeapi.co/api/v2/item/1476/"
    },
    {
      "name": "dynamax-crystal-cen551",
      "url": "https://pokeapi.co/api/v2/item/1477/"
    },
    {
      "name": "dynamax-crystal-cen5459",
      "url": "https://pokeapi.co/api/v2/item/1478/"
    },
    {
      "name": "dynamax-crystal-cen5460",
      "url": "https://pokeapi.co/api/v2/item/1479/"
    },
    {
      "name": "dynamax-crystal-cmi2943",
      "url": "https://pokeapi.co/api/v2/item/1480/"
    },
    {
      "name": "dynamax-crystal-cmi2845",
      "url": "https://pokeapi.co/api/v2/item/1481/"
    },
    {
      "name": "dynamax-crystal-equ8131",
      "url": "https://pokeapi.co/api/v2/item/1482/"
    },
    {
      "name": "dynamax-crystal-vul7405",
      "url": "https://pokeapi.co/api/v2/item/1483/"
    },
    {
      "name": "dynamax-crystal-umi424",
      "url": "https://pokeapi.co/api/v2/item/1484/"
    },
    {
      "name": "dynamax-crystal-umi5563",
      "url": "https://pokeapi.co/api/v2/item/1485/"
    },
    {
      "name": "dynamax-crystal-umi5735",
      "url": "https://pokeapi.co/api/v2/item/1486/"
    },
    {
      "name": "dynamax-crystal-umi6789",
      "url": "https://pokeapi.co/api/v2/item/1487/"
    },
    {
      "name": "dynamax-crystal-crt4287",
      "url": "https://pokeapi.co/api/v2/item/1488/"
    },
    {
      "name": "dynamax-crystal-lyr7001",
      "url": "https://pokeapi.co/api/v2/item/1489/"
    },
    {
      "name": "dynamax-crystal-lyr7178",
      "url": "https://pokeapi.co/api/v2/item/1490/"
    },
    {
      "name": "dynamax-crystal-lyr7106",
      "url": "https://pokeapi.co/api/v2/item/1491/"
    },
    {
      "name": "dynamax-crystal-lyr7298",
      "url": "https://pokeapi.co/api/v2/item/1492/"
    },
    {
      "name": "dynamax-crystal-ara6585",
      "url": "https://pokeapi.co/api/v2/item/1493/"
    },
    {
      "name": "dynamax-crystal-sco6134",
      "url": "https://pokeapi.co/api/v2/item/1494/"
    },
    {
      "name": "dynamax-crystal-sco6527",
      "url": "https://pokeapi.co/api/v2/item/1495/"
    },
    {
      "name": "dynamax-crystal-sco6553",
      "url": "https://pokeapi.co/api/v2/item/1496/"
    },
    {
      "name": "dynamax-crystal-sco5953",
      "url": "https://pokeapi.co/api/v2/item/1497/"
    },
    {
      "name": "dynamax-crystal-sco5984",
      "url": "https://pokeapi.co/api/v2/item/1498/"
    },
    {
      "name": "dynamax-crystal-sco6508",
      "url": "https://pokeapi.co/api/v2/item/1499/"
    },
    {
      "name": "dynamax-crystal-sco6084",
      "url": "https://pokeapi.co/api/v2/item/1500/"
    },
    {
      "name": "dynamax-crystal-sco5944",
      "url": "https://pokeapi.co/api/v2/item/1501/"
    },
    {
      "name": "dynamax-crystal-sco6630",
      "url": "https://pokeapi.co/api/v2/item/1502/"
    },
    {
      "name": "dynamax-crystal-sco6027",
      "url": "https://pokeapi.co/api/v2/item/1503/"
    },
    {
      "name": "dynamax-crystal-sco6247",
      "url": "https://pokeapi.co/api/v2/item/1504/"
    },
    {
      "name": "dynamax-crystal-sco6252",
      "url": "https://pokeapi.co/api/v2/item/1505/"
    },
    {
      "name": "dynamax-crystal-sco5928",
      "url": "https://pokeapi.co/api/v2/item/1506/"
    },
    {
      "name": "dynamax-crystal-sco6241",
      "url": "https://pokeapi.co/api/v2/item/1507/"
    },
    {
      "name": "dynamax-crystal-sco6165",
      "url": "https://pokeapi.co/api/v2/item/1508/"
    },
    {
      "name": "dynamax-crystal-tri544",
      "url": "https://pokeapi.co/api/v2/item/1509/"
    },
    {
      "name": "dynamax-crystal-leo3982",
      "url": "https://pokeapi.co/api/v2/item/1510/"
    },
    {
      "name": "dynamax-crystal-leo4534",
      "url": "https://pokeapi.co/api/v2/item/1511/"
    },
    {
      "name": "dynamax-crystal-leo4357",
      "url": "https://pokeapi.co/api/v2/item/1512/"
    },
    {
      "name": "dynamax-crystal-leo4057",
      "url": "https://pokeapi.co/api/v2/item/1513/"
    },
    {
      "name": "dynamax-crystal-leo4359",
      "url": "https://pokeapi.co/api/v2/item/1514/"
    },
    {
      "name": "dynamax-crystal-leo4031",
      "url": "https://pokeapi.co/api/v2/item/1515/"
    },
    {
      "name": "dynamax-crystal-leo3852",
      "url": "https://pokeapi.co/api/v2/item/1516/"
    },
    {
      "name": "dynamax-crystal-leo3905",
      "url": "https://pokeapi.co/api/v2/item/1517/"
    },
    {
      "name": "dynamax-crystal-leo3773",
      "url": "https://pokeapi.co/api/v2/item/1518/"
    },
    {
      "name": "dynamax-crystal-gru8425",
      "url": "https://pokeapi.co/api/v2/item/1519/"
    },
    {
      "name": "dynamax-crystal-gru8636",
      "url": "https://pokeapi.co/api/v2/item/1520/"
    },
    {
      "name": "dynamax-crystal-gru8353",
      "url": "https://pokeapi.co/api/v2/item/1521/"
    },
    {
      "name": "dynamax-crystal-lib5685",
      "url": "https://pokeapi.co/api/v2/item/1522/"
    },
    {
      "name": "dynamax-crystal-lib5531",
      "url": "https://pokeapi.co/api/v2/item/1523/"
    },
    {
      "name": "dynamax-crystal-lib5787",
      "url": "https://pokeapi.co/api/v2/item/1524/"
    },
    {
      "name": "dynamax-crystal-lib5603",
      "url": "https://pokeapi.co/api/v2/item/1525/"
    },
    {
      "name": "dynamax-crystal-pup3165",
      "url": "https://pokeapi.co/api/v2/item/1526/"
    },
    {
      "name": "dynamax-crystal-pup3185",
      "url": "https://pokeapi.co/api/v2/item/1527/"
    },
    {
      "name": "dynamax-crystal-pup3045",
      "url": "https://pokeapi.co/api/v2/item/1528/"
    },
    {
      "name": "dynamax-crystal-cyg7924",
      "url": "https://pokeapi.co/api/v2/item/1529/"
    },
    {
      "name": "dynamax-crystal-cyg7417",
      "url": "https://pokeapi.co/api/v2/item/1530/"
    },
    {
      "name": "dynamax-crystal-cyg7796",
      "url": "https://pokeapi.co/api/v2/item/1531/"
    },
    {
      "name": "dynamax-crystal-cyg8301",
      "url": "https://pokeapi.co/api/v2/item/1532/"
    },
    {
      "name": "dynamax-crystal-cyg7949",
      "url": "https://pokeapi.co/api/v2/item/1533/"
    },
    {
      "name": "dynamax-crystal-cyg7528",
      "url": "https://pokeapi.co/api/v2/item/1534/"
    },
    {
      "name": "dynamax-crystal-oct7228",
      "url": "https://pokeapi.co/api/v2/item/1535/"
    },
    {
      "name": "dynamax-crystal-col1956",
      "url": "https://pokeapi.co/api/v2/item/1536/"
    },
    {
      "name": "dynamax-crystal-col2040",
      "url": "https://pokeapi.co/api/v2/item/1537/"
    },
    {
      "name": "dynamax-crystal-col2177",
      "url": "https://pokeapi.co/api/v2/item/1538/"
    },
    {
      "name": "dynamax-crystal-gem2990",
      "url": "https://pokeapi.co/api/v2/item/1539/"
    },
    {
      "name": "dynamax-crystal-gem2891",
      "url": "https://pokeapi.co/api/v2/item/1540/"
    },
    {
      "name": "dynamax-crystal-gem2421",
      "url": "https://pokeapi.co/api/v2/item/1541/"
    },
    {
      "name": "dynamax-crystal-gem2473",
      "url": "https://pokeapi.co/api/v2/item/1542/"
    },
    {
      "name": "dynamax-crystal-gem2216",
      "url": "https://pokeapi.co/api/v2/item/1543/"
    },
    {
      "name": "dynamax-crystal-gem2777",
      "url": "https://pokeapi.co/api/v2/item/1544/"
    },
    {
      "name": "dynamax-crystal-gem2650",
      "url": "https://pokeapi.co/api/v2/item/1545/"
    },
    {
      "name": "dynamax-crystal-gem2286",
      "url": "https://pokeapi.co/api/v2/item/1546/"
    },
    {
      "name": "dynamax-crystal-gem2484",
      "url": "https://pokeapi.co/api/v2/item/1547/"
    },
    {
      "name": "dynamax-crystal-gem2930",
      "url": "https://pokeapi.co/api/v2/item/1548/"
    },
    {
      "name": "dynamax-crystal-peg8775",
      "url": "https://pokeapi.co/api/v2/item/1549/"
    },
    {
      "name": "dynamax-crystal-peg8781",
      "url": "https://pokeapi.co/api/v2/item/1550/"
    },
    {
      "name": "dynamax-crystal-peg39",
      "url": "https://pokeapi.co/api/v2/item/1551/"
    },
    {
      "name": "dynamax-crystal-peg8308",
      "url": "https://pokeapi.co/api/v2/item/1552/"
    },
    {
      "name": "dynamax-crystal-peg8650",
      "url": "https://pokeapi.co/api/v2/item/1553/"
    },
    {
      "name": "dynamax-crystal-peg8634",
      "url": "https://pokeapi.co/api/v2/item/1554/"
    },
    {
      "name": "dynamax-crystal-peg8684",
      "url": "https://pokeapi.co/api/v2/item/1555/"
    },
    {
      "name": "dynamax-crystal-peg8450",
      "url": "https://pokeapi.co/api/v2/item/1556/"
    },
    {
      "name": "dynamax-crystal-peg8880",
      "url": "https://pokeapi.co/api/v2/item/1557/"
    },
    {
      "name": "dynamax-crystal-peg8905",
      "url": "https://pokeapi.co/api/v2/item/1558/"
    },
    {
      "name": "dynamax-crystal-oph6556",
      "url": "https://pokeapi.co/api/v2/item/1559/"
    },
    {
      "name": "dynamax-crystal-oph6378",
      "url": "https://pokeapi.co/api/v2/item/1560/"
    },
    {
      "name": "dynamax-crystal-oph6603",
      "url": "https://pokeapi.co/api/v2/item/1561/"
    },
    {
      "name": "dynamax-crystal-oph6149",
      "url": "https://pokeapi.co/api/v2/item/1562/"
    },
    {
      "name": "dynamax-crystal-oph6056",
      "url": "https://pokeapi.co/api/v2/item/1563/"
    },
    {
      "name": "dynamax-crystal-oph6075",
      "url": "https://pokeapi.co/api/v2/item/1564/"
    },
    {
      "name": "dynamax-crystal-ser5854",
      "url": "https://pokeapi.co/api/v2/item/1565/"
    },
    {
      "name": "dynamax-crystal-ser7141",
      "url": "https://pokeapi.co/api/v2/item/1566/"
    },
    {
      "name": "dynamax-crystal-ser5879",
      "url": "https://pokeapi.co/api/v2/item/1567/"
    },
    {
      "name": "dynamax-crystal-her6406",
      "url": "https://pokeapi.co/api/v2/item/1568/"
    },
    {
      "name": "dynamax-crystal-her6148",
      "url": "https://pokeapi.co/api/v2/item/1569/"
    },
    {
      "name": "dynamax-crystal-her6410",
      "url": "https://pokeapi.co/api/v2/item/1570/"
    },
    {
      "name": "dynamax-crystal-her6526",
      "url": "https://pokeapi.co/api/v2/item/1571/"
    },
    {
      "name": "dynamax-crystal-her6117",
      "url": "https://pokeapi.co/api/v2/item/1572/"
    },
    {
      "name": "dynamax-crystal-her6008",
      "url": "https://pokeapi.co/api/v2/item/1573/"
    },
    {
      "name": "dynamax-crystal-per936",
      "url": "https://pokeapi.co/api/v2/item/1574/"
    },
    {
      "name": "dynamax-crystal-per1017",
      "url": "https://pokeapi.co/api/v2/item/1575/"
    },
    {
      "name": "dynamax-crystal-per1131",
      "url": "https://pokeapi.co/api/v2/item/1576/"
    },
    {
      "name": "dynamax-crystal-per1228",
      "url": "https://pokeapi.co/api/v2/item/1577/"
    },
    {
      "name": "dynamax-crystal-per834",
      "url": "https://pokeapi.co/api/v2/item/1578/"
    },
    {
      "name": "dynamax-crystal-per941",
      "url": "https://pokeapi.co/api/v2/item/1579/"
    },
    {
      "name": "dynamax-crystal-phe99",
      "url": "https://pokeapi.co/api/v2/item/1580/"
    },
    {
      "name": "dynamax-crystal-phe338",
      "url": "https://pokeapi.co/api/v2/item/1581/"
    },
    {
      "name": "dynamax-crystal-vel3634",
      "url": "https://pokeapi.co/api/v2/item/1582/"
    },
    {
      "name": "dynamax-crystal-vel3485",
      "url": "https://pokeapi.co/api/v2/item/1583/"
    },
    {
      "name": "dynamax-crystal-vel3734",
      "url": "https://pokeapi.co/api/v2/item/1584/"
    },
    {
      "name": "dynamax-crystal-aqr8232",
      "url": "https://pokeapi.co/api/v2/item/1585/"
    },
    {
      "name": "dynamax-crystal-aqr8414",
      "url": "https://pokeapi.co/api/v2/item/1586/"
    },
    {
      "name": "dynamax-crystal-aqr8709",
      "url": "https://pokeapi.co/api/v2/item/1587/"
    },
    {
      "name": "dynamax-crystal-aqr8518",
      "url": "https://pokeapi.co/api/v2/item/1588/"
    },
    {
      "name": "dynamax-crystal-aqr7950",
      "url": "https://pokeapi.co/api/v2/item/1589/"
    },
    {
      "name": "dynamax-crystal-aqr8499",
      "url": "https://pokeapi.co/api/v2/item/1590/"
    },
    {
      "name": "dynamax-crystal-aqr8610",
      "url": "https://pokeapi.co/api/v2/item/1591/"
    },
    {
      "name": "dynamax-crystal-aqr8264",
      "url": "https://pokeapi.co/api/v2/item/1592/"
    },
    {
      "name": "dynamax-crystal-cru4853",
      "url": "https://pokeapi.co/api/v2/item/1593/"
    },
    {
      "name": "dynamax-crystal-cru4730",
      "url": "https://pokeapi.co/api/v2/item/1594/"
    },
    {
      "name": "dynamax-crystal-cru4763",
      "url": "https://pokeapi.co/api/v2/item/1595/"
    },
    {
      "name": "dynamax-crystal-cru4700",
      "url": "https://pokeapi.co/api/v2/item/1596/"
    },
    {
      "name": "dynamax-crystal-cru4656",
      "url": "https://pokeapi.co/api/v2/item/1597/"
    },
    {
      "name": "dynamax-crystal-psa8728",
      "url": "https://pokeapi.co/api/v2/item/1598/"
    },
    {
      "name": "dynamax-crystal-tra6217",
      "url": "https://pokeapi.co/api/v2/item/1599/"
    },
    {
      "name": "dynamax-crystal-cap7776",
      "url": "https://pokeapi.co/api/v2/item/1600/"
    },
    {
      "name": "dynamax-crystal-cap7754",
      "url": "https://pokeapi.co/api/v2/item/1601/"
    },
    {
      "name": "dynamax-crystal-cap8278",
      "url": "https://pokeapi.co/api/v2/item/1602/"
    },
    {
      "name": "dynamax-crystal-cap8322",
      "url": "https://pokeapi.co/api/v2/item/1603/"
    },
    {
      "name": "dynamax-crystal-cap7773",
      "url": "https://pokeapi.co/api/v2/item/1604/"
    },
    {
      "name": "dynamax-crystal-sge7479",
      "url": "https://pokeapi.co/api/v2/item/1605/"
    },
    {
      "name": "dynamax-crystal-car2326",
      "url": "https://pokeapi.co/api/v2/item/1606/"
    },
    {
      "name": "dynamax-crystal-car3685",
      "url": "https://pokeapi.co/api/v2/item/1607/"
    },
    {
      "name": "dynamax-crystal-car3307",
      "url": "https://pokeapi.co/api/v2/item/1608/"
    },
    {
      "name": "dynamax-crystal-car3699",
      "url": "https://pokeapi.co/api/v2/item/1609/"
    },
    {
      "name": "dynamax-crystal-dra5744",
      "url": "https://pokeapi.co/api/v2/item/1610/"
    },
    {
      "name": "dynamax-crystal-dra5291",
      "url": "https://pokeapi.co/api/v2/item/1611/"
    },
    {
      "name": "dynamax-crystal-dra6705",
      "url": "https://pokeapi.co/api/v2/item/1612/"
    },
    {
      "name": "dynamax-crystal-dra6536",
      "url": "https://pokeapi.co/api/v2/item/1613/"
    },
    {
      "name": "dynamax-crystal-dra7310",
      "url": "https://pokeapi.co/api/v2/item/1614/"
    },
    {
      "name": "dynamax-crystal-dra6688",
      "url": "https://pokeapi.co/api/v2/item/1615/"
    },
    {
      "name": "dynamax-crystal-dra4434",
      "url": "https://pokeapi.co/api/v2/item/1616/"
    },
    {
      "name": "dynamax-crystal-dra6370",
      "url": "https://pokeapi.co/api/v2/item/1617/"
    },
    {
      "name": "dynamax-crystal-dra7462",
      "url": "https://pokeapi.co/api/v2/item/1618/"
    },
    {
      "name": "dynamax-crystal-dra6396",
      "url": "https://pokeapi.co/api/v2/item/1619/"
    },
    {
      "name": "dynamax-crystal-dra6132",
      "url": "https://pokeapi.co/api/v2/item/1620/"
    },
    {
      "name": "dynamax-crystal-dra6636",
      "url": "https://pokeapi.co/api/v2/item/1621/"
    },
    {
      "name": "dynamax-crystal-cvn4915",
      "url": "https://pokeapi.co/api/v2/item/1622/"
    },
    {
      "name": "dynamax-crystal-cvn4785",
      "url": "https://pokeapi.co/api/v2/item/1623/"
    },
    {
      "name": "dynamax-crystal-cvn4846",
      "url": "https://pokeapi.co/api/v2/item/1624/"
    },
    {
      "name": "dynamax-crystal-aql7595",
      "url": "https://pokeapi.co/api/v2/item/1625/"
    },
    {
      "name": "dynamax-crystal-aql7557",
      "url": "https://pokeapi.co/api/v2/item/1626/"
    },
    {
      "name": "dynamax-crystal-aql7525",
      "url": "https://pokeapi.co/api/v2/item/1627/"
    },
    {
      "name": "dynamax-crystal-aql7602",
      "url": "https://pokeapi.co/api/v2/item/1628/"
    },
    {
      "name": "dynamax-crystal-aql7235",
      "url": "https://pokeapi.co/api/v2/item/1629/"
    },
    {
      "name": "max-honey",
      "url": "https://pokeapi.co/api/v2/item/1630/"
    },
    {
      "name": "max-mushrooms",
      "url": "https://pokeapi.co/api/v2/item/1631/"
    },
    {
      "name": "galarica-twig",
      "url": "https://pokeapi.co/api/v2/item/1632/"
    },
    {
      "name": "galarica-cuff",
      "url": "https://pokeapi.co/api/v2/item/1633/"
    },
    {
      "name": "style-card",
      "url": "https://pokeapi.co/api/v2/item/1634/"
    },
    {
      "name": "armor-pass",
      "url": "https://pokeapi.co/api/v2/item/1635/"
    },
    {
      "name": "rotom-bike--sparkling-white",
      "url": "https://pokeapi.co/api/v2/item/1636/"
    },
    {
      "name": "rotom-bike--glistening-black",
      "url": "https://pokeapi.co/api/v2/item/1637/"
    },
    {
      "name": "exp-charm",
      "url": "https://pokeapi.co/api/v2/item/1638/"
    },
    {
      "name": "armorite-ore",
      "url": "https://pokeapi.co/api/v2/item/1639/"
    },
    {
      "name": "mark-charm",
      "url": "https://pokeapi.co/api/v2/item/1640/"
    },
    {
      "name": "reins-of-unity--merge",
      "url": "https://pokeapi.co/api/v2/item/1641/"
    },
    {
      "name": "reins-of-unity--split",
      "url": "https://pokeapi.co/api/v2/item/1642/"
    },
    {
      "name": "galarica-wreath",
      "url": "https://pokeapi.co/api/v2/item/1643/"
    },
    {
      "name": "legendary-clue-1",
      "url": "https://pokeapi.co/api/v2/item/1644/"
    },
    {
      "name": "legendary-clue-2",
      "url": "https://pokeapi.co/api/v2/item/1645/"
    },
    {
      "name": "legendary-clue-3",
      "url": "https://pokeapi.co/api/v2/item/1646/"
    },
    {
      "name": "legendary-clue-question",
      "url": "https://pokeapi.co/api/v2/item/1647/"
    },
    {
      "name": "crown-pass",
      "url": "https://pokeapi.co/api/v2/item/1648/"
    },
    {
      "name": "wooden-crown",
      "url": "https://pokeapi.co/api/v2/item/1649/"
    },
    {
      "name": "radiant-petal",
      "url": "https://pokeapi.co/api/v2/item/1650/"
    },
    {
      "name": "white-mane-hair",
      "url": "https://pokeapi.co/api/v2/item/1651/"
    },
    {
      "name": "black-mane-hair",
      "url": "https://pokeapi.co/api/v2/item/1652/"
    },
    {
      "name": "iceroot-carrot",
      "url": "https://pokeapi.co/api/v2/item/1653/"
    },
    {
      "name": "shaderoot-carrot",
      "url": "https://pokeapi.co/api/v2/item/1654/"
    },
    {
      "name": "dynite-ore",
      "url": "https://pokeapi.co/api/v2/item/1655/"
    },
    {
      "name": "carrot-seeds",
      "url": "https://pokeapi.co/api/v2/item/1656/"
    },
    {
      "name": "ability-patch",
      "url": "https://pokeapi.co/api/v2/item/1657/"
    },
    {
      "name": "reins-of-unity",
      "url": "https://pokeapi.co/api/v2/item/1658/"
    },
    {
      "name": "adamant-crystal",
      "url": "https://pokeapi.co/api/v2/item/1659/"
    },
    {
      "name": "lustrous-globe",
      "url": "https://pokeapi.co/api/v2/item/1660/"
    },
    {
      "name": "griseous-core",
      "url": "https://pokeapi.co/api/v2/item/1661/"
    },
    {
      "name": "blank-plate",
      "url": "https://pokeapi.co/api/v2/item/1662/"
    },
    {
      "name": "strange-ball",
      "url": "https://pokeapi.co/api/v2/item/1663/"
    },
    {
      "name": "legend-plate",
      "url": "https://pokeapi.co/api/v2/item/1664/"
    },
    {
      "name": "rotom-phone",
      "url": "https://pokeapi.co/api/v2/item/1665/"
    },
    {
      "name": "sandwich",
      "url": "https://pokeapi.co/api/v2/item/1666/"
    },
    {
      "name": "koraidon’s-poké-ball",
      "url": "https://pokeapi.co/api/v2/item/1667/"
    },
    {
      "name": "miraidon’s-poké-ball",
      "url": "https://pokeapi.co/api/v2/item/1668/"
    },
    {
      "name": "tera-orb",
      "url": "https://pokeapi.co/api/v2/item/1669/"
    },
    {
      "name": "scarlet-book",
      "url": "https://pokeapi.co/api/v2/item/1670/"
    },
    {
      "name": "violet-book",
      "url": "https://pokeapi.co/api/v2/item/1671/"
    },
    {
      "name": "kofu’s-wallet",
      "url": "https://pokeapi.co/api/v2/item/1672/"
    },
    {
      "name": "tiny-bamboo-shoot",
      "url": "https://pokeapi.co/api/v2/item/1673/"
    },
    {
      "name": "big-bamboo-shoot",
      "url": "https://pokeapi.co/api/v2/item/1674/"
    },
    {
      "name": "scroll-of-darkness",
      "url": "https://pokeapi.co/api/v2/item/1675/"
    },
    {
      "name": "scroll-of-waters",
      "url": "https://pokeapi.co/api/v2/item/1676/"
    },
    {
      "name": "malicious-armor",
      "url": "https://pokeapi.co/api/v2/item/1677/"
    },
    {
      "name": "normal-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1678/"
    },
    {
      "name": "fire-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1679/"
    },
    {
      "name": "water-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1680/"
    },
    {
      "name": "electric-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1681/"
    },
    {
      "name": "grass-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1682/"
    },
    {
      "name": "ice-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1683/"
    },
    {
      "name": "fighting-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1684/"
    },
    {
      "name": "poison-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1685/"
    },
    {
      "name": "ground-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1686/"
    },
    {
      "name": "flying-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1687/"
    },
    {
      "name": "psychic-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1688/"
    },
    {
      "name": "bug-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1689/"
    },
    {
      "name": "rock-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1690/"
    },
    {
      "name": "ghost-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1691/"
    },
    {
      "name": "dragon-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1692/"
    },
    {
      "name": "dark-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1693/"
    },
    {
      "name": "steel-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1694/"
    },
    {
      "name": "fairy-tera-shard",
      "url": "https://pokeapi.co/api/v2/item/1695/"
    },
    {
      "name": "booster-energy",
      "url": "https://pokeapi.co/api/v2/item/1696/"
    },
    {
      "name": "ability-shield",
      "url": "https://pokeapi.co/api/v2/item/1697/"
    },
    {
      "name": "clear-amulet",
      "url": "https://pokeapi.co/api/v2/item/1698/"
    },
    {
      "name": "mirror-herb",
      "url": "https://pokeapi.co/api/v2/item/1699/"
    },
    {
      "name": "punching-glove",
      "url": "https://pokeapi.co/api/v2/item/1700/"
    },
    {
      "name": "covert-cloak",
      "url": "https://pokeapi.co/api/v2/item/1701/"
    },
    {
      "name": "loaded-dice",
      "url": "https://pokeapi.co/api/v2/item/1702/"
    },
    {
      "name": "baguette",
      "url": "https://pokeapi.co/api/v2/item/1703/"
    },
    {
      "name": "mayonnaise",
      "url": "https://pokeapi.co/api/v2/item/1704/"
    },
    {
      "name": "ketchup",
      "url": "https://pokeapi.co/api/v2/item/1705/"
    },
    {
      "name": "mustard",
      "url": "https://pokeapi.co/api/v2/item/1706/"
    },
    {
      "name": "butter",
      "url": "https://pokeapi.co/api/v2/item/1707/"
    },
    {
      "name": "peanut-butter",
      "url": "https://pokeapi.co/api/v2/item/1708/"
    },
    {
      "name": "chili-sauce",
      "url": "https://pokeapi.co/api/v2/item/1709/"
    },
    {
      "name": "salt",
      "url": "https://pokeapi.co/api/v2/item/1710/"
    },
    {
      "name": "pepper",
      "url": "https://pokeapi.co/api/v2/item/1711/"
    },
    {
      "name": "yogurt",
      "url": "https://pokeapi.co/api/v2/item/1712/"
    },
    {
      "name": "whipped-cream",
      "url": "https://pokeapi.co/api/v2/item/1713/"
    },
    {
      "name": "cream-cheese",
      "url": "https://pokeapi.co/api/v2/item/1714/"
    },
    {
      "name": "jam",
      "url": "https://pokeapi.co/api/v2/item/1715/"
    },
    {
      "name": "marmalade",
      "url": "https://pokeapi.co/api/v2/item/1716/"
    },
    {
      "name": "olive-oil",
      "url": "https://pokeapi.co/api/v2/item/1717/"
    },
    {
      "name": "vinegar",
      "url": "https://pokeapi.co/api/v2/item/1718/"
    },
    {
      "name": "sweet-herba-mystica",
      "url": "https://pokeapi.co/api/v2/item/1719/"
    },
    {
      "name": "salty-herba-mystica",
      "url": "https://pokeapi.co/api/v2/item/1720/"
    },
    {
      "name": "sour-herba-mystica",
      "url": "https://pokeapi.co/api/v2/item/1721/"
    },
    {
      "name": "bitter-herba-mystica",
      "url": "https://pokeapi.co/api/v2/item/1722/"
    },
    {
      "name": "spicy-herba-mystica",
      "url": "https://pokeapi.co/api/v2/item/1723/"
    },
    {
      "name": "lettuce",
      "url": "https://pokeapi.co/api/v2/item/1724/"
    },
    {
      "name": "tomato",
      "url": "https://pokeapi.co/api/v2/item/1725/"
    },
    {
      "name": "cherry-tomatoes",
      "url": "https://pokeapi.co/api/v2/item/1726/"
    },
    {
      "name": "cucumber",
      "url": "https://pokeapi.co/api/v2/item/1727/"
    },
    {
      "name": "pickle",
      "url": "https://pokeapi.co/api/v2/item/1728/"
    },
    {
      "name": "onion",
      "url": "https://pokeapi.co/api/v2/item/1729/"
    },
    {
      "name": "red-onion",
      "url": "https://pokeapi.co/api/v2/item/1730/"
    },
    {
      "name": "green-bell-pepper",
      "url": "https://pokeapi.co/api/v2/item/1731/"
    },
    {
      "name": "red-bell-pepper",
      "url": "https://pokeapi.co/api/v2/item/1732/"
    },
    {
      "name": "yellow-bell-pepper",
      "url": "https://pokeapi.co/api/v2/item/1733/"
    },
    {
      "name": "avocado",
      "url": "https://pokeapi.co/api/v2/item/1734/"
    },
    {
      "name": "bacon",
      "url": "https://pokeapi.co/api/v2/item/1735/"
    },
    {
      "name": "ham",
      "url": "https://pokeapi.co/api/v2/item/1736/"
    },
    {
      "name": "prosciutto",
      "url": "https://pokeapi.co/api/v2/item/1737/"
    },
    {
      "name": "chorizo",
      "url": "https://pokeapi.co/api/v2/item/1738/"
    },
    {
      "name": "herbed-sausage",
      "url": "https://pokeapi.co/api/v2/item/1739/"
    },
    {
      "name": "hamburger",
      "url": "https://pokeapi.co/api/v2/item/1740/"
    },
    {
      "name": "klawf-stick",
      "url": "https://pokeapi.co/api/v2/item/1741/"
    },
    {
      "name": "smoked-fillet",
      "url": "https://pokeapi.co/api/v2/item/1742/"
    },
    {
      "name": "fried-fillet",
      "url": "https://pokeapi.co/api/v2/item/1743/"
    },
    {
      "name": "egg",
      "url": "https://pokeapi.co/api/v2/item/1744/"
    },
    {
      "name": "potato-tortilla",
      "url": "https://pokeapi.co/api/v2/item/1745/"
    },
    {
      "name": "tofu",
      "url": "https://pokeapi.co/api/v2/item/1746/"
    },
    {
      "name": "rice",
      "url": "https://pokeapi.co/api/v2/item/1747/"
    },
    {
      "name": "noodles",
      "url": "https://pokeapi.co/api/v2/item/1748/"
    },
    {
      "name": "potato-salad",
      "url": "https://pokeapi.co/api/v2/item/1749/"
    },
    {
      "name": "cheese",
      "url": "https://pokeapi.co/api/v2/item/1750/"
    },
    {
      "name": "banana",
      "url": "https://pokeapi.co/api/v2/item/1751/"
    },
    {
      "name": "strawberry",
      "url": "https://pokeapi.co/api/v2/item/1752/"
    },
    {
      "name": "apple",
      "url": "https://pokeapi.co/api/v2/item/1753/"
    },
    {
      "name": "kiwi",
      "url": "https://pokeapi.co/api/v2/item/1754/"
    },
    {
      "name": "pineapple",
      "url": "https://pokeapi.co/api/v2/item/1755/"
    },
    {
      "name": "jalapeño",
      "url": "https://pokeapi.co/api/v2/item/1756/"
    },
    {
      "name": "horseradish",
      "url": "https://pokeapi.co/api/v2/item/1757/"
    },
    {
      "name": "curry-powder",
      "url": "https://pokeapi.co/api/v2/item/1758/"
    },
    {
      "name": "wasabi",
      "url": "https://pokeapi.co/api/v2/item/1759/"
    },
    {
      "name": "watercress",
      "url": "https://pokeapi.co/api/v2/item/1760/"
    },
    {
      "name": "basil",
      "url": "https://pokeapi.co/api/v2/item/1761/"
    },
    {
      "name": "venonat-fang",
      "url": "https://pokeapi.co/api/v2/item/1762/"
    },
    {
      "name": "diglett-dirt",
      "url": "https://pokeapi.co/api/v2/item/1763/"
    },
    {
      "name": "meowth-fur",
      "url": "https://pokeapi.co/api/v2/item/1764/"
    },
    {
      "name": "psyduck-down",
      "url": "https://pokeapi.co/api/v2/item/1765/"
    },
    {
      "name": "mankey-fur",
      "url": "https://pokeapi.co/api/v2/item/1766/"
    },
    {
      "name": "growlithe-fur",
      "url": "https://pokeapi.co/api/v2/item/1767/"
    },
    {
      "name": "slowpoke-claw",
      "url": "https://pokeapi.co/api/v2/item/1768/"
    },
    {
      "name": "magnemite-screw",
      "url": "https://pokeapi.co/api/v2/item/1769/"
    },
    {
      "name": "grimer-toxin",
      "url": "https://pokeapi.co/api/v2/item/1770/"
    },
    {
      "name": "shellder-pearl",
      "url": "https://pokeapi.co/api/v2/item/1771/"
    },
    {
      "name": "gastly-gas",
      "url": "https://pokeapi.co/api/v2/item/1772/"
    },
    {
      "name": "drowzee-fur",
      "url": "https://pokeapi.co/api/v2/item/1773/"
    },
    {
      "name": "voltorb-sparks",
      "url": "https://pokeapi.co/api/v2/item/1774/"
    },
    {
      "name": "scyther-claw",
      "url": "https://pokeapi.co/api/v2/item/1775/"
    },
    {
      "name": "tauros-hair",
      "url": "https://pokeapi.co/api/v2/item/1776/"
    },
    {
      "name": "magikarp-scales",
      "url": "https://pokeapi.co/api/v2/item/1777/"
    },
    {
      "name": "ditto-goo",
      "url": "https://pokeapi.co/api/v2/item/1778/"
    },
    {
      "name": "eevee-fur",
      "url": "https://pokeapi.co/api/v2/item/1779/"
    },
    {
      "name": "dratini-scales",
      "url": "https://pokeapi.co/api/v2/item/1780/"
    },
    {
      "name": "pichu-fur",
      "url": "https://pokeapi.co/api/v2/item/1781/"
    },
    {
      "name": "igglybuff-fluff",
      "url": "https://pokeapi.co/api/v2/item/1782/"
    },
    {
      "name": "mareep-wool",
      "url": "https://pokeapi.co/api/v2/item/1783/"
    },
    {
      "name": "hoppip-leaf",
      "url": "https://pokeapi.co/api/v2/item/1784/"
    },
    {
      "name": "sunkern-leaf",
      "url": "https://pokeapi.co/api/v2/item/1785/"
    },
    {
      "name": "murkrow-bauble",
      "url": "https://pokeapi.co/api/v2/item/1786/"
    },
    {
      "name": "misdreavus-tears",
      "url": "https://pokeapi.co/api/v2/item/1787/"
    },
    {
      "name": "girafarig-fur",
      "url": "https://pokeapi.co/api/v2/item/1788/"
    },
    {
      "name": "pineco-husk",
      "url": "https://pokeapi.co/api/v2/item/1789/"
    },
    {
      "name": "dunsparce-scales",
      "url": "https://pokeapi.co/api/v2/item/1790/"
    },
    {
      "name": "qwilfish-spines",
      "url": "https://pokeapi.co/api/v2/item/1791/"
    },
    {
      "name": "heracross-claw",
      "url": "https://pokeapi.co/api/v2/item/1792/"
    },
    {
      "name": "sneasel-claw",
      "url": "https://pokeapi.co/api/v2/item/1793/"
    },
    {
      "name": "teddiursa-claw",
      "url": "https://pokeapi.co/api/v2/item/1794/"
    },
    {
      "name": "delibird-parcel",
      "url": "https://pokeapi.co/api/v2/item/1795/"
    },
    {
      "name": "houndour-fang",
      "url": "https://pokeapi.co/api/v2/item/1796/"
    },
    {
      "name": "phanpy-nail",
      "url": "https://pokeapi.co/api/v2/item/1797/"
    },
    {
      "name": "stantler-hair",
      "url": "https://pokeapi.co/api/v2/item/1798/"
    },
    {
      "name": "larvitar-claw",
      "url": "https://pokeapi.co/api/v2/item/1799/"
    },
    {
      "name": "wingull-feather",
      "url": "https://pokeapi.co/api/v2/item/1800/"
    },
    {
      "name": "ralts-dust",
      "url": "https://pokeapi.co/api/v2/item/1801/"
    },
    {
      "name": "surskit-syrup",
      "url": "https://pokeapi.co/api/v2/item/1802/"
    },
    {
      "name": "shroomish-spores",
      "url": "https://pokeapi.co/api/v2/item/1803/"
    },
    {
      "name": "slakoth-fur",
      "url": "https://pokeapi.co/api/v2/item/1804/"
    },
    {
      "name": "makuhita-sweat",
      "url": "https://pokeapi.co/api/v2/item/1805/"
    },
    {
      "name": "azurill-fur",
      "url": "https://pokeapi.co/api/v2/item/1806/"
    },
    {
      "name": "sableye-gem",
      "url": "https://pokeapi.co/api/v2/item/1807/"
    },
    {
      "name": "meditite-sweat",
      "url": "https://pokeapi.co/api/v2/item/1808/"
    },
    {
      "name": "gulpin-mucus",
      "url": "https://pokeapi.co/api/v2/item/1809/"
    },
    {
      "name": "numel-lava",
      "url": "https://pokeapi.co/api/v2/item/1810/"
    },
    {
      "name": "torkoal-coal",
      "url": "https://pokeapi.co/api/v2/item/1811/"
    },
    {
      "name": "spoink-pearl",
      "url": "https://pokeapi.co/api/v2/item/1812/"
    },
    {
      "name": "cacnea-needle",
      "url": "https://pokeapi.co/api/v2/item/1813/"
    },
    {
      "name": "swablu-fluff",
      "url": "https://pokeapi.co/api/v2/item/1814/"
    },
    {
      "name": "zangoose-claw",
      "url": "https://pokeapi.co/api/v2/item/1815/"
    },
    {
      "name": "seviper-fang",
      "url": "https://pokeapi.co/api/v2/item/1816/"
    },
    {
      "name": "barboach-slime",
      "url": "https://pokeapi.co/api/v2/item/1817/"
    },
    {
      "name": "shuppet-scrap",
      "url": "https://pokeapi.co/api/v2/item/1818/"
    },
    {
      "name": "tropius-leaf",
      "url": "https://pokeapi.co/api/v2/item/1819/"
    },
    {
      "name": "snorunt-fur",
      "url": "https://pokeapi.co/api/v2/item/1820/"
    },
    {
      "name": "luvdisc-scales",
      "url": "https://pokeapi.co/api/v2/item/1821/"
    },
    {
      "name": "bagon-scales",
      "url": "https://pokeapi.co/api/v2/item/1822/"
    },
    {
      "name": "starly-feather",
      "url": "https://pokeapi.co/api/v2/item/1823/"
    },
    {
      "name": "kricketot-shell",
      "url": "https://pokeapi.co/api/v2/item/1824/"
    },
    {
      "name": "shinx-fang",
      "url": "https://pokeapi.co/api/v2/item/1825/"
    },
    {
      "name": "combee-honey",
      "url": "https://pokeapi.co/api/v2/item/1826/"
    },
    {
      "name": "pachirisu-fur",
      "url": "https://pokeapi.co/api/v2/item/1827/"
    },
    {
      "name": "buizel-fur",
      "url": "https://pokeapi.co/api/v2/item/1828/"
    },
    {
      "name": "shellos-mucus",
      "url": "https://pokeapi.co/api/v2/item/1829/"
    },
    {
      "name": "drifloon-gas",
      "url": "https://pokeapi.co/api/v2/item/1830/"
    },
    {
      "name": "stunky-fur",
      "url": "https://pokeapi.co/api/v2/item/1831/"
    },
    {
      "name": "bronzor-fragment",
      "url": "https://pokeapi.co/api/v2/item/1832/"
    },
    {
      "name": "bonsly-tears",
      "url": "https://pokeapi.co/api/v2/item/1833/"
    },
    {
      "name": "happiny-dust",
      "url": "https://pokeapi.co/api/v2/item/1834/"
    },
    {
      "name": "spiritomb-fragment",
      "url": "https://pokeapi.co/api/v2/item/1835/"
    },
    {
      "name": "gible-scales",
      "url": "https://pokeapi.co/api/v2/item/1836/"
    },
    {
      "name": "riolu-fur",
      "url": "https://pokeapi.co/api/v2/item/1837/"
    },
    {
      "name": "hippopotas-sand",
      "url": "https://pokeapi.co/api/v2/item/1838/"
    },
    {
      "name": "croagunk-poison",
      "url": "https://pokeapi.co/api/v2/item/1839/"
    },
    {
      "name": "finneon-scales",
      "url": "https://pokeapi.co/api/v2/item/1840/"
    },
    {
      "name": "snover-berries",
      "url": "https://pokeapi.co/api/v2/item/1841/"
    },
    {
      "name": "rotom-sparks",
      "url": "https://pokeapi.co/api/v2/item/1842/"
    },
    {
      "name": "petilil-leaf",
      "url": "https://pokeapi.co/api/v2/item/1843/"
    },
    {
      "name": "basculin-fang",
      "url": "https://pokeapi.co/api/v2/item/1844/"
    },
    {
      "name": "sandile-claw",
      "url": "https://pokeapi.co/api/v2/item/1845/"
    },
    {
      "name": "zorua-fur",
      "url": "https://pokeapi.co/api/v2/item/1846/"
    },
    {
      "name": "gothita-eyelash",
      "url": "https://pokeapi.co/api/v2/item/1847/"
    },
    {
      "name": "deerling-hair",
      "url": "https://pokeapi.co/api/v2/item/1848/"
    },
    {
      "name": "foongus-spores",
      "url": "https://pokeapi.co/api/v2/item/1849/"
    },
    {
      "name": "alomomola-mucus",
      "url": "https://pokeapi.co/api/v2/item/1850/"
    },
    {
      "name": "tynamo-slime",
      "url": "https://pokeapi.co/api/v2/item/1851/"
    },
    {
      "name": "axew-scales",
      "url": "https://pokeapi.co/api/v2/item/1852/"
    },
    {
      "name": "cubchoo-fur",
      "url": "https://pokeapi.co/api/v2/item/1853/"
    },
    {
      "name": "cryogonal-ice",
      "url": "https://pokeapi.co/api/v2/item/1854/"
    },
    {
      "name": "pawniard-blade",
      "url": "https://pokeapi.co/api/v2/item/1855/"
    },
    {
      "name": "rufflet-feather",
      "url": "https://pokeapi.co/api/v2/item/1856/"
    },
    {
      "name": "deino-scales",
      "url": "https://pokeapi.co/api/v2/item/1857/"
    },
    {
      "name": "larvesta-fuzz",
      "url": "https://pokeapi.co/api/v2/item/1858/"
    },
    {
      "name": "fletchling-feather",
      "url": "https://pokeapi.co/api/v2/item/1859/"
    },
    {
      "name": "scatterbug-powder",
      "url": "https://pokeapi.co/api/v2/item/1860/"
    },
    {
      "name": "litleo-tuft",
      "url": "https://pokeapi.co/api/v2/item/1861/"
    },
    {
      "name": "flabébé-pollen",
      "url": "https://pokeapi.co/api/v2/item/1862/"
    },
    {
      "name": "skiddo-leaf",
      "url": "https://pokeapi.co/api/v2/item/1863/"
    },
    {
      "name": "skrelp-kelp",
      "url": "https://pokeapi.co/api/v2/item/1864/"
    },
    {
      "name": "clauncher-claw",
      "url": "https://pokeapi.co/api/v2/item/1865/"
    },
    {
      "name": "hawlucha-down",
      "url": "https://pokeapi.co/api/v2/item/1866/"
    },
    {
      "name": "dedenne-fur",
      "url": "https://pokeapi.co/api/v2/item/1867/"
    },
    {
      "name": "goomy-goo",
      "url": "https://pokeapi.co/api/v2/item/1868/"
    },
    {
      "name": "klefki-key",
      "url": "https://pokeapi.co/api/v2/item/1869/"
    },
    {
      "name": "bergmite-ice",
      "url": "https://pokeapi.co/api/v2/item/1870/"
    },
    {
      "name": "noibat-fur",
      "url": "https://pokeapi.co/api/v2/item/1871/"
    },
    {
      "name": "yungoos-fur",
      "url": "https://pokeapi.co/api/v2/item/1872/"
    },
    {
      "name": "crabrawler-shell",
      "url": "https://pokeapi.co/api/v2/item/1873/"
    },
    {
      "name": "oricorio-feather",
      "url": "https://pokeapi.co/api/v2/item/1874/"
    },
    {
      "name": "rockruff-rock",
      "url": "https://pokeapi.co/api/v2/item/1875/"
    },
    {
      "name": "mareanie-spike",
      "url": "https://pokeapi.co/api/v2/item/1876/"
    },
    {
      "name": "mudbray-mud",
      "url": "https://pokeapi.co/api/v2/item/1877/"
    },
    {
      "name": "fomantis-leaf",
      "url": "https://pokeapi.co/api/v2/item/1878/"
    },
    {
      "name": "salandit-gas",
      "url": "https://pokeapi.co/api/v2/item/1879/"
    },
    {
      "name": "bounsweet-sweat",
      "url": "https://pokeapi.co/api/v2/item/1880/"
    },
    {
      "name": "oranguru-fur",
      "url": "https://pokeapi.co/api/v2/item/1881/"
    },
    {
      "name": "passimian-fur",
      "url": "https://pokeapi.co/api/v2/item/1882/"
    },
    {
      "name": "sandygast-sand",
      "url": "https://pokeapi.co/api/v2/item/1883/"
    },
    {
      "name": "komala-claw",
      "url": "https://pokeapi.co/api/v2/item/1884/"
    },
    {
      "name": "mimikyu-scrap",
      "url": "https://pokeapi.co/api/v2/item/1885/"
    },
    {
      "name": "bruxish-tooth",
      "url": "https://pokeapi.co/api/v2/item/1886/"
    },
    {
      "name": "chewtle-claw",
      "url": "https://pokeapi.co/api/v2/item/1887/"
    },
    {
      "name": "skwovet-fur",
      "url": "https://pokeapi.co/api/v2/item/1888/"
    },
    {
      "name": "arrokuda-scales",
      "url": "https://pokeapi.co/api/v2/item/1889/"
    },
    {
      "name": "rookidee-feather",
      "url": "https://pokeapi.co/api/v2/item/1890/"
    },
    {
      "name": "toxel-sparks",
      "url": "https://pokeapi.co/api/v2/item/1891/"
    },
    {
      "name": "falinks-sweat",
      "url": "https://pokeapi.co/api/v2/item/1892/"
    },
    {
      "name": "cufant-tarnish",
      "url": "https://pokeapi.co/api/v2/item/1893/"
    },
    {
      "name": "rolycoly-coal",
      "url": "https://pokeapi.co/api/v2/item/1894/"
    },
    {
      "name": "silicobra-sand",
      "url": "https://pokeapi.co/api/v2/item/1895/"
    },
    {
      "name": "indeedee-fur",
      "url": "https://pokeapi.co/api/v2/item/1896/"
    },
    {
      "name": "pincurchin-spines",
      "url": "https://pokeapi.co/api/v2/item/1897/"
    },
    {
      "name": "snom-thread",
      "url": "https://pokeapi.co/api/v2/item/1898/"
    },
    {
      "name": "impidimp-hair",
      "url": "https://pokeapi.co/api/v2/item/1899/"
    },
    {
      "name": "applin-juice",
      "url": "https://pokeapi.co/api/v2/item/1900/"
    },
    {
      "name": "sinistea-chip",
      "url": "https://pokeapi.co/api/v2/item/1901/"
    },
    {
      "name": "hatenna-dust",
      "url": "https://pokeapi.co/api/v2/item/1902/"
    },
    {
      "name": "stonjourner-stone",
      "url": "https://pokeapi.co/api/v2/item/1903/"
    },
    {
      "name": "eiscue-down",
      "url": "https://pokeapi.co/api/v2/item/1904/"
    },
    {
      "name": "dreepy-powder",
      "url": "https://pokeapi.co/api/v2/item/1905/"
    },
    {
      "name": "lechonk-hair",
      "url": "https://pokeapi.co/api/v2/item/1906/"
    },
    {
      "name": "tarountula-thread",
      "url": "https://pokeapi.co/api/v2/item/1907/"
    },
    {
      "name": "nymble-claw",
      "url": "https://pokeapi.co/api/v2/item/1908/"
    },
    {
      "name": "rellor-mud",
      "url": "https://pokeapi.co/api/v2/item/1909/"
    },
    {
      "name": "greavard-wax",
      "url": "https://pokeapi.co/api/v2/item/1910/"
    },
    {
      "name": "flittle-down",
      "url": "https://pokeapi.co/api/v2/item/1911/"
    },
    {
      "name": "wiglett-sand",
      "url": "https://pokeapi.co/api/v2/item/1912/"
    },
    {
      "name": "dondozo-whisker",
      "url": "https://pokeapi.co/api/v2/item/1913/"
    },
    {
      "name": "veluza-fillet",
      "url": "https://pokeapi.co/api/v2/item/1914/"
    },
    {
      "name": "finizen-mucus",
      "url": "https://pokeapi.co/api/v2/item/1915/"
    },
    {
      "name": "smoliv-oil",
      "url": "https://pokeapi.co/api/v2/item/1916/"
    },
    {
      "name": "capsakid-seed",
      "url": "https://pokeapi.co/api/v2/item/1917/"
    },
    {
      "name": "tadbulb-mucus",
      "url": "https://pokeapi.co/api/v2/item/1918/"
    },
    {
      "name": "varoom-fume",
      "url": "https://pokeapi.co/api/v2/item/1919/"
    },
    {
      "name": "orthworm-tarnish",
      "url": "https://pokeapi.co/api/v2/item/1920/"
    },
    {
      "name": "tandemaus-fur",
      "url": "https://pokeapi.co/api/v2/item/1921/"
    },
    {
      "name": "cetoddle-grease",
      "url": "https://pokeapi.co/api/v2/item/1922/"
    },
    {
      "name": "frigibax-scales",
      "url": "https://pokeapi.co/api/v2/item/1923/"
    },
    {
      "name": "tatsugiri-scales",
      "url": "https://pokeapi.co/api/v2/item/1924/"
    },
    {
      "name": "cyclizar-scales",
      "url": "https://pokeapi.co/api/v2/item/1925/"
    },
    {
      "name": "pawmi-fur",
      "url": "https://pokeapi.co/api/v2/item/1926/"
    },
    {
      "name": "wattrel-feather",
      "url": "https://pokeapi.co/api/v2/item/1927/"
    },
    {
      "name": "bombirdier-feather",
      "url": "https://pokeapi.co/api/v2/item/1928/"
    },
    {
      "name": "squawkabilly-feather",
      "url": "https://pokeapi.co/api/v2/item/1929/"
    },
    {
      "name": "flamigo-down",
      "url": "https://pokeapi.co/api/v2/item/1930/"
    },
    {
      "name": "klawf-claw",
      "url": "https://pokeapi.co/api/v2/item/1931/"
    },
    {
      "name": "nacli-salt",
      "url": "https://pokeapi.co/api/v2/item/1932/"
    },
    {
      "name": "glimmet-crystal",
      "url": "https://pokeapi.co/api/v2/item/1933/"
    },
    {
      "name": "shroodle-ink",
      "url": "https://pokeapi.co/api/v2/item/1934/"
    },
    {
      "name": "fidough-fur",
      "url": "https://pokeapi.co/api/v2/item/1935/"
    },
    {
      "name": "maschiff-fang",
      "url": "https://pokeapi.co/api/v2/item/1936/"
    },
    {
      "name": "bramblin-twig",
      "url": "https://pokeapi.co/api/v2/item/1937/"
    },
    {
      "name": "gimmighoul-coin",
      "url": "https://pokeapi.co/api/v2/item/1938/"
    },
    {
      "name": "tinkatink-hair",
      "url": "https://pokeapi.co/api/v2/item/1939/"
    },
    {
      "name": "charcadet-soot",
      "url": "https://pokeapi.co/api/v2/item/1940/"
    },
    {
      "name": "toedscool-flaps",
      "url": "https://pokeapi.co/api/v2/item/1941/"
    },
    {
      "name": "wooper-slime",
      "url": "https://pokeapi.co/api/v2/item/1942/"
    },
    {
      "name": "tm100",
      "url": "https://pokeapi.co/api/v2/item/1943/"
    },
    {
      "name": "tm101",
      "url": "https://pokeapi.co/api/v2/item/1944/"
    },
    {
      "name": "tm102",
      "url": "https://pokeapi.co/api/v2/item/1945/"
    },
    {
      "name": "tm103",
      "url": "https://pokeapi.co/api/v2/item/1946/"
    },
    {
      "name": "tm104",
      "url": "https://pokeapi.co/api/v2/item/1947/"
    },
    {
      "name": "tm105",
      "url": "https://pokeapi.co/api/v2/item/1948/"
    },
    {
      "name": "tm106",
      "url": "https://pokeapi.co/api/v2/item/1949/"
    },
    {
      "name": "tm107",
      "url": "https://pokeapi.co/api/v2/item/1950/"
    },
    {
      "name": "tm108",
      "url": "https://pokeapi.co/api/v2/item/1951/"
    },
    {
      "name": "tm109",
      "url": "https://pokeapi.co/api/v2/item/1952/"
    },
    {
      "name": "tm110",
      "url": "https://pokeapi.co/api/v2/item/1953/"
    },
    {
      "name": "tm111",
      "url": "https://pokeapi.co/api/v2/item/1954/"
    },
    {
      "name": "tm112",
      "url": "https://pokeapi.co/api/v2/item/1955/"
    },
    {
      "name": "tm113",
      "url": "https://pokeapi.co/api/v2/item/1956/"
    },
    {
      "name": "tm114",
      "url": "https://pokeapi.co/api/v2/item/1957/"
    },
    {
      "name": "tm115",
      "url": "https://pokeapi.co/api/v2/item/1958/"
    },
    {
      "name": "tm116",
      "url": "https://pokeapi.co/api/v2/item/1959/"
    },
    {
      "name": "tm117",
      "url": "https://pokeapi.co/api/v2/item/1960/"
    },
    {
      "name": "tm118",
      "url": "https://pokeapi.co/api/v2/item/1961/"
    },
    {
      "name": "tm119",
      "url": "https://pokeapi.co/api/v2/item/1962/"
    },
    {
      "name": "tm120",
      "url": "https://pokeapi.co/api/v2/item/1963/"
    },
    {
      "name": "tm121",
      "url": "https://pokeapi.co/api/v2/item/1964/"
    },
    {
      "name": "tm122",
      "url": "https://pokeapi.co/api/v2/item/1965/"
    },
    {
      "name": "tm123",
      "url": "https://pokeapi.co/api/v2/item/1966/"
    },
    {
      "name": "tm124",
      "url": "https://pokeapi.co/api/v2/item/1967/"
    },
    {
      "name": "tm125",
      "url": "https://pokeapi.co/api/v2/item/1968/"
    },
    {
      "name": "tm126",
      "url": "https://pokeapi.co/api/v2/item/1969/"
    },
    {
      "name": "tm127",
      "url": "https://pokeapi.co/api/v2/item/1970/"
    },
    {
      "name": "tm128",
      "url": "https://pokeapi.co/api/v2/item/1971/"
    },
    {
      "name": "tm129",
      "url": "https://pokeapi.co/api/v2/item/1972/"
    },
    {
      "name": "tm130",
      "url": "https://pokeapi.co/api/v2/item/1973/"
    },
    {
      "name": "tm131",
      "url": "https://pokeapi.co/api/v2/item/1974/"
    },
    {
      "name": "tm132",
      "url": "https://pokeapi.co/api/v2/item/1975/"
    },
    {
      "name": "tm133",
      "url": "https://pokeapi.co/api/v2/item/1976/"
    },
    {
      "name": "tm134",
      "url": "https://pokeapi.co/api/v2/item/1977/"
    },
    {
      "name": "tm135",
      "url": "https://pokeapi.co/api/v2/item/1978/"
    },
    {
      "name": "tm136",
      "url": "https://pokeapi.co/api/v2/item/1979/"
    },
    {
      "name": "tm137",
      "url": "https://pokeapi.co/api/v2/item/1980/"
    },
    {
      "name": "tm138",
      "url": "https://pokeapi.co/api/v2/item/1981/"
    },
    {
      "name": "tm139",
      "url": "https://pokeapi.co/api/v2/item/1982/"
    },
    {
      "name": "tm140",
      "url": "https://pokeapi.co/api/v2/item/1983/"
    },
    {
      "name": "tm141",
      "url": "https://pokeapi.co/api/v2/item/1984/"
    },
    {
      "name": "tm142",
      "url": "https://pokeapi.co/api/v2/item/1985/"
    },
    {
      "name": "tm143",
      "url": "https://pokeapi.co/api/v2/item/1986/"
    },
    {
      "name": "tm144",
      "url": "https://pokeapi.co/api/v2/item/1987/"
    },
    {
      "name": "tm145",
      "url": "https://pokeapi.co/api/v2/item/1988/"
    },
    {
      "name": "tm146",
      "url": "https://pokeapi.co/api/v2/item/1989/"
    },
    {
      "name": "tm147",
      "url": "https://pokeapi.co/api/v2/item/1990/"
    },
    {
      "name": "tm148",
      "url": "https://pokeapi.co/api/v2/item/1991/"
    },
    {
      "name": "tm149",
      "url": "https://pokeapi.co/api/v2/item/1992/"
    },
    {
      "name": "tm150",
      "url": "https://pokeapi.co/api/v2/item/1993/"
    },
    {
      "name": "tm151",
      "url": "https://pokeapi.co/api/v2/item/1994/"
    },
    {
      "name": "tm152",
      "url": "https://pokeapi.co/api/v2/item/1995/"
    },
    {
      "name": "tm153",
      "url": "https://pokeapi.co/api/v2/item/1996/"
    },
    {
      "name": "tm154",
      "url": "https://pokeapi.co/api/v2/item/1997/"
    },
    {
      "name": "tm155",
      "url": "https://pokeapi.co/api/v2/item/1998/"
    },
    {
      "name": "tm156",
      "url": "https://pokeapi.co/api/v2/item/1999/"
    },
    {
      "name": "tm157",
      "url": "https://pokeapi.co/api/v2/item/2000/"
    },
    {
      "name": "tm158",
      "url": "https://pokeapi.co/api/v2/item/2001/"
    },
    {
      "name": "tm159",
      "url": "https://pokeapi.co/api/v2/item/2002/"
    },
    {
      "name": "tm160",
      "url": "https://pokeapi.co/api/v2/item/2003/"
    },
    {
      "name": "tm161",
      "url": "https://pokeapi.co/api/v2/item/2004/"
    },
    {
      "name": "tm162",
      "url": "https://pokeapi.co/api/v2/item/2005/"
    },
    {
      "name": "tm163",
      "url": "https://pokeapi.co/api/v2/item/2006/"
    },
    {
      "name": "tm164",
      "url": "https://pokeapi.co/api/v2/item/2007/"
    },
    {
      "name": "tm165",
      "url": "https://pokeapi.co/api/v2/item/2008/"
    },
    {
      "name": "tm166",
      "url": "https://pokeapi.co/api/v2/item/2009/"
    },
    {
      "name": "tm167",
      "url": "https://pokeapi.co/api/v2/item/2010/"
    },
    {
      "name": "tm168",
      "url": "https://pokeapi.co/api/v2/item/2011/"
    },
    {
      "name": "tm169",
      "url": "https://pokeapi.co/api/v2/item/2012/"
    },
    {
      "name": "tm170",
      "url": "https://pokeapi.co/api/v2/item/2013/"
    },
    {
      "name": "tm171",
      "url": "https://pokeapi.co/api/v2/item/2014/"
    },
    {
      "name": "picnic-set",
      "url": "https://pokeapi.co/api/v2/item/2015/"
    },
    {
      "name": "academy-bottle",
      "url": "https://pokeapi.co/api/v2/item/2016/"
    },
    {
      "name": "academy-bottle",
      "url": "https://pokeapi.co/api/v2/item/2017/"
    },
    {
      "name": "polka-dot-bottle",
      "url": "https://pokeapi.co/api/v2/item/2018/"
    },
    {
      "name": "striped-bottle",
      "url": "https://pokeapi.co/api/v2/item/2019/"
    },
    {
      "name": "diamond-bottle",
      "url": "https://pokeapi.co/api/v2/item/2020/"
    },
    {
      "name": "academy-cup",
      "url": "https://pokeapi.co/api/v2/item/2021/"
    },
    {
      "name": "academy-cup",
      "url": "https://pokeapi.co/api/v2/item/2022/"
    },
    {
      "name": "striped-cup",
      "url": "https://pokeapi.co/api/v2/item/2023/"
    },
    {
      "name": "polka-dot-cup",
      "url": "https://pokeapi.co/api/v2/item/2024/"
    },
    {
      "name": "flower-pattern-cup",
      "url": "https://pokeapi.co/api/v2/item/2025/"
    },
    {
      "name": "academy-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2026/"
    },
    {
      "name": "academy-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2027/"
    },
    {
      "name": "whimsical-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2028/"
    },
    {
      "name": "leafy-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2029/"
    },
    {
      "name": "spooky-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2030/"
    },
    {
      "name": "academy-ball",
      "url": "https://pokeapi.co/api/v2/item/2031/"
    },
    {
      "name": "academy-ball",
      "url": "https://pokeapi.co/api/v2/item/2032/"
    },
    {
      "name": "marill-ball",
      "url": "https://pokeapi.co/api/v2/item/2033/"
    },
    {
      "name": "yarn-ball",
      "url": "https://pokeapi.co/api/v2/item/2034/"
    },
    {
      "name": "cyber-ball",
      "url": "https://pokeapi.co/api/v2/item/2035/"
    },
    {
      "name": "gold-pick",
      "url": "https://pokeapi.co/api/v2/item/2036/"
    },
    {
      "name": "silver-pick",
      "url": "https://pokeapi.co/api/v2/item/2037/"
    },
    {
      "name": "red-flag-pick",
      "url": "https://pokeapi.co/api/v2/item/2038/"
    },
    {
      "name": "blue-flag-pick",
      "url": "https://pokeapi.co/api/v2/item/2039/"
    },
    {
      "name": "pika-pika-pick",
      "url": "https://pokeapi.co/api/v2/item/2040/"
    },
    {
      "name": "winking-pika-pick",
      "url": "https://pokeapi.co/api/v2/item/2041/"
    },
    {
      "name": "vee-vee-pick",
      "url": "https://pokeapi.co/api/v2/item/2042/"
    },
    {
      "name": "smiling-vee-pick",
      "url": "https://pokeapi.co/api/v2/item/2043/"
    },
    {
      "name": "blue-poké-ball-pick",
      "url": "https://pokeapi.co/api/v2/item/2044/"
    },
    {
      "name": "auspicious-armor",
      "url": "https://pokeapi.co/api/v2/item/2045/"
    },
    {
      "name": "leader’s-crest",
      "url": "https://pokeapi.co/api/v2/item/2046/"
    },
    {
      "name": "pink-bottle",
      "url": "https://pokeapi.co/api/v2/item/2047/"
    },
    {
      "name": "blue-bottle",
      "url": "https://pokeapi.co/api/v2/item/2048/"
    },
    {
      "name": "yellow-bottle",
      "url": "https://pokeapi.co/api/v2/item/2049/"
    },
    {
      "name": "steel-bottle-(r)",
      "url": "https://pokeapi.co/api/v2/item/2050/"
    },
    {
      "name": "steel-bottle-(y)",
      "url": "https://pokeapi.co/api/v2/item/2051/"
    },
    {
      "name": "steel-bottle-(b)",
      "url": "https://pokeapi.co/api/v2/item/2052/"
    },
    {
      "name": "silver-bottle",
      "url": "https://pokeapi.co/api/v2/item/2053/"
    },
    {
      "name": "barred-cup",
      "url": "https://pokeapi.co/api/v2/item/2054/"
    },
    {
      "name": "diamond-pattern-cup",
      "url": "https://pokeapi.co/api/v2/item/2055/"
    },
    {
      "name": "fire-pattern-cup",
      "url": "https://pokeapi.co/api/v2/item/2056/"
    },
    {
      "name": "pink-cup",
      "url": "https://pokeapi.co/api/v2/item/2057/"
    },
    {
      "name": "blue-cup",
      "url": "https://pokeapi.co/api/v2/item/2058/"
    },
    {
      "name": "yellow-cup",
      "url": "https://pokeapi.co/api/v2/item/2059/"
    },
    {
      "name": "pikachu-cup",
      "url": "https://pokeapi.co/api/v2/item/2060/"
    },
    {
      "name": "eevee-cup",
      "url": "https://pokeapi.co/api/v2/item/2061/"
    },
    {
      "name": "slowpoke-cup",
      "url": "https://pokeapi.co/api/v2/item/2062/"
    },
    {
      "name": "silver-cup",
      "url": "https://pokeapi.co/api/v2/item/2063/"
    },
    {
      "name": "exercise-ball",
      "url": "https://pokeapi.co/api/v2/item/2064/"
    },
    {
      "name": "plaid-tablecloth-(y)",
      "url": "https://pokeapi.co/api/v2/item/2065/"
    },
    {
      "name": "plaid-tablecloth-(b)",
      "url": "https://pokeapi.co/api/v2/item/2066/"
    },
    {
      "name": "plaid-tablecloth-(r)",
      "url": "https://pokeapi.co/api/v2/item/2067/"
    },
    {
      "name": "b&w-grass-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2068/"
    },
    {
      "name": "battle-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2069/"
    },
    {
      "name": "monstrous-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2070/"
    },
    {
      "name": "striped-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2071/"
    },
    {
      "name": "diamond-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2072/"
    },
    {
      "name": "polka-dot-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2073/"
    },
    {
      "name": "lilac-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2074/"
    },
    {
      "name": "mint-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2075/"
    },
    {
      "name": "peach-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2076/"
    },
    {
      "name": "yellow-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2077/"
    },
    {
      "name": "blue-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2078/"
    },
    {
      "name": "pink-tablecloth",
      "url": "https://pokeapi.co/api/v2/item/2079/"
    },
    {
      "name": "gold-bottle",
      "url": "https://pokeapi.co/api/v2/item/2080/"
    },
    {
      "name": "bronze-bottle",
      "url": "https://pokeapi.co/api/v2/item/2081/"
    },
    {
      "name": "gold-cup",
      "url": "https://pokeapi.co/api/v2/item/2082/"
    },
    {
      "name": "bronze-cup",
      "url": "https://pokeapi.co/api/v2/item/2083/"
    },
    {
      "name": "green-poké-ball-pick",
      "url": "https://pokeapi.co/api/v2/item/2084/"
    },
    {
      "name": "red-poké-ball-pick",
      "url": "https://pokeapi.co/api/v2/item/2085/"
    },
    {
      "name": "party-sparkler-pick",
      "url": "https://pokeapi.co/api/v2/item/2086/"
    },
    {
      "name": "heroic-sword-pick",
      "url": "https://pokeapi.co/api/v2/item/2087/"
    },
    {
      "name": "magical-star-pick",
      "url": "https://pokeapi.co/api/v2/item/2088/"
    },
    {
      "name": "magical-heart-pick",
      "url": "https://pokeapi.co/api/v2/item/2089/"
    },
    {
      "name": "parasol-pick",
      "url": "https://pokeapi.co/api/v2/item/2090/"
    },
    {
      "name": "blue-sky-flower-pick",
      "url": "https://pokeapi.co/api/v2/item/2091/"
    },
    {
      "name": "sunset-flower-pick",
      "url": "https://pokeapi.co/api/v2/item/2092/"
    },
    {
      "name": "sunrise-flower-pick",
      "url": "https://pokeapi.co/api/v2/item/2093/"
    },
    {
      "name": "blue-dish",
      "url": "https://pokeapi.co/api/v2/item/2094/"
    },
    {
      "name": "green-dish",
      "url": "https://pokeapi.co/api/v2/item/2095/"
    },
    {
      "name": "orange-dish",
      "url": "https://pokeapi.co/api/v2/item/2096/"
    },
    {
      "name": "red-dish",
      "url": "https://pokeapi.co/api/v2/item/2097/"
    },
    {
      "name": "white-dish",
      "url": "https://pokeapi.co/api/v2/item/2098/"
    },
    {
      "name": "yellow-dish",
      "url": "https://pokeapi.co/api/v2/item/2099/"
    },
    {
      "name": "black-augurite",
      "url": "https://pokeapi.co/api/v2/item/10001/"
    },
    {
      "name": "peat-block",
      "url": "https://pokeapi.co/api/v2/item/10002/"
    }
  ]
}
export const pokeAbility = {
  "count": 358,
  "next": null,
  "previous": null,
  "results": [
    {
      "name": "stench",
      "url": "https://pokeapi.co/api/v2/ability/1/"
    },
    {
      "name": "drizzle",
      "url": "https://pokeapi.co/api/v2/ability/2/"
    },
    {
      "name": "speed-boost",
      "url": "https://pokeapi.co/api/v2/ability/3/"
    },
    {
      "name": "battle-armor",
      "url": "https://pokeapi.co/api/v2/ability/4/"
    },
    {
      "name": "sturdy",
      "url": "https://pokeapi.co/api/v2/ability/5/"
    },
    {
      "name": "damp",
      "url": "https://pokeapi.co/api/v2/ability/6/"
    },
    {
      "name": "limber",
      "url": "https://pokeapi.co/api/v2/ability/7/"
    },
    {
      "name": "sand-veil",
      "url": "https://pokeapi.co/api/v2/ability/8/"
    },
    {
      "name": "static",
      "url": "https://pokeapi.co/api/v2/ability/9/"
    },
    {
      "name": "volt-absorb",
      "url": "https://pokeapi.co/api/v2/ability/10/"
    },
    {
      "name": "water-absorb",
      "url": "https://pokeapi.co/api/v2/ability/11/"
    },
    {
      "name": "oblivious",
      "url": "https://pokeapi.co/api/v2/ability/12/"
    },
    {
      "name": "cloud-nine",
      "url": "https://pokeapi.co/api/v2/ability/13/"
    },
    {
      "name": "compound-eyes",
      "url": "https://pokeapi.co/api/v2/ability/14/"
    },
    {
      "name": "insomnia",
      "url": "https://pokeapi.co/api/v2/ability/15/"
    },
    {
      "name": "color-change",
      "url": "https://pokeapi.co/api/v2/ability/16/"
    },
    {
      "name": "immunity",
      "url": "https://pokeapi.co/api/v2/ability/17/"
    },
    {
      "name": "flash-fire",
      "url": "https://pokeapi.co/api/v2/ability/18/"
    },
    {
      "name": "shield-dust",
      "url": "https://pokeapi.co/api/v2/ability/19/"
    },
    {
      "name": "own-tempo",
      "url": "https://pokeapi.co/api/v2/ability/20/"
    },
    {
      "name": "suction-cups",
      "url": "https://pokeapi.co/api/v2/ability/21/"
    },
    {
      "name": "intimidate",
      "url": "https://pokeapi.co/api/v2/ability/22/"
    },
    {
      "name": "shadow-tag",
      "url": "https://pokeapi.co/api/v2/ability/23/"
    },
    {
      "name": "rough-skin",
      "url": "https://pokeapi.co/api/v2/ability/24/"
    },
    {
      "name": "wonder-guard",
      "url": "https://pokeapi.co/api/v2/ability/25/"
    },
    {
      "name": "levitate",
      "url": "https://pokeapi.co/api/v2/ability/26/"
    },
    {
      "name": "effect-spore",
      "url": "https://pokeapi.co/api/v2/ability/27/"
    },
    {
      "name": "synchronize",
      "url": "https://pokeapi.co/api/v2/ability/28/"
    },
    {
      "name": "clear-body",
      "url": "https://pokeapi.co/api/v2/ability/29/"
    },
    {
      "name": "natural-cure",
      "url": "https://pokeapi.co/api/v2/ability/30/"
    },
    {
      "name": "lightning-rod",
      "url": "https://pokeapi.co/api/v2/ability/31/"
    },
    {
      "name": "serene-grace",
      "url": "https://pokeapi.co/api/v2/ability/32/"
    },
    {
      "name": "swift-swim",
      "url": "https://pokeapi.co/api/v2/ability/33/"
    },
    {
      "name": "chlorophyll",
      "url": "https://pokeapi.co/api/v2/ability/34/"
    },
    {
      "name": "illuminate",
      "url": "https://pokeapi.co/api/v2/ability/35/"
    },
    {
      "name": "trace",
      "url": "https://pokeapi.co/api/v2/ability/36/"
    },
    {
      "name": "huge-power",
      "url": "https://pokeapi.co/api/v2/ability/37/"
    },
    {
      "name": "poison-point",
      "url": "https://pokeapi.co/api/v2/ability/38/"
    },
    {
      "name": "inner-focus",
      "url": "https://pokeapi.co/api/v2/ability/39/"
    },
    {
      "name": "magma-armor",
      "url": "https://pokeapi.co/api/v2/ability/40/"
    },
    {
      "name": "water-veil",
      "url": "https://pokeapi.co/api/v2/ability/41/"
    },
    {
      "name": "magnet-pull",
      "url": "https://pokeapi.co/api/v2/ability/42/"
    },
    {
      "name": "soundproof",
      "url": "https://pokeapi.co/api/v2/ability/43/"
    },
    {
      "name": "rain-dish",
      "url": "https://pokeapi.co/api/v2/ability/44/"
    },
    {
      "name": "sand-stream",
      "url": "https://pokeapi.co/api/v2/ability/45/"
    },
    {
      "name": "pressure",
      "url": "https://pokeapi.co/api/v2/ability/46/"
    },
    {
      "name": "thick-fat",
      "url": "https://pokeapi.co/api/v2/ability/47/"
    },
    {
      "name": "early-bird",
      "url": "https://pokeapi.co/api/v2/ability/48/"
    },
    {
      "name": "flame-body",
      "url": "https://pokeapi.co/api/v2/ability/49/"
    },
    {
      "name": "run-away",
      "url": "https://pokeapi.co/api/v2/ability/50/"
    },
    {
      "name": "keen-eye",
      "url": "https://pokeapi.co/api/v2/ability/51/"
    },
    {
      "name": "hyper-cutter",
      "url": "https://pokeapi.co/api/v2/ability/52/"
    },
    {
      "name": "pickup",
      "url": "https://pokeapi.co/api/v2/ability/53/"
    },
    {
      "name": "truant",
      "url": "https://pokeapi.co/api/v2/ability/54/"
    },
    {
      "name": "hustle",
      "url": "https://pokeapi.co/api/v2/ability/55/"
    },
    {
      "name": "cute-charm",
      "url": "https://pokeapi.co/api/v2/ability/56/"
    },
    {
      "name": "plus",
      "url": "https://pokeapi.co/api/v2/ability/57/"
    },
    {
      "name": "minus",
      "url": "https://pokeapi.co/api/v2/ability/58/"
    },
    {
      "name": "forecast",
      "url": "https://pokeapi.co/api/v2/ability/59/"
    },
    {
      "name": "sticky-hold",
      "url": "https://pokeapi.co/api/v2/ability/60/"
    },
    {
      "name": "shed-skin",
      "url": "https://pokeapi.co/api/v2/ability/61/"
    },
    {
      "name": "guts",
      "url": "https://pokeapi.co/api/v2/ability/62/"
    },
    {
      "name": "marvel-scale",
      "url": "https://pokeapi.co/api/v2/ability/63/"
    },
    {
      "name": "liquid-ooze",
      "url": "https://pokeapi.co/api/v2/ability/64/"
    },
    {
      "name": "overgrow",
      "url": "https://pokeapi.co/api/v2/ability/65/"
    },
    {
      "name": "blaze",
      "url": "https://pokeapi.co/api/v2/ability/66/"
    },
    {
      "name": "torrent",
      "url": "https://pokeapi.co/api/v2/ability/67/"
    },
    {
      "name": "swarm",
      "url": "https://pokeapi.co/api/v2/ability/68/"
    },
    {
      "name": "rock-head",
      "url": "https://pokeapi.co/api/v2/ability/69/"
    },
    {
      "name": "drought",
      "url": "https://pokeapi.co/api/v2/ability/70/"
    },
    {
      "name": "arena-trap",
      "url": "https://pokeapi.co/api/v2/ability/71/"
    },
    {
      "name": "vital-spirit",
      "url": "https://pokeapi.co/api/v2/ability/72/"
    },
    {
      "name": "white-smoke",
      "url": "https://pokeapi.co/api/v2/ability/73/"
    },
    {
      "name": "pure-power",
      "url": "https://pokeapi.co/api/v2/ability/74/"
    },
    {
      "name": "shell-armor",
      "url": "https://pokeapi.co/api/v2/ability/75/"
    },
    {
      "name": "air-lock",
      "url": "https://pokeapi.co/api/v2/ability/76/"
    },
    {
      "name": "tangled-feet",
      "url": "https://pokeapi.co/api/v2/ability/77/"
    },
    {
      "name": "motor-drive",
      "url": "https://pokeapi.co/api/v2/ability/78/"
    },
    {
      "name": "rivalry",
      "url": "https://pokeapi.co/api/v2/ability/79/"
    },
    {
      "name": "steadfast",
      "url": "https://pokeapi.co/api/v2/ability/80/"
    },
    {
      "name": "snow-cloak",
      "url": "https://pokeapi.co/api/v2/ability/81/"
    },
    {
      "name": "gluttony",
      "url": "https://pokeapi.co/api/v2/ability/82/"
    },
    {
      "name": "anger-point",
      "url": "https://pokeapi.co/api/v2/ability/83/"
    },
    {
      "name": "unburden",
      "url": "https://pokeapi.co/api/v2/ability/84/"
    },
    {
      "name": "heatproof",
      "url": "https://pokeapi.co/api/v2/ability/85/"
    },
    {
      "name": "simple",
      "url": "https://pokeapi.co/api/v2/ability/86/"
    },
    {
      "name": "dry-skin",
      "url": "https://pokeapi.co/api/v2/ability/87/"
    },
    {
      "name": "download",
      "url": "https://pokeapi.co/api/v2/ability/88/"
    },
    {
      "name": "iron-fist",
      "url": "https://pokeapi.co/api/v2/ability/89/"
    },
    {
      "name": "poison-heal",
      "url": "https://pokeapi.co/api/v2/ability/90/"
    },
    {
      "name": "adaptability",
      "url": "https://pokeapi.co/api/v2/ability/91/"
    },
    {
      "name": "skill-link",
      "url": "https://pokeapi.co/api/v2/ability/92/"
    },
    {
      "name": "hydration",
      "url": "https://pokeapi.co/api/v2/ability/93/"
    },
    {
      "name": "solar-power",
      "url": "https://pokeapi.co/api/v2/ability/94/"
    },
    {
      "name": "quick-feet",
      "url": "https://pokeapi.co/api/v2/ability/95/"
    },
    {
      "name": "normalize",
      "url": "https://pokeapi.co/api/v2/ability/96/"
    },
    {
      "name": "sniper",
      "url": "https://pokeapi.co/api/v2/ability/97/"
    },
    {
      "name": "magic-guard",
      "url": "https://pokeapi.co/api/v2/ability/98/"
    },
    {
      "name": "no-guard",
      "url": "https://pokeapi.co/api/v2/ability/99/"
    },
    {
      "name": "stall",
      "url": "https://pokeapi.co/api/v2/ability/100/"
    },
    {
      "name": "technician",
      "url": "https://pokeapi.co/api/v2/ability/101/"
    },
    {
      "name": "leaf-guard",
      "url": "https://pokeapi.co/api/v2/ability/102/"
    },
    {
      "name": "klutz",
      "url": "https://pokeapi.co/api/v2/ability/103/"
    },
    {
      "name": "mold-breaker",
      "url": "https://pokeapi.co/api/v2/ability/104/"
    },
    {
      "name": "super-luck",
      "url": "https://pokeapi.co/api/v2/ability/105/"
    },
    {
      "name": "aftermath",
      "url": "https://pokeapi.co/api/v2/ability/106/"
    },
    {
      "name": "anticipation",
      "url": "https://pokeapi.co/api/v2/ability/107/"
    },
    {
      "name": "forewarn",
      "url": "https://pokeapi.co/api/v2/ability/108/"
    },
    {
      "name": "unaware",
      "url": "https://pokeapi.co/api/v2/ability/109/"
    },
    {
      "name": "tinted-lens",
      "url": "https://pokeapi.co/api/v2/ability/110/"
    },
    {
      "name": "filter",
      "url": "https://pokeapi.co/api/v2/ability/111/"
    },
    {
      "name": "slow-start",
      "url": "https://pokeapi.co/api/v2/ability/112/"
    },
    {
      "name": "scrappy",
      "url": "https://pokeapi.co/api/v2/ability/113/"
    },
    {
      "name": "storm-drain",
      "url": "https://pokeapi.co/api/v2/ability/114/"
    },
    {
      "name": "ice-body",
      "url": "https://pokeapi.co/api/v2/ability/115/"
    },
    {
      "name": "solid-rock",
      "url": "https://pokeapi.co/api/v2/ability/116/"
    },
    {
      "name": "snow-warning",
      "url": "https://pokeapi.co/api/v2/ability/117/"
    },
    {
      "name": "honey-gather",
      "url": "https://pokeapi.co/api/v2/ability/118/"
    },
    {
      "name": "frisk",
      "url": "https://pokeapi.co/api/v2/ability/119/"
    },
    {
      "name": "reckless",
      "url": "https://pokeapi.co/api/v2/ability/120/"
    },
    {
      "name": "multitype",
      "url": "https://pokeapi.co/api/v2/ability/121/"
    },
    {
      "name": "flower-gift",
      "url": "https://pokeapi.co/api/v2/ability/122/"
    },
    {
      "name": "bad-dreams",
      "url": "https://pokeapi.co/api/v2/ability/123/"
    },
    {
      "name": "pickpocket",
      "url": "https://pokeapi.co/api/v2/ability/124/"
    },
    {
      "name": "sheer-force",
      "url": "https://pokeapi.co/api/v2/ability/125/"
    },
    {
      "name": "contrary",
      "url": "https://pokeapi.co/api/v2/ability/126/"
    },
    {
      "name": "unnerve",
      "url": "https://pokeapi.co/api/v2/ability/127/"
    },
    {
      "name": "defiant",
      "url": "https://pokeapi.co/api/v2/ability/128/"
    },
    {
      "name": "defeatist",
      "url": "https://pokeapi.co/api/v2/ability/129/"
    },
    {
      "name": "cursed-body",
      "url": "https://pokeapi.co/api/v2/ability/130/"
    },
    {
      "name": "healer",
      "url": "https://pokeapi.co/api/v2/ability/131/"
    },
    {
      "name": "friend-guard",
      "url": "https://pokeapi.co/api/v2/ability/132/"
    },
    {
      "name": "weak-armor",
      "url": "https://pokeapi.co/api/v2/ability/133/"
    },
    {
      "name": "heavy-metal",
      "url": "https://pokeapi.co/api/v2/ability/134/"
    },
    {
      "name": "light-metal",
      "url": "https://pokeapi.co/api/v2/ability/135/"
    },
    {
      "name": "multiscale",
      "url": "https://pokeapi.co/api/v2/ability/136/"
    },
    {
      "name": "toxic-boost",
      "url": "https://pokeapi.co/api/v2/ability/137/"
    },
    {
      "name": "flare-boost",
      "url": "https://pokeapi.co/api/v2/ability/138/"
    },
    {
      "name": "harvest",
      "url": "https://pokeapi.co/api/v2/ability/139/"
    },
    {
      "name": "telepathy",
      "url": "https://pokeapi.co/api/v2/ability/140/"
    },
    {
      "name": "moody",
      "url": "https://pokeapi.co/api/v2/ability/141/"
    },
    {
      "name": "overcoat",
      "url": "https://pokeapi.co/api/v2/ability/142/"
    },
    {
      "name": "poison-touch",
      "url": "https://pokeapi.co/api/v2/ability/143/"
    },
    {
      "name": "regenerator",
      "url": "https://pokeapi.co/api/v2/ability/144/"
    },
    {
      "name": "big-pecks",
      "url": "https://pokeapi.co/api/v2/ability/145/"
    },
    {
      "name": "sand-rush",
      "url": "https://pokeapi.co/api/v2/ability/146/"
    },
    {
      "name": "wonder-skin",
      "url": "https://pokeapi.co/api/v2/ability/147/"
    },
    {
      "name": "analytic",
      "url": "https://pokeapi.co/api/v2/ability/148/"
    },
    {
      "name": "illusion",
      "url": "https://pokeapi.co/api/v2/ability/149/"
    },
    {
      "name": "imposter",
      "url": "https://pokeapi.co/api/v2/ability/150/"
    },
    {
      "name": "infiltrator",
      "url": "https://pokeapi.co/api/v2/ability/151/"
    },
    {
      "name": "mummy",
      "url": "https://pokeapi.co/api/v2/ability/152/"
    },
    {
      "name": "moxie",
      "url": "https://pokeapi.co/api/v2/ability/153/"
    },
    {
      "name": "justified",
      "url": "https://pokeapi.co/api/v2/ability/154/"
    },
    {
      "name": "rattled",
      "url": "https://pokeapi.co/api/v2/ability/155/"
    },
    {
      "name": "magic-bounce",
      "url": "https://pokeapi.co/api/v2/ability/156/"
    },
    {
      "name": "sap-sipper",
      "url": "https://pokeapi.co/api/v2/ability/157/"
    },
    {
      "name": "prankster",
      "url": "https://pokeapi.co/api/v2/ability/158/"
    },
    {
      "name": "sand-force",
      "url": "https://pokeapi.co/api/v2/ability/159/"
    },
    {
      "name": "iron-barbs",
      "url": "https://pokeapi.co/api/v2/ability/160/"
    },
    {
      "name": "zen-mode",
      "url": "https://pokeapi.co/api/v2/ability/161/"
    },
    {
      "name": "victory-star",
      "url": "https://pokeapi.co/api/v2/ability/162/"
    },
    {
      "name": "turboblaze",
      "url": "https://pokeapi.co/api/v2/ability/163/"
    },
    {
      "name": "teravolt",
      "url": "https://pokeapi.co/api/v2/ability/164/"
    },
    {
      "name": "aroma-veil",
      "url": "https://pokeapi.co/api/v2/ability/165/"
    },
    {
      "name": "flower-veil",
      "url": "https://pokeapi.co/api/v2/ability/166/"
    },
    {
      "name": "cheek-pouch",
      "url": "https://pokeapi.co/api/v2/ability/167/"
    },
    {
      "name": "protean",
      "url": "https://pokeapi.co/api/v2/ability/168/"
    },
    {
      "name": "fur-coat",
      "url": "https://pokeapi.co/api/v2/ability/169/"
    },
    {
      "name": "magician",
      "url": "https://pokeapi.co/api/v2/ability/170/"
    },
    {
      "name": "bulletproof",
      "url": "https://pokeapi.co/api/v2/ability/171/"
    },
    {
      "name": "competitive",
      "url": "https://pokeapi.co/api/v2/ability/172/"
    },
    {
      "name": "strong-jaw",
      "url": "https://pokeapi.co/api/v2/ability/173/"
    },
    {
      "name": "refrigerate",
      "url": "https://pokeapi.co/api/v2/ability/174/"
    },
    {
      "name": "sweet-veil",
      "url": "https://pokeapi.co/api/v2/ability/175/"
    },
    {
      "name": "stance-change",
      "url": "https://pokeapi.co/api/v2/ability/176/"
    },
    {
      "name": "gale-wings",
      "url": "https://pokeapi.co/api/v2/ability/177/"
    },
    {
      "name": "mega-launcher",
      "url": "https://pokeapi.co/api/v2/ability/178/"
    },
    {
      "name": "grass-pelt",
      "url": "https://pokeapi.co/api/v2/ability/179/"
    },
    {
      "name": "symbiosis",
      "url": "https://pokeapi.co/api/v2/ability/180/"
    },
    {
      "name": "tough-claws",
      "url": "https://pokeapi.co/api/v2/ability/181/"
    },
    {
      "name": "pixilate",
      "url": "https://pokeapi.co/api/v2/ability/182/"
    },
    {
      "name": "gooey",
      "url": "https://pokeapi.co/api/v2/ability/183/"
    },
    {
      "name": "aerilate",
      "url": "https://pokeapi.co/api/v2/ability/184/"
    },
    {
      "name": "parental-bond",
      "url": "https://pokeapi.co/api/v2/ability/185/"
    },
    {
      "name": "dark-aura",
      "url": "https://pokeapi.co/api/v2/ability/186/"
    },
    {
      "name": "fairy-aura",
      "url": "https://pokeapi.co/api/v2/ability/187/"
    },
    {
      "name": "aura-break",
      "url": "https://pokeapi.co/api/v2/ability/188/"
    },
    {
      "name": "primordial-sea",
      "url": "https://pokeapi.co/api/v2/ability/189/"
    },
    {
      "name": "desolate-land",
      "url": "https://pokeapi.co/api/v2/ability/190/"
    },
    {
      "name": "delta-stream",
      "url": "https://pokeapi.co/api/v2/ability/191/"
    },
    {
      "name": "stamina",
      "url": "https://pokeapi.co/api/v2/ability/192/"
    },
    {
      "name": "wimp-out",
      "url": "https://pokeapi.co/api/v2/ability/193/"
    },
    {
      "name": "emergency-exit",
      "url": "https://pokeapi.co/api/v2/ability/194/"
    },
    {
      "name": "water-compaction",
      "url": "https://pokeapi.co/api/v2/ability/195/"
    },
    {
      "name": "merciless",
      "url": "https://pokeapi.co/api/v2/ability/196/"
    },
    {
      "name": "shields-down",
      "url": "https://pokeapi.co/api/v2/ability/197/"
    },
    {
      "name": "stakeout",
      "url": "https://pokeapi.co/api/v2/ability/198/"
    },
    {
      "name": "water-bubble",
      "url": "https://pokeapi.co/api/v2/ability/199/"
    },
    {
      "name": "steelworker",
      "url": "https://pokeapi.co/api/v2/ability/200/"
    },
    {
      "name": "berserk",
      "url": "https://pokeapi.co/api/v2/ability/201/"
    },
    {
      "name": "slush-rush",
      "url": "https://pokeapi.co/api/v2/ability/202/"
    },
    {
      "name": "long-reach",
      "url": "https://pokeapi.co/api/v2/ability/203/"
    },
    {
      "name": "liquid-voice",
      "url": "https://pokeapi.co/api/v2/ability/204/"
    },
    {
      "name": "triage",
      "url": "https://pokeapi.co/api/v2/ability/205/"
    },
    {
      "name": "galvanize",
      "url": "https://pokeapi.co/api/v2/ability/206/"
    },
    {
      "name": "surge-surfer",
      "url": "https://pokeapi.co/api/v2/ability/207/"
    },
    {
      "name": "schooling",
      "url": "https://pokeapi.co/api/v2/ability/208/"
    },
    {
      "name": "disguise",
      "url": "https://pokeapi.co/api/v2/ability/209/"
    },
    {
      "name": "battle-bond",
      "url": "https://pokeapi.co/api/v2/ability/210/"
    },
    {
      "name": "power-construct",
      "url": "https://pokeapi.co/api/v2/ability/211/"
    },
    {
      "name": "corrosion",
      "url": "https://pokeapi.co/api/v2/ability/212/"
    },
    {
      "name": "comatose",
      "url": "https://pokeapi.co/api/v2/ability/213/"
    },
    {
      "name": "queenly-majesty",
      "url": "https://pokeapi.co/api/v2/ability/214/"
    },
    {
      "name": "innards-out",
      "url": "https://pokeapi.co/api/v2/ability/215/"
    },
    {
      "name": "dancer",
      "url": "https://pokeapi.co/api/v2/ability/216/"
    },
    {
      "name": "battery",
      "url": "https://pokeapi.co/api/v2/ability/217/"
    },
    {
      "name": "fluffy",
      "url": "https://pokeapi.co/api/v2/ability/218/"
    },
    {
      "name": "dazzling",
      "url": "https://pokeapi.co/api/v2/ability/219/"
    },
    {
      "name": "soul-heart",
      "url": "https://pokeapi.co/api/v2/ability/220/"
    },
    {
      "name": "tangling-hair",
      "url": "https://pokeapi.co/api/v2/ability/221/"
    },
    {
      "name": "receiver",
      "url": "https://pokeapi.co/api/v2/ability/222/"
    },
    {
      "name": "power-of-alchemy",
      "url": "https://pokeapi.co/api/v2/ability/223/"
    },
    {
      "name": "beast-boost",
      "url": "https://pokeapi.co/api/v2/ability/224/"
    },
    {
      "name": "rks-system",
      "url": "https://pokeapi.co/api/v2/ability/225/"
    },
    {
      "name": "electric-surge",
      "url": "https://pokeapi.co/api/v2/ability/226/"
    },
    {
      "name": "psychic-surge",
      "url": "https://pokeapi.co/api/v2/ability/227/"
    },
    {
      "name": "misty-surge",
      "url": "https://pokeapi.co/api/v2/ability/228/"
    },
    {
      "name": "grassy-surge",
      "url": "https://pokeapi.co/api/v2/ability/229/"
    },
    {
      "name": "full-metal-body",
      "url": "https://pokeapi.co/api/v2/ability/230/"
    },
    {
      "name": "shadow-shield",
      "url": "https://pokeapi.co/api/v2/ability/231/"
    },
    {
      "name": "prism-armor",
      "url": "https://pokeapi.co/api/v2/ability/232/"
    },
    {
      "name": "neuroforce",
      "url": "https://pokeapi.co/api/v2/ability/233/"
    },
    {
      "name": "intrepid-sword",
      "url": "https://pokeapi.co/api/v2/ability/234/"
    },
    {
      "name": "dauntless-shield",
      "url": "https://pokeapi.co/api/v2/ability/235/"
    },
    {
      "name": "libero",
      "url": "https://pokeapi.co/api/v2/ability/236/"
    },
    {
      "name": "ball-fetch",
      "url": "https://pokeapi.co/api/v2/ability/237/"
    },
    {
      "name": "cotton-down",
      "url": "https://pokeapi.co/api/v2/ability/238/"
    },
    {
      "name": "propeller-tail",
      "url": "https://pokeapi.co/api/v2/ability/239/"
    },
    {
      "name": "mirror-armor",
      "url": "https://pokeapi.co/api/v2/ability/240/"
    },
    {
      "name": "gulp-missile",
      "url": "https://pokeapi.co/api/v2/ability/241/"
    },
    {
      "name": "stalwart",
      "url": "https://pokeapi.co/api/v2/ability/242/"
    },
    {
      "name": "steam-engine",
      "url": "https://pokeapi.co/api/v2/ability/243/"
    },
    {
      "name": "punk-rock",
      "url": "https://pokeapi.co/api/v2/ability/244/"
    },
    {
      "name": "sand-spit",
      "url": "https://pokeapi.co/api/v2/ability/245/"
    },
    {
      "name": "ice-scales",
      "url": "https://pokeapi.co/api/v2/ability/246/"
    },
    {
      "name": "ripen",
      "url": "https://pokeapi.co/api/v2/ability/247/"
    },
    {
      "name": "ice-face",
      "url": "https://pokeapi.co/api/v2/ability/248/"
    },
    {
      "name": "power-spot",
      "url": "https://pokeapi.co/api/v2/ability/249/"
    },
    {
      "name": "mimicry",
      "url": "https://pokeapi.co/api/v2/ability/250/"
    },
    {
      "name": "screen-cleaner",
      "url": "https://pokeapi.co/api/v2/ability/251/"
    },
    {
      "name": "steely-spirit",
      "url": "https://pokeapi.co/api/v2/ability/252/"
    },
    {
      "name": "perish-body",
      "url": "https://pokeapi.co/api/v2/ability/253/"
    },
    {
      "name": "wandering-spirit",
      "url": "https://pokeapi.co/api/v2/ability/254/"
    },
    {
      "name": "gorilla-tactics",
      "url": "https://pokeapi.co/api/v2/ability/255/"
    },
    {
      "name": "neutralizing-gas",
      "url": "https://pokeapi.co/api/v2/ability/256/"
    },
    {
      "name": "pastel-veil",
      "url": "https://pokeapi.co/api/v2/ability/257/"
    },
    {
      "name": "hunger-switch",
      "url": "https://pokeapi.co/api/v2/ability/258/"
    },
    {
      "name": "quick-draw",
      "url": "https://pokeapi.co/api/v2/ability/259/"
    },
    {
      "name": "unseen-fist",
      "url": "https://pokeapi.co/api/v2/ability/260/"
    },
    {
      "name": "curious-medicine",
      "url": "https://pokeapi.co/api/v2/ability/261/"
    },
    {
      "name": "transistor",
      "url": "https://pokeapi.co/api/v2/ability/262/"
    },
    {
      "name": "dragons-maw",
      "url": "https://pokeapi.co/api/v2/ability/263/"
    },
    {
      "name": "chilling-neigh",
      "url": "https://pokeapi.co/api/v2/ability/264/"
    },
    {
      "name": "grim-neigh",
      "url": "https://pokeapi.co/api/v2/ability/265/"
    },
    {
      "name": "as-one-glastrier",
      "url": "https://pokeapi.co/api/v2/ability/266/"
    },
    {
      "name": "as-one-spectrier",
      "url": "https://pokeapi.co/api/v2/ability/267/"
    },
    {
      "name": "lingering-aroma",
      "url": "https://pokeapi.co/api/v2/ability/268/"
    },
    {
      "name": "seed-sower",
      "url": "https://pokeapi.co/api/v2/ability/269/"
    },
    {
      "name": "thermal-exchange",
      "url": "https://pokeapi.co/api/v2/ability/270/"
    },
    {
      "name": "anger-shell",
      "url": "https://pokeapi.co/api/v2/ability/271/"
    },
    {
      "name": "purifying-salt",
      "url": "https://pokeapi.co/api/v2/ability/272/"
    },
    {
      "name": "well-baked-body",
      "url": "https://pokeapi.co/api/v2/ability/273/"
    },
    {
      "name": "wind-rider",
      "url": "https://pokeapi.co/api/v2/ability/274/"
    },
    {
      "name": "guard-dog",
      "url": "https://pokeapi.co/api/v2/ability/275/"
    },
    {
      "name": "rocky-payload",
      "url": "https://pokeapi.co/api/v2/ability/276/"
    },
    {
      "name": "wind-power",
      "url": "https://pokeapi.co/api/v2/ability/277/"
    },
    {
      "name": "zero-to-hero",
      "url": "https://pokeapi.co/api/v2/ability/278/"
    },
    {
      "name": "commander",
      "url": "https://pokeapi.co/api/v2/ability/279/"
    },
    {
      "name": "electromorphosis",
      "url": "https://pokeapi.co/api/v2/ability/280/"
    },
    {
      "name": "protosynthesis",
      "url": "https://pokeapi.co/api/v2/ability/281/"
    },
    {
      "name": "quark-drive",
      "url": "https://pokeapi.co/api/v2/ability/282/"
    },
    {
      "name": "good-as-gold",
      "url": "https://pokeapi.co/api/v2/ability/283/"
    },
    {
      "name": "vessel-of-ruin",
      "url": "https://pokeapi.co/api/v2/ability/284/"
    },
    {
      "name": "sword-of-ruin",
      "url": "https://pokeapi.co/api/v2/ability/285/"
    },
    {
      "name": "tablets-of-ruin",
      "url": "https://pokeapi.co/api/v2/ability/286/"
    },
    {
      "name": "beads-of-ruin",
      "url": "https://pokeapi.co/api/v2/ability/287/"
    },
    {
      "name": "orichalcum-pulse",
      "url": "https://pokeapi.co/api/v2/ability/288/"
    },
    {
      "name": "hadron-engine",
      "url": "https://pokeapi.co/api/v2/ability/289/"
    },
    {
      "name": "opportunist",
      "url": "https://pokeapi.co/api/v2/ability/290/"
    },
    {
      "name": "cud-chew",
      "url": "https://pokeapi.co/api/v2/ability/291/"
    },
    {
      "name": "sharpness",
      "url": "https://pokeapi.co/api/v2/ability/292/"
    },
    {
      "name": "supreme-overlord",
      "url": "https://pokeapi.co/api/v2/ability/293/"
    },
    {
      "name": "costar",
      "url": "https://pokeapi.co/api/v2/ability/294/"
    },
    {
      "name": "toxic-debris",
      "url": "https://pokeapi.co/api/v2/ability/295/"
    },
    {
      "name": "armor-tail",
      "url": "https://pokeapi.co/api/v2/ability/296/"
    },
    {
      "name": "earth-eater",
      "url": "https://pokeapi.co/api/v2/ability/297/"
    },
    {
      "name": "mycelium-might",
      "url": "https://pokeapi.co/api/v2/ability/298/"
    },
    {
      "name": "mountaineer",
      "url": "https://pokeapi.co/api/v2/ability/10001/"
    },
    {
      "name": "wave-rider",
      "url": "https://pokeapi.co/api/v2/ability/10002/"
    },
    {
      "name": "skater",
      "url": "https://pokeapi.co/api/v2/ability/10003/"
    },
    {
      "name": "thrust",
      "url": "https://pokeapi.co/api/v2/ability/10004/"
    },
    {
      "name": "perception",
      "url": "https://pokeapi.co/api/v2/ability/10005/"
    },
    {
      "name": "parry",
      "url": "https://pokeapi.co/api/v2/ability/10006/"
    },
    {
      "name": "instinct",
      "url": "https://pokeapi.co/api/v2/ability/10007/"
    },
    {
      "name": "dodge",
      "url": "https://pokeapi.co/api/v2/ability/10008/"
    },
    {
      "name": "jagged-edge",
      "url": "https://pokeapi.co/api/v2/ability/10009/"
    },
    {
      "name": "frostbite",
      "url": "https://pokeapi.co/api/v2/ability/10010/"
    },
    {
      "name": "tenacity",
      "url": "https://pokeapi.co/api/v2/ability/10011/"
    },
    {
      "name": "pride",
      "url": "https://pokeapi.co/api/v2/ability/10012/"
    },
    {
      "name": "deep-sleep",
      "url": "https://pokeapi.co/api/v2/ability/10013/"
    },
    {
      "name": "power-nap",
      "url": "https://pokeapi.co/api/v2/ability/10014/"
    },
    {
      "name": "spirit",
      "url": "https://pokeapi.co/api/v2/ability/10015/"
    },
    {
      "name": "warm-blanket",
      "url": "https://pokeapi.co/api/v2/ability/10016/"
    },
    {
      "name": "gulp",
      "url": "https://pokeapi.co/api/v2/ability/10017/"
    },
    {
      "name": "herbivore",
      "url": "https://pokeapi.co/api/v2/ability/10018/"
    },
    {
      "name": "sandpit",
      "url": "https://pokeapi.co/api/v2/ability/10019/"
    },
    {
      "name": "hot-blooded",
      "url": "https://pokeapi.co/api/v2/ability/10020/"
    },
    {
      "name": "medic",
      "url": "https://pokeapi.co/api/v2/ability/10021/"
    },
    {
      "name": "life-force",
      "url": "https://pokeapi.co/api/v2/ability/10022/"
    },
    {
      "name": "lunchbox",
      "url": "https://pokeapi.co/api/v2/ability/10023/"
    },
    {
      "name": "nurse",
      "url": "https://pokeapi.co/api/v2/ability/10024/"
    },
    {
      "name": "melee",
      "url": "https://pokeapi.co/api/v2/ability/10025/"
    },
    {
      "name": "sponge",
      "url": "https://pokeapi.co/api/v2/ability/10026/"
    },
    {
      "name": "bodyguard",
      "url": "https://pokeapi.co/api/v2/ability/10027/"
    },
    {
      "name": "hero",
      "url": "https://pokeapi.co/api/v2/ability/10028/"
    },
    {
      "name": "last-bastion",
      "url": "https://pokeapi.co/api/v2/ability/10029/"
    },
    {
      "name": "stealth",
      "url": "https://pokeapi.co/api/v2/ability/10030/"
    },
    {
      "name": "vanguard",
      "url": "https://pokeapi.co/api/v2/ability/10031/"
    },
    {
      "name": "nomad",
      "url": "https://pokeapi.co/api/v2/ability/10032/"
    },
    {
      "name": "sequence",
      "url": "https://pokeapi.co/api/v2/ability/10033/"
    },
    {
      "name": "grass-cloak",
      "url": "https://pokeapi.co/api/v2/ability/10034/"
    },
    {
      "name": "celebrate",
      "url": "https://pokeapi.co/api/v2/ability/10035/"
    },
    {
      "name": "lullaby",
      "url": "https://pokeapi.co/api/v2/ability/10036/"
    },
    {
      "name": "calming",
      "url": "https://pokeapi.co/api/v2/ability/10037/"
    },
    {
      "name": "daze",
      "url": "https://pokeapi.co/api/v2/ability/10038/"
    },
    {
      "name": "frighten",
      "url": "https://pokeapi.co/api/v2/ability/10039/"
    },
    {
      "name": "interference",
      "url": "https://pokeapi.co/api/v2/ability/10040/"
    },
    {
      "name": "mood-maker",
      "url": "https://pokeapi.co/api/v2/ability/10041/"
    },
    {
      "name": "confidence",
      "url": "https://pokeapi.co/api/v2/ability/10042/"
    },
    {
      "name": "fortune",
      "url": "https://pokeapi.co/api/v2/ability/10043/"
    },
    {
      "name": "bonanza",
      "url": "https://pokeapi.co/api/v2/ability/10044/"
    },
    {
      "name": "explode",
      "url": "https://pokeapi.co/api/v2/ability/10045/"
    },
    {
      "name": "omnipotent",
      "url": "https://pokeapi.co/api/v2/ability/10046/"
    },
    {
      "name": "share",
      "url": "https://pokeapi.co/api/v2/ability/10047/"
    },
    {
      "name": "black-hole",
      "url": "https://pokeapi.co/api/v2/ability/10048/"
    },
    {
      "name": "shadow-dash",
      "url": "https://pokeapi.co/api/v2/ability/10049/"
    },
    {
      "name": "sprint",
      "url": "https://pokeapi.co/api/v2/ability/10050/"
    },
    {
      "name": "disgust",
      "url": "https://pokeapi.co/api/v2/ability/10051/"
    },
    {
      "name": "high-rise",
      "url": "https://pokeapi.co/api/v2/ability/10052/"
    },
    {
      "name": "climber",
      "url": "https://pokeapi.co/api/v2/ability/10053/"
    },
    {
      "name": "flame-boost",
      "url": "https://pokeapi.co/api/v2/ability/10054/"
    },
    {
      "name": "aqua-boost",
      "url": "https://pokeapi.co/api/v2/ability/10055/"
    },
    {
      "name": "run-up",
      "url": "https://pokeapi.co/api/v2/ability/10056/"
    },
    {
      "name": "conqueror",
      "url": "https://pokeapi.co/api/v2/ability/10057/"
    },
    {
      "name": "shackle",
      "url": "https://pokeapi.co/api/v2/ability/10058/"
    },
    {
      "name": "decoy",
      "url": "https://pokeapi.co/api/v2/ability/10059/"
    },
    {
      "name": "shield",
      "url": "https://pokeapi.co/api/v2/ability/10060/"
    }
  ]
}